const { on, off } = require("./toolbox/linux_core")
class General {
  constructor() {
    this.event_emitter_callback = {};
  }

  dtKStrToJson(str) {
    try {
      const byteLength = str.length / 2;
      if (byteLength === 0) return {};
      let byteArr = [];
      for (let i = 0; i < byteLength; i++) {
        const b = this.hexToInt(str.substring(i * 2, i * 2 + 2));
        byteArr = [...byteArr, b];
      }
      let checksum, checksum_cal;
      if (byteArr[0] === 0xfa) {
        checksum = byteArr[byteArr.length - 1].toString(16).padStart(2, "0");
        checksum_cal = this.getChecksum_dtk(str.substring(0, str.length - 2));
      } else if (byteArr[0] === 0x41 && byteArr[1] === 0x54) {
        //255 do not have checksum, so length for checking
        checksum = byteArr[4];
        checksum_cal = byteLength - 5;
      } else {
        checksum = byteArr[byteArr.length - 2].toString(16).padStart(2, "0");
        checksum_cal = this.getChecksum_dtk(str.substring(0, str.length - 4));
      }
      if (checksum_cal !== checksum)
        return {
          commandCode: (byteArr[4] << 8) + byteArr[5],
          dtkAdd: str.substring(4, 8),
          error: `checksum not match, checksum: ${checksum} checksum_cal: ${checksum_cal}`,
        };
      let commandCode = (byteArr[4] << 8) + byteArr[5];
      let dtkAdd = str.substring(4, 8);
      if (byteArr[0] === 0xfd || byteArr[0] === 0xed) {
        // Gateway -> Devices
      } else if (byteArr[0] === 0xf0) {
        //Devices -> Gateway
      } else if (byteArr[0] === 0xfa) {
        //dtk internal command
        commandCode = (byteArr[0] << 8) + byteArr[3];
      } else if (byteArr[0] === 0x41 && byteArr[1] === 0x54) {
        //255
        if (byteArr[2] === 0x43 && byteArr[3] === 0x49)
          commandCode = (byteArr[2] << 8) + byteArr[3];
        else commandCode = (byteArr[2] << 8) + byteArr[5];
      } else {
        return { commandCode: 0, dtkAdd: 0 };
      }
      let cmd = { commandCode, dtkAdd, uploadProtocol: commandCode };
      switch (commandCode) {
        // F0 head, Light to Gateway: 0400-05fc
        // F0 head, Sensor to Gateway: 0800-09fc
        // F0 head, DaliCtl to Gateway: 0c00-0dfc
        case 0xfa01: {
          // decode dtk basic information string from dtk device
          cmd.loraDeviceType = byteArr[7];
          cmd.hardwareVersion = byteArr[8];
          cmd.commandName = "DTKBasicInfo";
          break;
        } //dtk report basic information string
        case 0xfa02: {
          cmd.dtkInternalAdd = `${byteArr[26]
            .toString(16)
            .padStart(2, 0)}${byteArr[28].toString(16).padStart(2, 0)}`;
          cmd.dtkType = byteArr[5];
          cmd.dtkPanID = (byteArr[6] << 8) + byteArr[7];
          cmd.dtkChannel = byteArr[8];
          cmd.dtkTransferMode = byteArr[9];
          cmd.dtkAdd = `${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11]
            .toString(16)
            .padStart(2, 0)}`;
          cmd.reservedValue1 = (byteArr[12] << 8) + byteArr[13];
          cmd.baudRate = byteArr[14];
          cmd.dataBit = byteArr[15];
          cmd.stopBit = byteArr[16];
          cmd.parityBit = byteArr[17];
          cmd.reservedValue2 = (byteArr[18] << 8) + byteArr[19];
          cmd.unNamed20 = byteArr[20];
          cmd.macAddress = `${byteArr[21]
            .toString(16)
            .padStart(2, 0)}${byteArr[22]
              .toString(16)
              .padStart(2, 0)}${byteArr[23]
                .toString(16)
                .padStart(2, 0)}${byteArr[24]
                  .toString(16)
                  .padStart(2, 0)}${byteArr[25]
                    .toString(16)
                    .padStart(2, 0)}${byteArr[26]
                      .toString(16)
                      .padStart(2, 0)}${byteArr[27]
                        .toString(16)
                        .padStart(2, 0)}${byteArr[28].toString(16).padStart(2, 0)}`;
          cmd.slave_dtkType = byteArr[29];
          cmd.slave_dtkPanID = (byteArr[30] << 8) + byteArr[31];
          cmd.slave_dtkChannel = byteArr[32];
          cmd.slave_dtkTransferMode = byteArr[33];
          cmd.slave_dtkAdd = (byteArr[34] << 8) + byteArr[35];
          cmd.slave_reservedValue1 = (byteArr[36] << 8) + byteArr[37];
          cmd.slave_baudRate = byteArr[38];
          cmd.slave_dataBit = byteArr[39];
          cmd.slave_stopBit = byteArr[40];
          cmd.slave_parityBit = byteArr[41];
          cmd.slave_reservedValue2 = (byteArr[42] << 8) + byteArr[43];
          cmd.slave_unNamed44 = byteArr[44];
          cmd.reservedValue3 = byteArr[45];
          cmd.encoded = byteArr[46];
          cmd.password = `${byteArr[47].toString(16).padStart(2, 0)}${byteArr[48]
            .toString(16)
            .padStart(2, 0)}${byteArr[49]
              .toString(16)
              .padStart(2, 0)}${byteArr[50].toString(16).padStart(2, 0)}`;
          cmd.loraParameter = byteArr[51];
          cmd.commandName = "DTKDeviceInfo";
          break;
        } // decode dtk information string from dtk device
        case 0xfa03: {
          if (byteArr[2] == 0x0a) cmd.commandName = "writeDTKDeviceInfoSuccess";
          else if (byteArr[2] == 0x0b) cmd.commandName = "writeDTKDeviceInfoFail";
          else if (byteArr[2] == 0x0c)
            cmd.commandName = "writeDTKDeviceInfoFail(dataNotValid)";
          break;
        } // decode dtk information string from dtk device
        case 0xfa04: {
          // response from restart dtk device command
          if (byteArr[2] == 0x0a) cmd.commandName = "restartDTKSuccess";
          break;
        } // dtk restart success
        case 0xfa06: {
          // response from read dtk infomation command
          cmd.dtkInternalAdd = str.substring(8, 12);
          cmd.dtkType = byteArr[6];
          cmd.dtkPanID = str.substring(14, 18);
          cmd.dtkChannel = byteArr[9];
          cmd.dtkTransferMode = byteArr[10];
          cmd.dtkAdd = str.substring(22, 26);
          cmd.baudRate = byteArr[13];
          cmd.dataBit = byteArr[14];
          cmd.stopBit = byteArr[15];
          cmd.parityBit = byteArr[16];
          cmd.loraParameter = byteArr[17];
          cmd.commandName = "readOtherDTKInfo";
          break;
        } // dtk report read other dtk information
        case 0xfa07: {
          // response from restart other dtk device command
          if (byteArr[2] == 0x0a) cmd.commandName = "restartOtherDTKSuccess";
          else if (byteArr[2] == 0x0b) cmd.commandName = "restartOtherDTKFail";
          cmd.dtkAdd = (byteArr[4] << 8) + byteArr[5];
          break;
        } // dtk restart other dtk success
        case 0xfa08: {
          // response from write other dtk infomation command
          if (byteArr[2] == 0x0a) cmd.commandName = "writeOtherDTKSuccess";
          else if (byteArr[2] == 0x0b) cmd.commandName = "writeOtherDTKFail";
          cmd.dtkAdd = (byteArr[4] << 8) + byteArr[5];
          break;
        } //report write other dtk
        case 0xfa09: {
          // response from set dtk enter low power consumption mode command
          if (byteArr[2] == 0x0a) cmd.commandName = "setDTKEnterLowPowerSuccess";
          else if (byteArr[2] == 0x0b)
            cmd.commandName = "setDTKEnterLowPowerFail";
          break;
        } // dtk enter low power consumption mode success
        case 0xfa0c: {
          // response from set dtk enter distribution network mode command
          if (byteArr[2] == 0x0a)
            cmd.commandName = "setDTKEnterDistributionNetworkSuccess";
          else if (byteArr[2] == 0x0b)
            cmd.commandName = "setDTKEnterDistributionNetworkFail";
          break;
        } // dtk enter distribution network mode success
        case 0xfa31: {
          if (byteArr[2] == 0x0a) cmd.commandName = "setDTKdBmSuccess";
          else if (byteArr[2] == 0x0b) cmd.commandName = "setDTKdBmFail";
          break;
        } // dtk set dBm success
        case 0x0401: {
          //TODO, for now it just ping function
          cmd.commandName = "reportCurrentData";
          break;
        } //light reportCurrentData
        case 0x0402: {
          cmd.commandName = "requestGatewaySendStart";
          break;
        } //light requestGatewaySendStart
        case 0x0403: {
          cmd.voltage = ((byteArr[6] << 8) + byteArr[7]) / 100;
          const currentPolarity = byteArr[8];
          let current = ((byteArr[9] << 9) + byteArr[10]) / 100;
          if (currentPolarity === 1) current = current * -1;
          cmd.current = current;
          cmd.onoffstatusL = byteArr[11];
          cmd.commandName = "reportDataControlL";
          break;
        } //light reportDataControlL
        case 0x0404: {
          cmd.onoffstatusA = byteArr[6] > 0 ? 0 : 1;
          cmd.lightLv = byteArr[6];
          cmd.bypass = byteArr[7];
          cmd.lockLevel = byteArr[8];
          cmd.commandName = "reportDataControlA";
          break;
        } //light reportDataControlA
        case 0x0405: {
          cmd.commandName = "lightSurvival";
          break;
        } //light lightSurvival
        case 0x0406: {
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          cmd.ip = `${byteArr[10]}.${byteArr[11]}.${byteArr[12]}.${byteArr[13]}`;
          cmd.ipArray = [byteArr[10], byteArr[11], byteArr[12], byteArr[13]];
          cmd.dtkChannel = byteArr[14];
          cmd.commandName = "lightStart";
          break;
        } //light lightStart
        case 0x0407: {
          cmd.commandName = "acknowledgeReceiveCommand";
          cmd.ackCommandCode = (byteArr[6] << 8) + byteArr[7];
          break;
        } //light acknowledgeReceiveCommand
        case 0x0408: {
          cmd.commandName = "reportBatTestStart";
          break;
        } //light reportBatTestStart
        case 0x0409: {
          cmd.commandName = "reportBatTestData";
          const v100 = (byteArr[6] << 8) + byteArr[7];
          const currentDir = byteArr[8];
          let i100 = (byteArr[9] << 8) + byteArr[10];
          if (currentDir === 1) i100 = i100 * -1;
          cmd.voltage = v100 / 100;
          cmd.current = i100 / 100;
          cmd.onoffstatusL = byteArr[11];
          cmd.testTime = (byteArr[12] << 8) + byteArr[13];
          cmd.progress = byteArr[14];
          break;
        } //light reportBatTestData
        case 0x040a: {
          cmd.commandName = "reportBatTestEnd";
          cmd.totalTestTime = (byteArr[6] << 8) + byteArr[7];
          break;
        } //light reportBatTestEnd
        case 0x040b: {
          cmd.commandName = "meshLightStart";
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          cmd.ip = `${byteArr[10]}.${byteArr[11]}.${byteArr[12]}.${byteArr[13]}`;
          cmd.ipArray = [byteArr[10], byteArr[11], byteArr[12], byteArr[13]];
          cmd.MeshChannel = byteArr[14];
          cmd.meshFreq = byteArr[15];
          cmd.hadMeshAdd = byteArr[16] ? true : false;
          break;
        } //light lightRequestCommandResend
        case 0x040c: {
          cmd.commandName = "reportConfirmChangeDtkSetting";
          cmd.confirmCommandCode = (byteArr[6] << 8) + byteArr[7];
          break;
        } //light reportConfirmChangeDtkSetting
        case 0x0501: {
          cmd.commandName = "reportLockLevel";
          cmd.lockLevel = byteArr[6];
          break;
        } // light reportLockLevel
        case 0x0502: {
          cmd.commandName = "reportEnableA";
          cmd.enableA = byteArr[6];
          break;
        } //light reportEnableA
        case 0x0503: {
          cmd.commandName = "reportEnableL";
          cmd.enableL = byteArr[6];
          break;
        } //light reportEnableL
        case 0x0504: {
          cmd.commandName = "reportEnableBat";
          cmd.enableBat = byteArr[6];
          break;
        } //light reportEnableBat
        case 0x0505: {
          cmd.commandName = "reportEnableDim";
          cmd.enableDim = byteArr[6];
          break;
        } //light reportEnableDim
        case 0x0506: {
          cmd.commandName = "reportDimTransition";
          cmd.dimTransition = byteArr[6];
          break;
        } //light reportDimTransition
        case 0x0507: {
          cmd.commandName = "reportDimTransitON";
          cmd.dimTransitON = byteArr[6];
          break;
        } //light reportDimTransitON
        case 0x0508: {
          cmd.commandName = "reportDimTransitOFF";
          cmd.dimTransitOFF = byteArr[6];
          break;
        } //light reportDimTransitOFF
        case 0x0509: {
          cmd.commandName = "reportCutDimOnBypass";
          cmd.cutDimOnBypass = byteArr[6];
          break;
        } //light reportCutDimOnBypass
        case 0x050a: {
          cmd.commandName = "reportReverseA";
          cmd.reverseA = byteArr[6];
          break;
        } //light reportReverseA
        case 0x050b: {
          cmd.commandName = "reportControlAPin";
          cmd.controlAPin = byteArr[6];
          break;
        } //light reportControlAPin
        case 0x050c: {
          cmd.commandName = "reportControlLPin";
          cmd.controlLPin = byteArr[6];
          break;
        } //light reportControlLPin
        case 0x050d: {
          cmd.commandName = "reportRegularInterval";
          cmd.regular_time_interval = byteArr[6];
          break;
        } //light reportRegularInterval
        case 0x050e: {
          cmd.commandName = "reportSurvivalInterval";
          cmd.survival_time_interval = byteArr[6];
          break;
        } // light reportSurvivalInterval
        case 0x0510: {
          cmd.commandName = "reportEnableAirconControl";
          cmd.enableAirconControl = byteArr[6];
          break;
        } //light reportEnableAirconControl
        case 0x0511: {
          cmd.commandName = "reportInputBypassPin";
          cmd.inputBypassPin = byteArr[6];
          break;
        } //light reportInputBypassPin
        case 0x0512: {
          cmd.commandName = "reportOtaSsid";
          cmd.otaSsid = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        } //light reportOtaSsid
        case 0x0513: {
          cmd.commandName = "reportOtaPassword";
          cmd.otaPassword = String.fromCharCode(
            ...byteArr.slice(6, byteLength - 2)
          );
          break;
        } //light reportOtaPassword
        case 0x0514: {
          cmd.commandName = "reportCurrentProgramVersion";
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          break;
        } //light reportCurrentProgramVersion
        case 0x0515: {
          cmd.commandName = "reportUpdateFirmwareStatus";
          cmd.statusCode = byteArr[6];
          break;
        } //light reportUpdateFirmwareStatus
        case 0x0516: {
          cmd.commandName = "reportMacAddress";
          cmd.macAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          cmd.macArray = [
            byteArr[6],
            byteArr[7],
            byteArr[8],
            byteArr[9],
            byteArr[10],
            byteArr[11],
          ];
          break;
        } //light reportMacAddress
        case 0x0517: {
          cmd.commandName = "reportTestSettingReadWrite";
          cmd.result = byteArr[6] == 0x33 ? true : false;
          break;
        } //light reportTestSettingReadWrite
        case 0x0518: {
          cmd.commandName = "reportDisableEspNow";
          cmd.disableEspNow = byteArr[6] == 0x33 ? true : false;
          break;
        } //light reportDisableEspNow
        case 0x0519: {
          cmd.commandName = "reportEnableEspOut";
          cmd.enableEspOut = byteArr[6] == 0x33 ? true : false;
          break;
        } //light reportEnableEspNow
        case 0x051a: {
          cmd.commandName = "reportControlBPin";
          cmd.controlBPin = byteArr[6];
          break;
        } //light reportControlBPin
        case 0x051b: {
          cmd.commandName = "reportControlDPin";
          cmd.controlCPin = byteArr[6];
          break;
        } //light reportControlDPin
        case 0x051c: {
          cmd.commandName = "reportDelayCountDown";
          cmd.delayCountDown = (byteArr[6] << 8) | byteArr[7];
          cmd.delayCountDown2 = (byteArr[8] << 8) | byteArr[9];
          break;
        } //light reportDelayCountDown
        case 0x051d: {
          cmd.commandName = "reportEnableDali";
          cmd.enableDali = byteArr[6] === 0x33 ? true : false;
          break;
        } //light reportEnableDali
        case 0x051e: {
          cmd.commandName = "reportEnableTurnOnOnDisconnect";
          cmd.enableTurnOnOnDisconnect = byteArr[6] === 0x33 ? true : false;
          break;
        } //light reportEnableTurnOnOnDisconnect
        case 0x051f: {
          cmd.commandName = "reportWifiApMacAddress";
          cmd.wifiApMacAddressArray = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11]];
          cmd.wifiApMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        } //light reportWifiApMacAddress
        case 0x0520: {
          cmd.commandName = "reportSwitchSequence"
          cmd.switchSequence = byteArr[6];
          break;
        }//light reportSwitchSequence
        case 0x0521: {
          cmd.commandName = "reportMacUploadNode";
          let ffCheck = byteArr[12];
          let sourceMacAddressBytes = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11]];
          let revealMac = this.revealFF(sourceMacAddressBytes, ffCheck);

          // cmd.mac = sourceMacAddressBytes.map(byte => byte.toString(16).padStart(2, 0)).join('');
          cmd.mac = revealMac;
          break;
        }
        case 0x0522: {
          cmd.commandName = "reportLightFault";
          cmd.faultCode = byteArr[6];
          cmd.lowMemory = (cmd.faultCode >> 0) & 1;
          cmd.i2cError = (cmd.faultCode >> 1) & 1;
          cmd.batLowVolt = (cmd.faultCode >> 2) & 1;
          cmd.batHighVolt = (cmd.faultCode >> 3) & 1;
          cmd.batLowCur = (cmd.faultCode >> 4) & 1;
          cmd.statusAMismatch = (cmd.faultCode >> 5) & 1;
          cmd.mcpFail = (cmd.faultCode >> 6) & 1;
          cmd.coreTempHigh = (cmd.faultCode >> 7) & 1;
          cmd.generalFault = cmd.faultCode > 0 ? 1 : 0;
          break;
        } //light ReportLightFault
        case 0x0523: {
          cmd.commandName = "reportEnableAcknowledge"
          cmd.enableAcknowledge = byteArr[6];
          break;
        }
        case 0x0524: {
          cmd.commandName = "reportGroupAction"
          cmd.groupID = byteArr[6].toString(16).padStart(2, 0) + byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0) + byteArr[9].toString(16).padStart(2, 0);
          cmd.settingNum = byteArr[10];
          cmd.command = ""
          for (let i = 11; i < byteLength - 2; i++) {
            cmd.command += byteArr[i].toString(16).padStart(2, 0);
          }
          let fullcommnadStr = "ed" + (cmd.command.length / 2 + 2).toString(16).padStart(2, 0) + cmd.dtkAdd + cmd.command;
          fullcommnadStr = fullcommnadStr + this.getChecksum_dtk(fullcommnadStr) + "ff";
          cmd.commandObj = cmd.command != "" ? this.dtKStrToJson(fullcommnadStr) : false;
          break;
        }
        case 0x0525: {
          cmd.commandName = "reportDeleteAllGroupAction"
          break;
        }
        case 0x0526: {
          cmd.commandName = "reportGroupActionQuantity"
          cmd.groupActionQuantity = byteArr[6];
          cmd.groupID = byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0) + byteArr[9].toString(16).padStart(2, 0) + byteArr[10].toString(16).padStart(2, 0);
          break;
        }
        case 0x0527: {
          cmd.commandName = "reportBypassStatus"
          cmd.bypass = byteArr[6];
          break;
        }
        case 0x0528: {
          cmd.commandName = "reportUpdateFirmwareStart"
          break;
        }
        case 0x0529: {
          cmd.commandName = "reportDisableDtk"
          cmd.disableDtk = byteArr[6];
          break;
        }
        case 0x0580: {
          cmd.commandName = "reportDtkInfo";
          cmd.dtkType = byteArr[6];
          cmd.dtkPanID = str.substring(14, 18);
          cmd.dtkChannel = byteArr[9];
          cmd.dtkTransferMode = byteArr[10];
          cmd.dtkAdd = str.substring(22, 26);
          cmd.loraParameter = byteArr[13];
          cmd.dtkInternalAdd = str.substring(28, 32);
          break;
        } //light reportDtkInfo
        case 0x0581: {
          cmd.commandName = "reportDtkType";
          cmd.dtkType = byteArr[6];
          break;
        } //light reportDtkType
        case 0x0582: {
          cmd.commandName = "reportDtkPanID";
          cmd.dtkPanID = str.substring(12, 16);
          break;
        } //light reportDtkPanID
        case 0x0583: {
          cmd.commandName = "reportDtkChannel";
          cmd.dtkChannel = byteArr[6];
          break;
        } //light reportDtkChannel
        case 0x0584: {
          cmd.commandName = "reportDtkTransferMode";
          cmd.dtkTransferMode = byteArr[6];
          break;
        } //light reportDtkTransferMode
        case 0x0585: {
          cmd.commandName = "reportDtkDefinedAdd";
          cmd.dtkAdd = str.substring(12, 16);
          break;
        } //light reportDtkDefinedAdd
        case 0x0586: {
          cmd.commandName = "reportDtkLoraParameter";
          cmd.loraParameter = byteArr[6];
          break;
        } //light reportDtkLoraParameter
        case 0x0587: {
          cmd.commandName = "reportDtkInternalAdd";
          cmd.internalAdd = str.substring(12, 16);
          break;
        } //light reportDtkInternalAdd
        case 0x0588: {
          cmd.commandName = "lightReportChangeDtkInfoFail"
          break;
        }
        case 0x0589: {
          cmd.commandName = "lightReportDtkBaudrateCode";
          cmd.baudrateCode = byteArr[6];
          break;
        } //light reportDtkBaudrateCode
        case 0x05a0: {
          cmd.commandName = "lightReportMeshMacAddress";
          cmd.meshMacAddressArray = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11],];
          cmd.meshMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        } //light reportMeshMacAddress
        case 0x05a1: {
          cmd.commandName = "lightReportMeshInfo";
          cmd.meshChannel = byteArr[6];
          cmd.meshFreq = byteArr[7];
          cmd.meshSpeed = byteArr[8];
          cmd.meshPower = byteArr[9];
          cmd.meshEnableRepeat = byteArr[10];
          break;
        } //light reportMeshInfo
        case 0x05a2: {
          cmd.commandName = "lightReportMeshChannel";
          cmd.meshChannel = byteArr[6];
          break;
        } //light reportMeshChannel
        case 0x05a3: {
          cmd.commandName = "lightReportMeshFreq";
          cmd.meshFreq = byteArr[6];
          break;
        } //light reportMeshFreq
        case 0x05a4: {
          cmd.commandName = "lightReportMeshSpeed";
          cmd.meshSpeed = byteArr[6];
          break;
        } //light reportMeshSpeed
        case 0x05a5: {
          cmd.commandName = "lightReportMeshPower";
          cmd.meshPower = byteArr[6];
          break;
        } //light reportMeshPower
        case 0x05a6: {
          cmd.commandName = "lightReportMeshNetworkID";
          cmd.meshNetworkID = byteArr[6].toString(16).padStart(2, 0) + byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0);
          break;
        } //light reportMeshNetworkID
        case 0x05a7: {
          cmd.commandName = "lightReportMeshDefinedAdd";
          cmd.meshDefinedAdd = (byteArr[6] << 8) | byteArr[7];
          break;
        } //light reportMeshDefinedAdd
        case 0x05a8: {
          cmd.commandName = "lightReportMeshEnableRepeat";
          cmd.meshEnableRepeat = byteArr[6];
          break;
        } //light reportMeshEnableRepeat
        case 0x05a9: {
          cmd.commandName = "lightReportChangeMeshInfoFail";
          break;
        } //light reportMeshBaudrate
        case 0x0802: {
          cmd.commandName = "requestGatewaySendStart";
          break;
        } //requestGatewaySendStart
        case 0x0803: {
          cmd.commandName = "motionDataUpload";
          cmd.motionStatus = byteArr[6];
          cmd.isRegular = byteLength >= 9 ? byteArr[7] : false;
          cmd.uniqueActionID = byteLength >= 10 ? byteArr[8] : undefined;
          break;
        } //motionDataUpload
        case 0x0804: {
          cmd.commandName = "daylightDataUpload";
          cmd.lux = (byteArr[6] << 8) + byteArr[7];
          cmd.luxLv = byteArr[8];
          cmd.isRegular = byteLength >= 11 ? byteArr[9] : false;
          cmd.uniqueActionID = byteLength >= 12 ? byteArr[10] : undefined;
          break;
        } //daylightDataUpload
        case 0x0805: {
          cmd.commandName = "lightSwitchDataUpload";
          const statusByte = byteArr[6];
          for (let i = 0; i < 8; i++) {
            cmd[`currentStatus${i === 0 ? "" : i + 1}`] = (statusByte >> i) & 1;
          }
          const onChangeByte = byteArr[7];
          for (let i = 0; i < 8; i++) {
            cmd[`onChangeStatus${i === 0 ? "" : i + 1}`] =
              (onChangeByte >> i) & 1;
          }
          cmd.isRegular = byteLength >= 10 ? byteArr[8] : false;
          cmd.uniqueActionID = byteLength >= 11 ? byteArr[9] : undefined;
          break;
        } //lightSwitchDataUpload
        case 0x0806: {
          cmd.commandName = "daylightMotionDataUpload";
          cmd.motionStatus = byteArr[6];
          cmd.lux = (byteArr[7] << 8) + byteArr[8];
          cmd.luxLv = byteArr[9];
          cmd.settingNum = byteArr[10];
          cmd.writeDb = byteArr[11];
          cmd.uniqueActionID = byteLength >= 14 ? byteArr[12] : undefined;
          break;
        } //daylightMotionDataUpload
        case 0x0807: {
          cmd.commandName = "sensorSurvival";
          break;
        } //sensorSurvival
        case 0x0808: {
          cmd.commandName = "sensorStart";
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          cmd.ip = `${byteArr[10]}.${byteArr[11]}.${byteArr[12]}.${byteArr[13]}`;
          cmd.ipArray = [byteArr[10], byteArr[11], byteArr[12], byteArr[13]];
          cmd.dtkChannel = byteArr[14];
          break;
        } //sensorStart
        case 0x0809: {
          cmd.commandName = "acknowledgeReceiveCommand";
          cmd.ackCommandCode = (byteArr[6] << 8) + byteArr[7];
          break;
        } //sensorAcknowledgeReceiveCommand
        case 0x080a: {
          cmd.commandName = "sceneButtonDataUpload";
          for (let i = 0; i < 4; i++) {
            cmd[`currentStatus${i == 0 ? "" : i + 1}`] = (byteArr[6] >> i) & 1;
          }
          cmd.isRegular = byteArr[7];
          cmd.uniqueActionID = byteLength >= 10 ? byteArr[8] : undefined;
          break;
        } //sceneButtonDataUpload
        case 0x080b: {
          cmd.commandName = "ultrasonicDataUpload";
          break;
        }//ultrasonicDataUpload
        case 0x080c: {
          cmd.commandName = "meshSensorStart"
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          cmd.ip = `${byteArr[10]}.${byteArr[11]}.${byteArr[12]}.${byteArr[13]}`;
          cmd.meshChannel = byteArr[14];
          cmd.meshFreq = byteArr[15];
          cmd.hadMeshAdd = byteArr[16] ? true : false;
        }//meshSensorStart
          break;
        case 0x0901: {
          cmd.commandName = "sensorReportSensorType";
          cmd.sensorType = byteArr[6];
          break;
        } //sensorReportSensorType
        case 0x0902: {
          cmd.commandName = "sensorReportSensorDist";
          cmd.sensorDist = byteArr[6];
          break;
        } //sensorReportSensorDist
        case 0x0903: {
          cmd.commandName = "sensorReportSensorMode";
          cmd.sensorMode = byteArr[6];
          break;
        } //sensorReportSensorMode
        case 0x0904: {
          cmd.commandName = "sensorReportHasIR";
          cmd.hasIR = byteArr[6]
          break;
        } //sensorReportHasIR
        case 0x0905: {
          cmd.commandName = "sensorReportDisabledSensor";
          cmd.disabledSensor = byteArr[6]
          break;
        } //sensorReportDisabledSensor
        case 0x0906: {
          cmd.commandName = "sensorReportDisabledLux";
          cmd.disabledLux = byteArr[6];
          break;
        } //sensorReportDisabledLux
        case 0x0907: {
          cmd.commandName = "sensorReportDisabledMotion";
          cmd.disabledMotion = byteArr[6];
          break;
        } //sensorReportDisabledMotion
        case 0x0908: {
          cmd.commandName = "sensorReportGang";
          cmd.gang = byteArr[6];
          break;
        } //sensorReportGang
        case 0x0909: {
          cmd.commandName = "sensorReportCheck_lux_interval";
          cmd.check_lux_interval = byteArr[6];
          break;
        } //sensorReportCheck_lux_interval
        case 0x090a: {
          cmd.commandName = "sensorReportEnable_delayed_action";
          cmd.enable_delayed_action = byteArr[6];
          break;
        } //sensorReportEnable_delayed_action
        case 0x090b: {
          cmd.commandName = "sensorReportEnable_delayed_action2";
          cmd.enable_delayed_action2 = byteArr[6];
          break;
        } //sensorReportEnable_delayed_action2
        case 0x090c: {
          cmd.commandName = "sensorReportMotion_off_delay";
          cmd.motion_off_delay = (byteArr[6] << 8) + byteArr[7];
          cmd.delaySec = cmd.motion_off_delay;
          break;
        } //sensorReportMotion_off_delay
        case 0x090d: {
          cmd.commandName = "sensorReportMotion_off_delay2";
          cmd.motion_off_delay2 = (byteArr[6] << 8) + byteArr[7];
          cmd.delaySec2 = cmd.motion_off_delay2;
          break;
        } //sensorReportMotion_off_delay2
        case 0x090e: {
          cmd.commandName = "sensorReportDelayCountDown";
          cmd.delayCountDown = (byteArr[6] << 8) + byteArr[7];
          break;
        } //sensorReportDelayCountDown
        case 0x090f: {
          cmd.commandName = "sensorReportDisabledRelay";
          cmd.disabledRelay = byteArr[6];
          break;
        } //sensorReportDisabledRelay
        case 0x0910: {
          cmd.commandName = "sensorReportDisabledContact";
          cmd.disabledContact = byteArr[6];
          break;
        } //sensorReportDisabledContact
        case 0x0911: {
          cmd.commandName = "sensorReportBtn1Pin";
          cmd.btn1Pin = byteArr[6];
          break;
        } //sensorReportBtn1Pin
        case 0x0912: {
          cmd.commandName = "sensorReportBtn2Pin";
          cmd.btn2Pin = byteArr[6];
          break;
        } //sensorReportBtn2Pin
        case 0x0913: {
          cmd.commandName = "sensorReportBtn3Pin";
          cmd.btn3Pin = byteArr[6];
          break;
        } //sensorReportBtn3Pin
        case 0x0914: {
          cmd.commandName = "sensorReportBtn4Pin";
          cmd.btn4Pin = byteArr[6];
          break;
        } //sensorReportBtn4Pin
        case 0x0915: {
          cmd.commandName = "reportUpdateFirmwareStatus";
          cmd.statusCode = byteArr[6];
          break;
        } //sensorReportUpdateFirmwareStatus
        case 0x0916: {
          cmd.commandName = "reportCurrentProgramVersion";
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          break;
        } //sensorReportCurrentProgramVersion
        case 0x0917: {
          cmd.commandName = "sensorReportMacAddress";
          cmd.macAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          cmd.macArray = [
            byteArr[6],
            byteArr[7],
            byteArr[8],
            byteArr[9],
            byteArr[10],
            byteArr[11],
          ];
          break;
        } //sensorReportMacAddress
        case 0x0918: {
          cmd.commandName = "sensorReportTestSettingReadWrite";
          cmd.result = byteArr[6] == 0x33 ? true : false;
          break;
        } //sensorReportTestSettingReadWrite
        case 0x0919: {
          cmd.commandName = "reportRegularInterval";
          cmd.regular_time_interval = byteArr[6];
          break;
        } //sensorReportRegularInterval
        case 0x091a: {
          cmd.commandName = "reportSurvivalInterval";
          cmd.survival_time_interval = byteArr[6];
          break;
        } //sensorReportSurvivalInterval
        case 0x091b: {
          cmd.commandName = "reportDisableEspNow";
          cmd.disableEspNow = byteArr[6] == 0x33 ? true : false;
          break;
        } //sensorReportDisableEspNow
        case 0x091c: {
          cmd.commandName = "sensorReportSensorFault";
          cmd.faultCode = byteArr[6];
          cmd.ramFault = (cmd.faultCode >> 0) & 1;
          cmd.luxFault = (cmd.faultCode >> 1) & 1;
          cmd.pcfFault = (cmd.faultCode >> 2) & 1;
          cmd.coreTempFault = (cmd.faultCode >> 3) & 1;
          cmd.touchPanelFault = (cmd.faultCode >> 4) & 1;
          cmd.generalFault = cmd.faultCode > 0 ? 1 : 0;
          break;
        } //sensorReportSensorFault
        case 0x091d: {
          cmd.commandName = "sensorReportOtaSsid";
          cmd.otaSsid = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        } //sensorReportOtaSsid
        case 0x091e: {
          cmd.commandName = "sensorReportOtaPassword";
          cmd.otaPassword = String.fromCharCode(
            ...byteArr.slice(6, byteLength - 2)
          );
          break;
        } //sensorReportOtaPassword
        case 0x091f: {
          cmd.commandName = "sensorReportEnableEspOut";
          cmd.enableEspOut = byteArr[6] == 0x33 ? true : false;
          break;
        } //sensorReportEnableEspOut
        case 0x0920: {
          cmd.commandName = "sensorReportButtonPin";
          cmd.btn1Pin = byteArr[6];
          cmd.btn2Pin = byteArr[7];
          cmd.btn3Pin = byteArr[8];
          cmd.btn4Pin = byteArr[9];
          break;
        } //sensorReportButtonPin
        case 0x0922: {
          const msgLen = byteLength - 15;
          cmd.commandName = "sensorReportNearFieldSetting";
          cmd.macAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          cmd.macArray = [
            byteArr[6],
            byteArr[7],
            byteArr[8],
            byteArr[9],
            byteArr[10],
            byteArr[11],
          ];
          cmd.settingNum = byteArr[12];
          cmd.shortAdd = byteArr[13];
          let msgArray = [];
          for (let i = 0; i < msgLen - 1; i++) {
            msgArray[i] = byteArr[14 + i];
          }
          cmd.msgArray = msgArray;
          break;
        } //sensorReportNearFieldSetting
        case 0x0923: {
          cmd.commandName = "sensorReportWifiApMacAddress";
          cmd.wifiApMacAddressArray = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11]];
          cmd.wifiApMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        } //sensorReportWifiApMacAddress
        case 0x0924: {
          cmd.commandName = "sensorReportLuxFactor";
          cmd.multiplier = (byteArr[6] << 8 | byteArr[7]) / 10000;
          cmd.power = (byteArr[8] << 8 | byteArr[9]) / 10000;
          break;
        } //sensorReportEnableTurnOnOnDisconnect
        case 0x0925: {
          cmd.commandName = "sensorReportChangeSensorTypeFail";
          break;
        } //sensorReportChangeSensorTypeFail
        case 0x0926: {
          cmd.commandName = "sensorReportDeletedAllNearFieldSetting";
          break;
        } //sensorReportDeletedAllNearFieldSetting
        case 0x0927: {
          cmd.commandName = "sensorReportMacUploadNode";
          let ffCheck = byteArr[12];
          let sourceMacAddressBytes = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11]];
          let revealMac = this.revealFF(sourceMacAddressBytes, ffCheck);
          cmd.mac = revealMac;
          break;
        } //sensorReportMacUploadNode
        case 0x0928: {
          cmd.commandName = "sensorReportSceneBtnMinTime";
          cmd.sceneBtnMinTime = byteArr[6] << 16 + byteArr[7] << 8 + byteArr[8];
          break;
        } //sensorReportSceneBtnMinTime
        case 0x0929: {
          cmd.commandName = "sensorReportSceneBtnRepeatTime";
          cmd.sceneBtnRepeatTime = byteArr[6] << 16 + byteArr[7] << 8 + byteArr[8];
          break;
        } //sensorReportSceneBtnRepeatTime
        case 0x0930: {
          cmd.commandName = "sensorReportEnableAcknowledge"
          cmd.enableAcknowledge = byteArr[6];
          break;
        } //sensorReportEnableAcknowledge
        case 0x0931: {
          cmd.commandName = "reportTouchPanelReverseLed"
          cmd.reverseLed = byteArr[6];
          break;
        } //reportTouchPanelReverseLed
        case 0x0932: {
          cmd.commandName = "reportGroupAction"
          cmd.groupID = byteArr[6].toString(16).padStart(2, 0) + byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0) + byteArr[9].toString(16).padStart(2, 0);
          cmd.settingNum = byteArr[10];
          cmd.command = ""
          for (let i = 11; i < byteLength - 2; i++) {
            cmd.command += byteArr[i].toString(16).padStart(2, 0);
          }
          let fullcommnadStr = "ed" + (cmd.command.length / 2 + 2).toString(16).padStart(2, 0) + cmd.dtkAdd + cmd.command;
          fullcommnadStr = fullcommnadStr + this.getChecksum_dtk(fullcommnadStr) + "ff";
          cmd.commandObj = cmd.command != "" ? this.dtKStrToJson(fullcommnadStr) : false;
          break;
        } //reportGroupAction
        case 0x0933: {
          cmd.commandName = "reportDeleteAllGroupAction"
          break;
        } //reportDeleteAllGroupAction
        case 0x0934: {
          cmd.commandName = "reportGroupActionQuantity"
          cmd.groupActionQuantity = byteArr[6];
          cmd.groupID = byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0) + byteArr[9].toString(16).padStart(2, 0) + byteArr[10].toString(16).padStart(2, 0);
          break;
        }//reportGroupActionQuantity
        case 0x0935: {
          cmd.commandName = "reportUpdateFirmwareStart"
          break;
        } //reportUpdateFirmwareStart
        case 0x0936: {
          cmd.commandName = "reportDisabledLightAction"
          cmd.disabledLightAction = byteArr[6];
          break;
        } //reportDisabledLightAction
        case 0x0937: {
          cmd.commandName = "sensorReportDisableDtk"
          cmd.disableDtk = byteArr[6];
          break;
        } //sensorReportDisableDtk
        case 0x092a: {
          cmd.commandName = "sensorReportTouchPanelType";
          cmd.touchPanelType = byteArr[6];
          break;
        } //sensorReportTouchPanelType
        case 0x092b: {
          cmd.commandName = "sensorReportBtnPinGang";
          cmd.gang = byteArr[6];
          cmd.btn1Pin = byteArr[7];
          cmd.btn2Pin = byteArr[8];
          cmd.btn3Pin = byteArr[9];
          cmd.btn4Pin = byteArr[10];
          break;
        } //sensorReportBtnPinGang  
        case 0x092c: {
          cmd.commandName = "sensorReportSensorHeadType";
          cmd.sensorHeadType = byteArr[6];
          break;
        }//sensorReportSensorHeadType
        case 0x092d: {
          cmd.commandName = "sensorReportTouchPanelVer";
          cmd.touchPanelVersion = byteArr[6];
          break;
        }//sensorReportTouchPanelVer
        case 0x092e: {
          cmd.commandName = "sensorReportTouchPanelGang";
          cmd.touchPanelGang = byteArr[6];
          break;
        }//sensorReportTouchPanelGang
        case 0x092f: {
          cmd.commandName = "sensorReportBatchNearFieldSetting";
          cmd.macAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          cmd.macArray = [
            byteArr[6],
            byteArr[7],
            byteArr[8],
            byteArr[9],
            byteArr[10],
            byteArr[11],
          ];
          cmd.shortAdd = byteArr[12];
          let lightLvArr = [];
          for (let i = 0; i < 12; i++) {
            lightLvArr.push(byteArr[13 + i]);
          }
          cmd.lightLvArr = lightLvArr;
        }//sensorReportBatchNearFieldSetting
        case 0x0980: {
          cmd.commandName = "sensorReportDtkInfo";
          cmd.dtkType = byteArr[6];
          cmd.dtkPanID = str.substring(14, 18);
          cmd.dtkChannel = byteArr[9];
          cmd.dtkTransferMode = byteArr[10];
          cmd.dtkAdd = str.substring(22, 26);
          cmd.loraParameter = byteArr[13];
          cmd.dtkInternalAdd = str.substring(28, 32);
          break;
        } //sensorReportDtkInfo
        case 0x0981: {
          cmd.commandName = "sensorReportDtkType";
          cmd.dtkType = byteArr[6];
          break;
        } //sensorReportDtkType
        case 0x0982: {
          cmd.commandName = "sensorReportDtkPanID";
          cmd.dtkPanID = str.substring(12, 16);
          break;
        } //sensorReportDtkPanID
        case 0x0983: {
          cmd.commandName = "sensorReportDtkChannel";
          cmd.dtkChannel = byteArr[6];
          break;
        } //sensorReportDtkChannel
        case 0x0984: {
          cmd.commandName = "sensorReportDtkTransferMode";
          cmd.dtkTransferMode = byteArr[6];
          break;
        } //sensorReportDtkTransferMode
        case 0x0985: {
          cmd.commandName = "sensorReportDtkDefinedAdd";
          cmd.dtkAdd = str.substring(12, 16);
          break;
        } //sensorReportDtkDefinedAdd
        case 0x0986: {
          cmd.commandName = "sensorReportDtkLoraParameter";
          cmd.loraParameter = byteArr[6];
          break;
        } //sensorReportDtkLoraParameter
        case 0x0987: {
          cmd.commandName = "sensorReportDtkInternalAdd";
          cmd.internalAdd = str.substring(12, 16);
          break;
        } // sensorReportDtkInternalAdd
        case 0x0989: {
          cmd.commandName = "sensorReportDtkBaudrateCode";
          cmd.baudrateCode = byteArr[6];
          break;
        } //sensorReportDtkBaudrateCode
        case 0x09a0: {
          cmd.commandName = "sensorReportMeshMacAddress";
          cmd.meshMacAddressArray = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11],];
          cmd.meshMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        } //sensorReportMeshMacAddress
        case 0x09a1: {
          cmd.commandName = "sensorReportMeshInfo";
          cmd.meshChannel = byteArr[6];
          cmd.meshFreq = byteArr[7];
          cmd.meshSpeed = byteArr[8];
          cmd.meshPower = byteArr[9];
          cmd.meshEnableRepeat = byteArr[10];
          break;
        } //sensorReportMeshInfo
        case 0x09a2: {
          cmd.commandName = "sensorReportMeshChannel";
          cmd.meshChannel = byteArr[6];
          break;
        }//sensorReportMeshChannel
        case 0x09a3: {
          cmd.commandName = "sensorReportMeshFreq";
          cmd.meshFreq = byteArr[6];
          break;
        }//sensorReportMeshFreq
        case 0x09a4: {
          cmd.commandName = "sensorReportMeshSpeed";
          cmd.meshSpeed = byteArr[6];
          break;
        }//sensorReportMeshSpeed
        case 0x09a5: {
          cmd.commandName = "sensorReportMeshPower";
          cmd.meshPower = byteArr[6];
          break;
        }//sensorReportMeshPower
        case 0x09a6: {
          cmd.commandName = "sensorReportNetworkID";
          cmd.meshNetworkID = byteArr[6].toString(16).padStart(2, 0) + byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0);
          break;
        }//sensorReportMeshNetworkID
        case 0x09a7: {
          cmd.commandName = "reportMeshDefindAdd";
          cmd.meshDefinedAdd = (byteArr[6] << 8) | byteArr[7];

          break;
        }//sensorReportMeshDefindAdd
        case 0x09a8: {
          cmd.commandName = "sensorReportEnableRepeat";
          cmd.meshEnableRepeat = byteArr[6];
          break;
        }//sensor reportEnableRepeat
        case 0x09a9: {
          cmd.commandName = "sensorReportChangeMeshInfoFail"
          break;
        }
        case 0x09e0: {
          cmd.commandName = "sensorReportSensorHeadTestReport"
          cmd.testStarted = byteArr[6] == 1 ? true : false;
          cmd.sensorStatus = byteArr[7] == 1 ? true : false;
          cmd.lux = (byteArr[8] << 8) + byteArr[9];
          cmd.IRDetected = byteArr[10] == 1 ? true : false;
          cmd.IRNotDetected = byteArr[11] == 1 ? true : false;
          cmd.MWDetected = byteArr[12] == 1 ? true : false;
          cmd.MWNotDetected = byteArr[13] == 1 ? true : false;
        }
          break;
        case 0x0c01: {
          cmd.commandName = "daliCtlRequestGatewaySendStart";
          break;
        } //daliCtlRequestGatewaySendStart
        case 0x0c02: {
          cmd.commandName = "reportShortAddList";
          let shortAddArray = [];
          for (let i = 0; i < byteLength - 6 - 2; i++) {
            shortAddArray[i] = byteArr[6 + i];
            // cmd[`Add${i}`] = byteArr[6 + i];
          }
          cmd.shortAddArray = shortAddArray;
          break;
        } //reportShortAddList
        case 0x0c03: {
          cmd.commandName = "replyGeneralDaliQuery";
          cmd.shortAdd = byteArr[6];
          cmd.daliCmd = byteArr[7];
          cmd.reply = byteArr[8];
          break;
        } //replyGeneralDaliQuery
        case 0x0c04: {
          cmd.commandName = "daliCtlStart";
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          cmd.ip = `${byteArr[10]}.${byteArr[11]}.${byteArr[12]}.${byteArr[13]}`;
          cmd.dtkChannel = byteArr[14];
          break;
        } //daliCtlReportStart
        case 0x0c05: {
          cmd.commandName = "daliCtlSurvival";
          break;
        } //daliCtl Report Survival
        case 0x0c06: {
          cmd.commandName = "reportSingleLightData";
          cmd.shortAdd = byteArr[6];
          cmd.lightLv = byteArr[7];
          cmd.lockLv = byteArr[8];
          break;
        } //daliCtl reportSingleLight light lv and lock lv
        case 0x0c07: {
          cmd.commandName = "AcknowledgeReceiveCommand";
          cmd.ackCommandCode = (byteArr[6] << 8) + byteArr[7];
          break;
        } //daliCtl AcknowledgeReceiveCommand
        case 0x0c08: {
          cmd.commandName = "reportAllLightLv";
          cmd.bypass = byteArr[6];
          let lightLvArray = [];
          for (let i = 0; i < byteLength - 7 - 2; i++) {
            lightLvArray[i] = byteArr[7 + i];
          }
          cmd.lightLvArray = lightLvArray;
          break;
        } //daliCtl reportAllLightLv
        case 0x0c09: {
          cmd.commandName = "reportFadeTime";
          cmd.shortAdd = byteArr[6];
          cmd.fadeTime = byteArr[7];
          break;
        } //daliCtl reportFadeTime
        case 0x0c0a: {
          cmd.commandName = "reportMemoryBank";
          cmd.shortAdd = byteArr[6];
          cmd.memoryAdd = byteArr[7];
          cmd.value = byteArr[8];
          break;
        } //daliCtl reportMemoryBank
        case 0x0c0b: {
          cmd.commandName = "reportLockLevel";
          cmd.shortAdd = byteArr[6];
          cmd.lockLevel = byteArr[7];
          break;
        } //daliCtl reportLockLevel
        case 0x0c0c: {
          cmd.commandName = "reportLockLevelAll";
          let lockLvArray = [];
          for (let i = 0; i < byteLength - 6 - 2; i++) {
            lockLvArray[i] = byteArr[6 + i];
            // cmd[`lockLv${i}`] = byteArr[6 + i];
          }
          cmd.lockLvArray = lockLvArray;
          break;
        } //daliCtl reportLockLevelAll
        case 0x0c0d: {
          cmd.commandName = "scanFinish";
          break;
        } //daliCtl scanFinish
        case 0x0c0e: {
          cmd.commandName = "initialiseFinish";
          break;
        } //daliCtl initialiseFinish
        case 0x0c0f: {
          cmd.commandName = "reportMinLvAll";
          let minLvArray = [];
          for (let i = 0; i < byteLength - 6 - 2; i++) {
            minLvArray[i] = byteArr[6 + i];
            // cmd[`Lv${i}`] = byteArr[6 + i];
          }
          cmd.minLvArray = minLvArray;
          break;
        } //daliCtl reportMinLvAll
        case 0x0c10: {
          cmd.commandName = "reportMaxLvAll";
          let maxLvArray = [];
          for (let i = 0; i < byteLength - 6 - 2; i++) {
            maxLvArray[i] = byteArr[6 + i];
            // cmd[`Lv${i}`] = byteArr[6 + i];
          }
          cmd.maxLvArray = maxLvArray;
          break;
        } //daliCtl reportMaxLvAll
        case 0x0c11: {
          cmd.commandName = "reportMinLv";
          cmd.shortAdd = byteArr[6];
          cmd.minLv = byteArr[7];
          break;
        } //daliCtl reportMinLv
        case 0x0c12: {
          cmd.commandName = "reportMaxLv";
          cmd.shortAdd = byteArr[6];
          cmd.maxLv = byteArr[7];
          break;
        } //daliCtl reportMaxLv
        case 0x0c13: {
          cmd.commandName = "reportConnectedLights";
          let connectedLightArray = [];
          for (let i = 0; i < byteLength - 6 - 2; i++) {
            connectedLightArray[i] = byteArr[6 + i];
            // cmd[`Add${i}`] = byteArr[6 + i];
          }
          cmd.connectedLightArray = connectedLightArray;
          break;
        } //daliCtl reportConnectedLights
        case 0x0c14: {
          cmd.commandName = "reportDisconnectedLights";
          let disconnectedLightArray = [];
          for (let i = 0; i < byteLength - 6 - 2; i++) {
            disconnectedLightArray[i] = byteArr[6 + i];
            // cmd[`Add${i}`] = byteArr[6 + i];
          }
          cmd.disconnectedLightArray = disconnectedLightArray;
          break;
        } //daliCtl reportDisconnectedLights
        case 0x0c15: {
          cmd.commandName = "reportBypass";
          cmd.bypass = byteArr[6] == 0x33 ? 1 : 0;
          break;
        } //daliCtl reportBypass
        case 0x0c16: {
          cmd.commandName = "acknowledgePartCommand";
          cmd.ackCommandCode = (byteArr[6] << 8) + byteArr[7];
          cmd.receivedPartByteH = byteArr[8];
          cmd.receivedPartByteL = byteArr[9];
          cmd.actionID = byteArr[10];
          break;
        } //daliCtl acknowledgePartCommand
        case 0x0c17: {
          cmd.commandName = "reportFadeTimeAll";
          let fadeTimeArray = [];
          for (let i = 0; i < byteLength - 6 - 2; i++) {
            fadeTimeArray[i] = byteArr[6 + i];
            // cmd[`fadeTime${i}`] = byteArr[6 + i];
          }
          cmd.fadeTimeArray = fadeTimeArray;
          break;
        } //daliCtl reportFadeTimeAll
        case 0x0c18: {
          cmd.commandName = "reportControlAPin";
          cmd.controlAPin = byteArr[6];
          break;
        } //daliCtl reportControlAPin
        case 0x0c19: {
          cmd.commandName = "reportControlBPin";
          cmd.controlBPin = byteArr[6];
          break;
        } //daliCtl reportControlBPin
        case 0x0c1a: {
          cmd.commandName = "reportControlDPin";
          cmd.controlDPin = byteArr[6];
          break;
        } //daliCtl reportControlDPin
        case 0x0c1b: {
          cmd.commandName = "daliCtlReportDisableEspNow";
          cmd.disableEspNow = byteArr[6] == 0x33 ? true : false;
          break;
        } //daliCtl reportDisableEspNow
        case 0x0c1c: {
          cmd.commandName = "daliCtlReportEnableEspOut";
          cmd.enableEspOut = byteArr[6] == 0x33 ? true : false;
          break;
        } //daliCtl reportEnableEspOut
        case 0x0c1d: {
          cmd.commandName = "reportRegularInterval";
          cmd.regular_time_interval = byteArr[6];
          break;
        } //reportRegularInterval
        case 0x0c1e: {
          cmd.commandName = "reportSurvivalInterval";
          cmd.survival_time_interval = byteArr[6];
          break;
        } //reportSurvivalInterval
        case 0x0c1f: {
          cmd.commandName = "reportEnableDali";
          cmd.enableDali = byteArr[6] === 0x33 ? true : false;
          break;
        } //reportEnableDali
        case 0x0c20: {
          cmd.commandName = "reportEnableTurnOnOnDisconnect";
          cmd.enableTurnOnOnDisconnect = byteArr[6] === 0x33 ? true : false;
          break;
        } //reportEnableTurnOnOnDisconnect
        case 0x0c21: {
          cmd.commandName = "reportWifiApMacAddress";
          cmd.wifiApMacAddressArray = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11]];
          cmd.wifiApMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        }  //reportWifiApMacAddress
        case 0x0c22: {
          cmd.commandName = "reportDaliPowerOnOffStatus";
          cmd.powerOnOffStatus = byteArr[6];
          break;
        } //reportDaliPowerOnOffStatus
        case 0x0c23: {
          cmd.commandName = "daliCtlReportOtaSsid";
          cmd.otaSsid = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        } //daliCtl ReportOtaSsid
        case 0x0c24: {
          cmd.commandName = "daliCtlReportOtaPassword";
          cmd.otaPassword = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        } //daliCtl ReportOtaPassword
        case 0x0c25: {
          cmd.commandName = "daliCtlReportCurrentProgramVersion";
          const version =
            String.fromCharCode(byteArr[6]) +
            String.fromCharCode(byteArr[7]) +
            String.fromCharCode(byteArr[8]) +
            String.fromCharCode(byteArr[9]);
          cmd.version = version;
          break;
        } //daliCtlReportCurrentProgramVersion
        case 0x0c26: {
          cmd.commandName = "daliCtlReportUpdateFirmwareStatus";
          cmd.statusCode = byteArr[6];
          break;
        } //daliCtlReportUpdateFirmwareStatus
        case 0x0c27: {
          cmd.commandName = "daliCtlReportSwitchSequence";
          cmd.switchSequence = byteArr[6];
          break;
        }//daliCtlReportSwitchSequence
        case 0x0c28: {
          cmd.commandName = "reportMacUploadNode";
          let ffCheck = byteArr[12];
          let sourceMacAddressBytes = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11]];
          let revealMac = this.revealFF(sourceMacAddressBytes, ffCheck);
          cmd.mac = revealMac;
          break;
        }
        case 0x0c29: {
          cmd.commandName = "daliCtlReportCutDimOnBypass";
          cmd.cutDimOnBypass = byteArr[6];
          break;
        } //daliCtlReportCutDimOnBypass
        case 0x0c2a: {
          cmd.commandName = "daliCtlReportDaliFault";
          cmd.faultCode = byteArr[6];
          cmd.lowMemory = (cmd.faultCode >> 0) & 1;
          cmd.i2cError = (cmd.faultCode >> 1) & 1;
          cmd.batLowVolt = (cmd.faultCode >> 2) & 1;
          cmd.batHighVolt = (cmd.faultCode >> 3) & 1;
          cmd.batLowCur = (cmd.faultCode >> 4) & 1;
          cmd.statusAMismatch = (cmd.faultCode >> 5) & 1;
          cmd.mcpFail = (cmd.faultCode >> 6) & 1;
          cmd.coreTempHigh = (cmd.faultCode >> 7) & 1;
          cmd.generalFault = cmd.faultCode > 0 ? 1 : 0;
          break;
        } //daliCtlReportDaliFault
        case 0x0c2b: {
          cmd.commandName = "daliReportEnableAcknowledge"
          cmd.enableAcknowledge = byteArr[6];
          break;
        }
        case 0x0c2c: {
          cmd.commandName = "reportGroupAction"
          cmd.groupID = byteArr[6].toString(16).padStart(2, 0) + byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0) + byteArr[9].toString(16).padStart(2, 0);
          cmd.settingNum = byteArr[10];
          cmd.command = ""
          for (let i = 11; i < byteLength - 2; i++) {
            cmd.command += byteArr[i].toString(16).padStart(2, 0);
          }
          let fullcommnadStr = "ed" + (cmd.command.length / 2 + 2).toString(16).padStart(2, 0) + cmd.dtkAdd + cmd.command;
          fullcommnadStr = fullcommnadStr + this.getChecksum_dtk(fullcommnadStr) + "ff";
          cmd.commandObj = cmd.command != "" ? this.dtKStrToJson(fullcommnadStr) : false;
          break;
        }
        case 0x0c2d: {
          cmd.commandName = "reportDeleteAllGroupAction"
          break;
        }
        case 0x0c2e: {
          cmd.commandName = "reportGroupActionQuantity"
          cmd.groupActionQuantity = byteArr[6];
          cmd.groupID = byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0) + byteArr[9].toString(16).padStart(2, 0) + byteArr[10].toString(16).padStart(2, 0);
          break;
        }
        case 0x0c2f: {
          cmd.commandName = "reportBypassStatus"
          cmd.bypass = byteArr[6];
          break;
        }
        case 0x0c30: {
          cmd.commandName = "daliCtlReportUpdateFirmwareStart";
          break;
        }
        case 0x0c31: {
          cmd.commandName = "daliCtlReportDisableDtk";
          cmd.disableDtk = byteArr[6];
          break;
        }
        case 0x0c80: {
          cmd.commandName = "daliCtlReportDtkInfo";
          cmd.dtkType = byteArr[6];
          cmd.dtkPanID = str.substring(14, 18);
          cmd.dtkChannel = byteArr[9];
          cmd.dtkTransferMode = byteArr[10];
          cmd.dtkAdd = str.substring(22, 26);
          cmd.loraParameter = byteArr[13];
          cmd.dtkInternalAdd = str.substring(28, 32);
          break;
        } //daliCtl ReportDtkInfo
        case 0x0c81: {
          cmd.commandName = "daliCtlReportDtkType";
          cmd.dtkType = byteArr[6];
          break;
        } //daliCtl ReportDtkType
        case 0x0c82: {
          cmd.commandName = "daliCtlReportDtkPanID";
          cmd.dtkPanID = str.substring(12, 16);
          break;
        } //daliCtl ReportDtkPanID
        case 0x0c83: {
          cmd.commandName = "daliCtlReportDtkChannel";
          cmd.dtkChannel = byteArr[6];
          break;
        } //daliCtl ReportDtkChannel
        case 0x0c84: {
          cmd.commandName = "daliCtlReportDtkTransferMode";
          cmd.dtkTransferMode = byteArr[6];
          break;
        } //daliCtl ReportDtkTransferMode
        case 0x0c85: {
          cmd.commandName = "daliCtlReportDtkDefinedAdd";
          cmd.dtkAdd = str.substring(12, 16);
          break;
        } //daliCtl ReportDtkDefinedAdd
        case 0x0c86: {
          cmd.commandName = "daliCtlReportDtkLoraParameter";
          cmd.loraParameter = byteArr[6];
          break;
        } //daliCtl ReportDtkLoraParameter
        case 0x0c87: {
          cmd.commandName = "daliCtlReportDtkInternalAdd";
          cmd.internalAdd = str.substring(12, 16);
          break;
        } //daliCtl ReportDtkInternalAdd
        case 0x0c88: {
          cmd.commandName = "daliReportChangeDtkInfoFail"
          break;
        }
        case 0x0c89: {
          cmd.commandName = "daliCtlReportDtkBaudrateCode";
          cmd.baudrateCode = byteArr[6];
        } //daliCtl ReportDtk baudrateCode
        case 0x0ca0: {
          cmd.commandName = "daliCtlReportMeshMacAddress";
          cmd.meshMacAddressArray = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11],];
          cmd.meshMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        } //daliCtl ReportMeshMacAddress
        case 0x0ca1: {
          cmd.commandName = "daliCtlReportMeshInfo";
          cmd.meshChannel = byteArr[6];
          cmd.meshFreq = byteArr[7];
          cmd.meshSpeed = byteArr[8];
          cmd.meshPower = byteArr[9];
          cmd.meshEnableRepeat = byteArr[10];
          break;
        } //daliCtl ReportMeshInfo
        case 0x0ca2: {
          cmd.commandName = "daliCtlReportMeshChannel";
          cmd.meshChannel = byteArr[6];
          break;
        } //daliCtl ReportMeshChannel
        case 0x0ca3: {
          cmd.commandName = "daliCtlReportMeshFreq";
          cmd.meshFreq = byteArr[6];
          break;
        } //daliCtl ReportMeshFreq
        case 0x0ca4: {
          cmd.commandName = "daliCtlReportMeshSpeed";
          cmd.meshSpeed = byteArr[6];
          break;
        } //daliCtl ReportMeshSpeed
        case 0x0ca5: {
          cmd.commandName = "daliCtlReportMeshPower";
          cmd.meshPower = byteArr[6];
          break;
        } //daliCtl ReportMeshPower
        case 0x0ca6: {
          cmd.commandName = "daliCtlReportMeshNetworkID";
          cmd.meshNetworkID = byteArr[6].toString(16).padStart(2, 0) + byteArr[7].toString(16).padStart(2, 0) + byteArr[8].toString(16).padStart(2, 0);
          break;
        } //daliCtl ReportMeshNetworkID
        case 0x0ca7: {
          cmd.commandName = "daliCtlReportMeshDefindAdd";
          cmd.meshDefinedAdd = (byteArr[6] << 8) | byteArr[7];
          break;
        } //daliCtl ReportMeshDefindAdd
        case 0x0ca8: {
          cmd.commandName = "daliCtlReportEnableRepeat";
          cmd.meshEnableRepeat = byteArr[6];
          break;
        } //daliCtl ReportEnableRepeat
        case 0x0ca9: {
          cmd.commandName = "daliCtlReportChangeMeshInfoFail";
          break;
        } //daliCtl ReportMeshBaudrate
        case 0x0e01: {
          cmd.commandName = "pointToPointPing";
          cmd.sourceDtkAdd = str.substring(12, 16);
          break;
        } //pointToPointPing
        case 0x0e02: {
          cmd.commandName = "pointToPointPong";
          cmd.sourceDtkAdd = str.substring(12, 16);
          if (cmd.dtkAdd == "0000")
            cmd.dtkAdd = cmd.sourceDtkAdd
          break;
        } //pointToPointPong
        case 0x0e03: {
          cmd.commandName = "espBroadcastSend";
          cmd.sourceDtkAdd = str.substring(12, 16);
          break;
        } //helloEspNow
        case 0x0e04: {
          const commandStartIndex = 6
          const commandEndIndex = byteArr.length - byteArr[byteArr.length - 3] * 7 - parseInt(byteArr[byteArr.length - 3] / 7) - 2 - 2
          const dtkAdd = str.substring(4, 8)
          const command = str.substring(commandStartIndex * 2, commandEndIndex * 2)
          let fullcommnadStr = "f0" + (command.length / 2 + 2).toString(16).padStart(2, 0) + dtkAdd + command;
          fullcommnadStr = fullcommnadStr + this.getChecksum_dtk(fullcommnadStr) + "ff";
          cmd = { ...this.dtKStrToJson(fullcommnadStr) }
          break;
        }
        case 0x0e06: {
          cmd.commandName = "reclaimDelayList";
          cmd.sourceDtkAdd = str.substring(12, 16);
          // cmd.sourceMacAddress = byteArr[6];
          cmd.sourceMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          //byteArr[6]
          let len = `${byteArr[1].toString(16).padStart(2, 0)}`
          let macNum = (parseInt(len, 16) - 4) / 7;
          cmd.macNum = macNum;
          let macDistancePairs = {};
          // let i = 2;
          for (let i = 0; i < macNum; i++) {
            let mac = `${byteArr[6 + i * 7].toString(16).padStart(2, 0)}${byteArr[7 + i * 7].toString(16).padStart(2, 0)}${byteArr[8 + i * 7].toString(16).padStart(2, 0)}${byteArr[9 + i * 7].toString(16).padStart(2, 0)}${byteArr[10 + i * 7].toString(16).padStart(2, 0)}${byteArr[11 + i * 7].toString(16).padStart(2, 0)}`;
            let distance = `${byteArr[12 + i * 7].toString(16).padStart(2, 0)}`;

            // if (parseInt(distance, 16) >= 254) continue;
            const distanceNum = this.unmapDelay(parseInt(distance, 16));
            macDistancePairs[mac.toString()] = distanceNum;
          }
          cmd.macDistancePairs = macDistancePairs;
          // await redis.set(`data_dtkAdd_${dtkAdd}_mac_${sourceMacAddress}`, macDistancePairs)
          break;
        } //reclaimDelayList
        case 0x0e07: {
          cmd.commandName = "commandToGateway";
          const head = str.substring(0, 2)
          let hexStr = str.substring(2, 4);
          let decValue = parseInt(hexStr, 16);
          // console.log(decValue - 9);
          // console.log(Number(str.substring(2, 4)) - 9);
          const len = decValue - 9
          cmd.originMac = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}${byteArr[12].toString(16).padStart(2, 0)}`;
          const originCommand = head + len.toString(16).padStart(2, "0") + str.substring(4, 8) + str.substring(26, str.length - 4)
          const checkSum = this.getChecksum_dtk(originCommand)
          // console.log(originCommand);
          return this.dtKStrToJson(originCommand + checkSum + "ff")
          break;
        } //commandToGateway
        // case 0x0e08: {
        //   cmd.commandName = "receivedResponse";
        //   cmd.sourceMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}`;
        //   break;
        // }
        case 0x0e84: {
          cmd.commandName = "setMacUsability";
          cmd.espDtkAdd = `${byteArr[2].toString(16).padStart(2, 0)}${byteArr[3].toString(16).padStart(2, 0)}`;
          let ffCheck = byteArr[12];
          let sourceMacAddressBytes = [byteArr[6], byteArr[7], byteArr[8], byteArr[9], byteArr[10], byteArr[11]];
          let revealMac = this.revealFF(sourceMacAddressBytes, ffCheck);
          cmd.objectMac = revealMac;
          // cmd.objectMac = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}${byteArr[12].toString(16).padStart(2, 0)}`;
          cmd.connect = `${byteArr[13].toString(16).padStart(2, 0)}`
          cmd.channel = `${byteArr[14].toString(16).padStart(2, 0)}`
          const delaystr = `${byteArr[15].toString(16).padStart(2, 0)}`
          cmd.delay = this.unmapDelay(parseInt(delaystr, 16));
          cmd.connectionQuality = `${byteArr[16].toString(16).padStart(2, 0)}`
          break;
        }
        case 0x0f02: {
          cmd.commandName = "reportPingCount"
          cmd.count = byteArr[6] << 8 | byteArr[7]
          break;
        }
        // ED head, Gateway to General: 0000-00fc
        // ED head,  Gateway to Light:0200-03fc
        // ED head,  Gateway to Sensor: 0600-07fc
        // ED head,  Gateway to DaliCtl: 0a00-0bfc
        case 0x0201: {
          cmd.commandName = "requestCurrentData";
          break;
        } //light requestCurrentData
        case 0x0202: {
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.pwm = byteArr[8];
          cmd.commandName = "controlA";
          break;
        } //light controlA
        case 0x0203: {
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.pwm = byteArr[8];
          cmd.delayedPwm = byteArr[9];
          cmd.delaySec = (byteArr[10] << 8) + byteArr[11];
          cmd.delayed_action = cmd.delaySec;
          cmd.commandName = "controlADelay";
          break;
        } //light controlADelay
        case 0x0204: {
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.pwm = byteArr[8];
          cmd.delayedPwm = byteArr[9];
          cmd.delaySec = (byteArr[10] << 8) + byteArr[11];
          cmd.delayed_action = cmd.delaySec;
          cmd.delayedPwm2 = byteArr[12];
          cmd.delaySec2 = (byteArr[13] << 8) + byteArr[14];
          cmd.delayed_action2 = cmd.delaySec2;
          cmd.commandName = "controlADelay2";
          break;
        } //light controlADelay2
        case 0x0205: {
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.commandName = "controlAReverse";
          break;
        } //light controlAReverse
        case 0x0206: {
          cmd.onoffcontrolL = byteArr[6];
          cmd.commandName = "controlL";
          break;
        } //light controlL
        case 0x0207: {
          cmd.commandName = "startSettingToLight";
          cmd.typeByte = byteArr[6];
          cmd.enableA = (cmd.typeByte >> 0) & 1;
          cmd.enableL = (cmd.typeByte >> 1) & 1;
          cmd.enableBatVI = (cmd.typeByte >> 2) & 1;
          cmd.enableDim = (cmd.typeByte >> 3) & 1;
          cmd.reverseA = (cmd.typeByte >> 4) & 1;
          cmd.cutDimOnBypass = (cmd.typeByte >> 5) & 1;
          cmd.enableMotion = (cmd.typeByte >> 6) & 1;
          cmd.dimTransition = byteArr[7];
          cmd.dimTransitON = byteArr[8];
          cmd.dimTransitOFF = byteArr[9];
          cmd.survival_time_interval = byteArr[10];
          cmd.regular_time_interval = byteArr[11];
          cmd.gatewayAdd0 = byteArr[12];
          cmd.gatewayAdd1 = byteArr[13];
          break;
        } //light startSettingToLight
        case 0x0235: {
          cmd.commandName = "lightStepDim";
          cmd.stepUp = byteArr[6] === 0x33 ? true : false;
          cmd.lockLevel = byteArr[7];
          cmd.releaseOnDelayEnd = byteArr[8];
          cmd.dimStepSize = byteArr[9];
          break;
        } //lightStepDim
        case 0x0601: {
          cmd.commandName = "requestCurrentData";
          break;
        } //requestCurrentData
        case 0x0602: {
          cmd.commandName = "disabledSensor";
          cmd.disabledSensor = byteArr[6] === 0x33 ? true : false;
          break;
        } //sensor disabledSensor
        case 0x0603: {
          cmd.commandName = "motionStartSetting";
          cmd.survival_time_interval = byteArr[6];
          cmd.regular_time_interval = byteArr[7];
          cmd.sensorMode = byteArr[8];
          cmd.disabledSensor = byteArr[9] === 0x33 ? 1 : 0;
          cmd.hasIR = byteArr[10] === 0x33 ? 1 : 0;
          cmd.delaySec = (byteArr[11] << 8) + byteArr[12];
          cmd.delaySec2 = (byteArr[13] << 8) + byteArr[14];
          cmd.sensorDist = byteArr[15];
          cmd.gatewayAdd0 = byteArr[16];
          cmd.gatewayAdd1 = byteArr[17];
          break;
        } //motionStartSetting
        case 0x0604: {
          cmd.commandName = "daylightStartSetting";
          cmd.survival_time_interval = byteArr[6];
          cmd.regular_time_interval = byteArr[7];
          cmd.disabledSensor = byteArr[8] === 0x33 ? 1 : 0;
          cmd.gatewayAdd0 = byteArr[9];
          cmd.gatewayAdd1 = byteArr[10];
          break;
        } //daylightStartSetting

        case 0x0605: {
          cmd.commandName = "lightSwitchStartSetting";
          cmd.survival_time_interval = byteArr[6];
          cmd.regular_time_interval = byteArr[7];
          cmd.disabledSensor = byteArr[8] === 0x33 ? 1 : 0;
          cmd.gang = byteArr[9];
          cmd.btn1Pin = byteArr[10];
          cmd.btn2Pin = byteArr[11];
          cmd.btn3Pin = byteArr[12];
          cmd.btn4Pin = byteArr[13];
          cmd.gatewayAdd0 = byteArr[14];
          cmd.gatewayAdd1 = byteArr[15];
          break;
        } //lightSwitchStartSetting
        case 0x0606: {
          cmd.commandName = "daylightmotionStartSetting";
          cmd.survival_time_interval = byteArr[6];
          cmd.regular_time_interval = byteArr[7];
          break;
        } //daylightmotionStartSetting
        case 0x0607: {
          cmd.commandName = "scenebuttonStartSetting";
          cmd.survival_time_interval = byteArr[6];
          cmd.regular_time_interval = byteArr[7];
          cmd.disabledSensor = byteArr[8] === 0x33 ? 1 : 0;
          cmd.gang = byteArr[9];
          cmd.btn1Pin = byteArr[10];
          cmd.btn2Pin = byteArr[11];
          cmd.btn3Pin = byteArr[12];
          cmd.btn4Pin = byteArr[13];
          cmd.gatewayAdd0 = byteArr[14];
          cmd.gatewayAdd1 = byteArr[15];
          break;
        } //scenebuttonStartSetting
        case 0x0608: {
          cmd.commandName = "restartSystem";
          break;
        } //restartSystem
        case 0x0609: {
          cmd.commandName = "acknowledgeReceiveCommand";
          cmd.replyCommandCode = (byteArr[6] << 8) + byteArr[7];
          break;
        } //acknowledgeReceiveCommand
        case 0x060a: {
          cmd.commandName = "updateFirmware";
          cmd.updateSpiffs = byteArr[6] === 0x33 ? true : false;
          break;
        } //updateFirmware
        case 0x060b: {
          cmd.commandName = "changeOtaSsid";
          cmd.otaSsid = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        } //changeOtaSsid
        case 0x060c: {
          cmd.commandName = "changeOtaPassword";
          cmd.otaPassword = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        } //changeOtaPassword
        case 0x060d: {
          cmd.commandName = "changeSensorType";
          cmd.sensorType = byteArr[6];
          const typeNameMenu = ["motion", "daylight", "lightswitch", "daylightmotion", "scenebutton", "dimcontroller"];
          cmd.sensorTypeName = typeNameMenu[cmd.sensorType];
          break;
        } //changeSensorType
        case 0x060e: {
          cmd.commandName = "changeSensorDist";
          cmd.sensorDist = byteArr[6];
          break;
        } //changeSensorDist
        case 0x060f: {
          cmd.commandName = "changeSensorMode";
          cmd.sensorMode = byteArr[6];
          break;
        } //changeSensorMode
        case 0x0610: {
          cmd.commandName = "changeHasIR";
          cmd.hasIR = byteArr[6] === 0x33 ? true : false;
          break;
        } //changeHasIR
        case 0x0611: {
          cmd.commandName = "sensorChangeDisabledSensor";
          cmd.disabledSensor = byteArr[6] === 0x33 ? 1 : 0;
          break;
        } //sensorChangeDisabledSensor
        case 0x0612: {
          cmd.commandName = "sensorChangeDisabledLux";
          cmd.disabledLux = byteArr[6] === 1 ? true : false;
          break;
        } //sensorChangeDisabledLux
        case 0x0613: {
          cmd.commandName = "sensorChangeDisabledMotion";
          cmd.disabledMotion = byteArr[6] === 1 ? true : false;
          break;
        } //sensorChangeDisabledMotion
        case 0x062c: {
          cmd.commandName = "enableSensorWithDelay";
          cmd.delaySec = (byteArr[6] << 8) + byteArr[7];
          break;
        } // enableSensorWithDelay
        case 0x062d: {
          cmd.commandName = "disableSensorWithDelay";
          cmd.delaySec = (byteArr[6] << 8) + byteArr[7];
          break;
        } //disableSensorWithDelay
        case 0x0a09: {
          cmd.commandName = "daliCtlControlSingleLight";
          cmd.shortAdd = byteArr[6];
          cmd.pwm = byteArr[7];
          cmd.lockLevel = byteArr[8];
          cmd.delayedPwm = byteArr[9];
          cmd.delaySec = (byteArr[10] << 8) + byteArr[11];
          cmd.delayed_action = cmd.delaySec;
          cmd.delayedPwm2 = byteArr[12];
          cmd.delaySec2 = (byteArr[13] << 8) + byteArr[14];
          cmd.delayed_action2 = cmd.delaySec2;
          cmd.releaseOnDelayEnd = byteArr[15];
          break;
        } //daliCtlControlSingleLight
        case 0x0a19: {
          cmd.commandName = "daliCtlControlMultiLight_noDelay";
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.lightLvAry = [];
          const lightQty = byteLength - 10;
          for (let i = 0; i < lightQty; i++) {
            cmd.lightLvAry[i] = byteArr[8 + i];
          } //ed 0a 62 6f 0a 19 04 00 65 64 65 64 81 ff
          break;
        } //daliCtlControlMultiLight_noDelay
        case 0x0a1a: {
          cmd.commandName = "daliCtlControlMultiLight_1Delay";
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.delaySec = (byteArr[8] << 8) + byteArr[9];
          cmd.lightLvAry = [];
          cmd.D1LightLvAry = [];
          const lightQty = (byteLength - 12) / 2;
          for (let i = 0; i < lightQty; i++) {
            cmd.lightLvAry[i] = byteArr[10 + i];
            cmd.D1LightLvAry[i] = byteArr[10 + lightQty + i];
          } //ed 0a 62 6f 0a 1a 04 00 00 13 65 64 65 64 65 64 65 64 81 ff
          break;
        } //daliCtlControlMultiLight_1Delay
        case 0x0a1b: {
          cmd.commandName = "daliCtlControlMultiLight_2Delay";
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.delaySec = (byteArr[8] << 8) + byteArr[9];
          cmd.delaySec2 = (byteArr[10] << 8) + byteArr[11];
          cmd.lightLvAry = [];
          cmd.D1LightLvAry = [];
          cmd.D2LightLvAry = [];
          const lightQty = (byteLength - 14) / 3;
          for (let i = 0; i < lightQty; i++) {
            cmd.lightLvAry[i] = byteArr[12 + i];
            cmd.D1LightLvAry[i] = byteArr[12 + lightQty + i];
            cmd.D2LightLvAry[i] = byteArr[12 + (lightQty * 2) + i];
          } //ed 0a 62 6f 0a 1b 04 00 00 13 00 17 65 64 65 64 65 64 65 64 65 64 65 64 81 ff
          break;
        } //daliCtlControlMultiLight_2Delay
        case 0x0a33: {
          cmd.commandName = "daliCtlMultiLightStepDim";
          cmd.stepUp = byteArr[6] === 0x33 ? true : false;
          cmd.lockLevel = byteArr[7];
          cmd.releaseOnDelayEnd = byteArr[8];
          cmd.dimStepSize = byteArr[9];
          cmd.shortAddAry = [];
          const lightQty = byteLength - 12;
          for (let i = 0; i < lightQty; i++) {
            cmd.shortAddAry[i] = byteArr[10 + i];
          } //ed 0a 62 6f 0a 33 33 04 00 05 65 64 65 64 81 ff
          break;
        } //daliCtlMultiLightStepDim
        case 0x0a34: {
          cmd.commandName = "daliCtlMultiLightToggle";
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.shortAddAry = [];
          const lightQty = byteLength - 10;
          for (let i = 0; i < lightQty; i++) {
            cmd.shortAddAry[i] = byteArr[8 + i];
          } //ed 0a 62 6f 0a 34 04 00 65 64 65 64 81 ff
          break;
        } //daliCtlMultiLightToggle
        case 0x0a35: {
          cmd.commandName = "daliSingleLightStepDim";
          cmd.shortAdd = byteArr[6];
          cmd.stepUp = byteArr[7] === 0x33 ? true : false;
          cmd.lockLevel = byteArr[8];
          cmd.releaseOnDelayEnd = byteArr[9];
          cmd.dimStepSize = byteArr[10];
          break;
        } //daliSingleLightStepDim
        case 0x0a36: {
          cmd.commandName = "daliSingleLightToggle";
          cmd.shortAdd = byteArr[6];
          cmd.lockLevel = byteArr[7];
          cmd.releaseOnDelayEnd = byteArr[8];
          break;
        } //daliSingleLightToggle
        case 0x0a37: {
          cmd.commandName = "daliCtlStartFlashLight";
          break;
        } //daliCtlStartFlashLight
        case 0x0a38: {
          cmd.commandName = "daliCtlStopFlashLight";
          break;
        } //daliCtlStopFlashLight
        case 0x0a39: {
          cmd.commandName = "daliCtlControlMultiLight_noDelay";
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.lightLvAry = [];
          const lightQty = byteLength - 10;
          for (let i = 0; i < lightQty; i++) {
            cmd.lightLvAry[i] = byteArr[8 + i];
          }
          break;
        } //daliCtlControlMultiLight_noDelay - send in one command
        case 0x0a3a: {
          cmd.commandName = "daliCtlControlMultiLight_1Delay";
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.delaySec = (byteArr[8] << 8) + byteArr[9];
          cmd.lightLvAry = [];
          cmd.D1LightLvAry = [];
          const lightQty = (byteLength - 12) / 2;
          for (let i = 0; i < lightQty; i++) {
            cmd.lightLvAry[i] = byteArr[10 + i];
            cmd.D1LightLvAry[i] = byteArr[10 + lightQty + i];
          }
          break;
        } //daliCtlControlMultiLight_1Delay - send in one command
        case 0x0a3b: {
          cmd.commandName = "daliCtlControlMultiLight_2Delay";
          cmd.lockLevel = byteArr[6];
          cmd.releaseOnDelayEnd = byteArr[7];
          cmd.delaySec = (byteArr[8] << 8) + byteArr[9];
          cmd.delaySec2 = (byteArr[10] << 8) + byteArr[11];
          cmd.lightLvAry = [];
          cmd.D1LightLvAry = [];
          cmd.D2LightLvAry = [];
          const lightQty = (byteLength - 14) / 3;
          for (let i = 0; i < lightQty; i++) {
            cmd.lightLvAry[i] = byteArr[12 + i];
            cmd.D1LightLvAry[i] = byteArr[12 + lightQty + i];
            cmd.D2LightLvAry[i] = byteArr[12 + (lightQty * 2) + i];
          }
          break;
        } //daliCtlControlMultiLight_2Delay - send in one command
        case 0x0a3d: {
          cmd.commandName = "daliCtlSaveGroupAction";
          cmd.groupID = str.substring(12, 20);
          cmd.settingNum = byteArr[10];
          cmd.command = str.substring(22, str.length - 4);
          break;
        } //daliCtlSaveGroupAction
        case 0x0a3e: {
          cmd.commandName = "daliCtlDeleteGroupAction";
          cmd.groupID = str.substring(12, 20);
          cmd.settingNum = byteArr[10];
          break;
        } //daliCtlDeleteGroupAction
        case 0x0a3f: {
          cmd.commandName = "daliCtlExecuteGroupAction";
          cmd.groupID = str.substring(12, 20);
          cmd.settingNum = byteArr[10];
          break;
        } //daliCtlExecuteGroupAction
        case 0x0a40: {
          cmd.commandName = "daliCtlDeleteAllGroupAction";
          break;
        } //daliCtlDeleteAllGroupAction
        case 0x0a41: {
          cmd.commandName = "daliCtlControlARelay";
          cmd.controlA = byteArr[6];
          break;
        } //daliCtlControlARelay
        case 0x0a42: {
          cmd.commandName = "daliCtlControlBRelay";
          cmd.controlB = byteArr[6];
          break;
        } //daliCtlControlBRelay
        case 0x0a43: {
          cmd.commandName = "daliCtlControlDRelay";
          cmd.controlD = byteArr[6];
          break;
        } //daliCtlControlDRelay
        case 0x0a44: {
          cmd.commandName = "changeGeneralDaliParameter";
          cmd.shortAdd = byteArr[6];
          cmd.changeCmdNum = byteArr[7];
          cmd.value = byteArr[8];
          cmd.queryCmdNum = byteArr[9];
          break;
        } //changeGeneralDaliParameter
        case 0x0a45: {
          cmd.commandName = "daliCtlReportDisableDtk";
          cmd.disableDtk = byteArr[6];
          break;
        } //daliCtlReportDisableDtk
        /////////esp internal command///////////
        case 0x1101: {
          cmd.commandName = "ESPInternalReportCheckConnection";
          break;
        } //ESPInternalReportCheckConnection
        case 0x1102: {
          cmd.commandName = "ESPInternalReportMacAddress";
          const check_ff = byteArr[12];
          if (check_ff != 0) {
            const str = check_ff.toString(2).padStart(6, "0");
            for (let i = 0; i < 6; i++) {
              if (str[i] == 1) {
                byteArr[6 + (5 - i)] = 0xff;
              }
            }
          }
          cmd.macAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        } //ESPInternalReportMacAddress
        case 0x1103: {
          cmd.commandName = "ESPInternalReportVersion";
          const version = String.fromCharCode(byteArr[6]) + String.fromCharCode(byteArr[7]) + String.fromCharCode(byteArr[8]) + String.fromCharCode(byteArr[9]);
          cmd.version = version;
          break;
        } //ESPInternalReportVersion
        case 0x1104: {
          cmd.commandName = "ESPInternalReportESPBadMessageFromGW";
          break;
        } //reportESPBadMessageFromGW
        case 0x1105: {
          cmd.commandName = "ESPInternalReportUpdateFirmwareStatus";
          cmd.statusCode = byteArr[6];
          break;
        }//reportUpdateFirmwareStatus
        case 0x1111: {
          cmd.commandName = "ESPInternalReportOtaSsid"
          cmd.otaSsid = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        }//reportOtaSsid
        case 0x1112: {
          cmd.commandName = "ESPInternalReportOtaPassword"
          cmd.otaPassword = String.fromCharCode(...byteArr.slice(6, byteLength - 2));
          break;
        }
        case 0x1116: {
          cmd.commandName = "reportDtkAddByMacAddress"
          const macAddressAry = byteArr.slice(6, 12);
          cmd.macAddress = this.revealFF(macAddressAry, byteArr[12]);
          cmd.dtkAdd = `${byteArr[13].toString(16).padStart(2, 0)}${byteArr[14].toString(16).padStart(2, 0)}`;
          break;
        }
        case 0x1117: {
          cmd.commandName = "esp32IsHungry"

          break;
        }
        case 0x1108: {
          cmd.commandName = "espNowMasterStart"
          const check_ff = byteArr[12];
          if (check_ff != 0) {
            const str = check_ff.toString(2).padStart(6, "0");
            for (let i = 0; i < 6; i++) {
              if (str[i] == 1) {
                byteArr[6 + (5 - i)] = 0xff;
              }
            }
          }
          cmd.macAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7]
            .toString(16)
            .padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9]
              .toString(16)
              .padStart(2, 0)}${byteArr[10]
                .toString(16)
                .padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          const version = String.fromCharCode(byteArr[13]) + String.fromCharCode(byteArr[14]) + String.fromCharCode(byteArr[15]) + String.fromCharCode(byteArr[16]);
          cmd.version = version;
          break;
        }//espNowMasterStart
        case 0x110a: {
          cmd.commandName = " reportSystemInfo"
          cmd.totalRAM = byteArr[6] << 24 | byteArr[7] << 16 | byteArr[8] << 8 | byteArr[9];
          cmd.freeRAM = byteArr[10] << 24 | byteArr[11] << 16 | byteArr[12] << 8 | byteArr[13];
          cmd.flashSize = byteArr[14] << 24 | byteArr[15] << 16 | byteArr[16] << 8 | byteArr[17];
          cmd.totalStorage = byteArr[18] << 24 | byteArr[19] << 16 | byteArr[20] << 8 | byteArr[21];
          cmd.usedStorage = byteArr[22] << 24 | byteArr[23] << 16 | byteArr[24] << 8 | byteArr[25];
          cmd.coreTemperature = byteArr[26];
          if (cmd.coreTemperature > 127) {
            cmd.temperature -= 256;
          }

          break;
        }// reportSystemInfo
        ///////////255 internal command///////////
        case 0x4349: {
          cmd.commandName = "report255Module";
          let len = byteArr[4];
          cmd.mesh255_version = (byteArr[5] << 8) + byteArr[6];
          let pointer = 7;
          for (let i = pointer; i < len; i++) {
            if (byteArr[i] == 0x00) {
              pointer = i + 1;
              break;
            }
            cmd.mesh255_module_name = cmd?.mesh255_module_name ? cmd.mesh255_module_name + String.fromCharCode(byteArr[i]) : String.fromCharCode(byteArr[i]);
          }
          cmd.mesh255_hardward_version = (byteArr[pointer] << 16) + (byteArr[pointer + 1] << 8) + byteArr[pointer + 2];
          cmd.mesh255_ID = `${byteArr[pointer + 3].toString(16).padStart(2, 0)}${byteArr[pointer + 4].toString(16).padStart(2, 0)}${byteArr[pointer + 5].toString(16).padStart(2, 0)}${byteArr[pointer + 6].toString(16).padStart(2, 0)}${byteArr[pointer + 7].toString(16).padStart(2, 0)}${byteArr[pointer + 8].toString(16).padStart(2, 0)}`;
          break;
        } //report255Module
        case 0x5200: {
          cmd.commandName = "report255Power";
          cmd.meshPower = this.bin2dec(`${this.bitRead(byteArr[6], 7)}${this.bitRead(byteArr[6], 6)}${this.bitRead(byteArr[6], 5)}`);
          cmd.meshRepeat_enable = this.bin2dec(`${this.bitRead(byteArr[6], 4)}`); //default 1
          cmd.meshCom_enable = this.bin2dec(`${this.bitRead(byteArr[6], 3)}`); //default 1
          cmd.meshSleep_enable = this.bin2dec(`${this.bitRead(byteArr[6], 2)}`); //default 0
          cmd.meshOffset00_reserved_1 = this.bin2dec(`${this.bitRead(byteArr[6], 1)}`);
          cmd.meshOffset00_reserved_0 = this.bin2dec(`${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255Power
        case 0x5700: {
          cmd.commandName = "report255PowerChangeSuccess";
          cmd.meshPower = this.bin2dec(`${this.bitRead(byteArr[6], 7)}${this.bitRead(byteArr[6], 6)}${this.bitRead(byteArr[6], 5)}`);
          cmd.meshRepeat_enable = this.bin2dec(`${this.bitRead(byteArr[6], 4)}`); //default 1
          cmd.meshCom_enable = this.bin2dec(`${this.bitRead(byteArr[6], 3)}`); //default 1
          cmd.meshSleep_enable = this.bin2dec(`${this.bitRead(byteArr[6], 2)}`); //default 0
          cmd.meshOffset00_reserved_1 = this.bin2dec(`${this.bitRead(byteArr[6], 1)}`);
          cmd.meshOffset00_reserved_0 = this.bin2dec(`${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255PowerChangeSuccess
        case 0x5201: {
          cmd.commandName = "report255Delimiter";
          cmd.meshDelimiter_end_enable = this.bin2dec(`${this.bitRead(byteArr[6], 5)}`); //default 0
          cmd.meshDelimiter_start_enable = this.bin2dec(`${this.bitRead(byteArr[6], 4)}`); //default 0
          cmd.meshExtended_head_enable = this.bin2dec(`${this.bitRead(byteArr[6], 2)}`); //default 0
          break;
        } //report255Delimiter
        case 0x5701: {
          cmd.commandName = "report255DelimiterChangeSuccess";
          cmd.meshDelimiter_end_enable = this.bin2dec(`${this.bitRead(byteArr[6], 5)}`); //default 0
          cmd.meshDelimiter_start_enable = this.bin2dec(`${this.bitRead(byteArr[6], 4)}`); //default 0
          cmd.meshExtended_head_enable = this.bin2dec(`${this.bitRead(byteArr[6], 2)}`); //default 0
          break;
        } //report255DelimiterChangeSuccess
        case 0x5204: {
          cmd.commandName = "report255ChannelBuatRate";
          cmd.meshChannel = this.bin2dec(`${this.bitRead(byteArr[6], 7)}${this.bitRead(byteArr[6], 6)}${this.bitRead(byteArr[6], 5)}${this.bitRead(byteArr[6], 4)}${this.bitRead(byteArr[6], 3)}`);
          cmd.meshBaudRate = this.bin2dec(`${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255ChannelBuatRate
        case 0x5704: {
          cmd.commandName = "report255ChannelBuatRateChangeSuccess";
          cmd.meshChannel = this.bin2dec(`${this.bitRead(byteArr[6], 7)}${this.bitRead(byteArr[6], 6)}${this.bitRead(byteArr[6], 5)}${this.bitRead(byteArr[6], 4)}${this.bitRead(byteArr[6], 3)}`);
          cmd.meshBaudRate = this.bin2dec(`${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255ChannelBuatRateChangeSuccess
        case 0x5205: {
          cmd.commandName = "report255ParityBitStopBit";
          cmd.meshParity = this.bin2dec(`${this.bitRead(byteArr[6], 7)}${this.bitRead(byteArr[6], 6)}`);
          cmd.meshStop = this.bin2dec(`${this.bitRead(byteArr[6], 5)}${this.bitRead(byteArr[6], 4)}`);
          break;
        } //report255ParityBitStopBit
        case 0x5705: {
          cmd.commandName = "report255ParityBitStopBitChangeSuccess";
          cmd.meshParity = this.bin2dec(
            `${this.bitRead(byteArr[6], 7)}${this.bitRead(byteArr[6], 6)}`
          );
          cmd.meshStop = this.bin2dec(
            `${this.bitRead(byteArr[6], 5)}${this.bitRead(byteArr[6], 4)}`
          );
          break;
        } //report255ParityBitStopBitChangeSuccess
        case 0x5206: {
          cmd.commandName = "report255DelimiterStart";
          cmd.meshDelimiter_start = byteArr[6];
          break;
        } //report255DelimiterStart
        case 0x5706: {
          cmd.commandName = "report255DelimiterStartChangeSuccess";
          cmd.meshDelimiter_start = byteArr[6];
          break;
        } //report255DelimiterStartChangeSuccess
        case 0x5207: {
          cmd.commandName = "report255DelimiterEnd";
          cmd.meshDelimiter_end = byteArr[6];
          break;
        } //report255DelimiterEnd
        case 0x5707: {
          cmd.commandName = "report255DelimiterEndChangeSuccess";
          cmd.meshDelimiter_end = byteArr[6];
          break;
        } //report255DelimiterEndChangeSuccess
        case 0x520c: {
          cmd.commandName = "report255MacAddress";
          if (byteLength < 12) cmd.meshMacAddress = "";
          else
            cmd.meshMacAddress = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}${byteArr[9].toString(16).padStart(2, 0)}${byteArr[10].toString(16).padStart(2, 0)}${byteArr[11].toString(16).padStart(2, 0)}`;
          break;
        } //report255MacAddress
        case 0x5212: {
          cmd.commandName = "report255NetworkID";
          if (byteArr[6] != undefined && byteArr[7] != undefined && byteArr[8] != undefined)
            cmd.meshNetworkID = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}`;
          break;
        } //report255NetworkID
        case 0x5712: {
          cmd.commandName = "report255NetworkIDChangeSuccess";
          if (byteArr[6] != undefined && byteArr[7] != undefined && byteArr[8] != undefined)
            cmd.meshNetworkID = `${byteArr[6].toString(16).padStart(2, 0)}${byteArr[7].toString(16).padStart(2, 0)}${byteArr[8].toString(16).padStart(2, 0)}`;
          break;
        } //report255NetworkIDChangeSuccess
        case 0x5215: {
          cmd.commandName = "report255DelimiterExtend";
          cmd.meshDelimiter_extend = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshDelimiter_extend = cmd.meshDelimiter_extend + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255DelimiterExtend
        case 0x5715: {
          cmd.commandName = "report255DelimiterExtendChangeSuccess";
          cmd.meshDelimiter_extend = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshDelimiter_extend = cmd.meshDelimiter_extend + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255DelimiterExtendChangeSuccess
        case 0x521a: {
          cmd.commandName = "report255AsyncSleepTime";
          cmd.meshAsyncSleepTime = byteArr[6];
          break;
        } //report255AsyncSleepTime
        case 0x521a: {
          cmd.commandName = "report255AsyncSleepTimeChangeSuccess";
          cmd.meshAsyncSleepTime = byteArr[6];
          break;
        } //report255AsyncSleepTimeChangeSuccess
        case 0x521c: {
          cmd.commandName = "report255syncSleepTime";
          cmd.meshSyncSleepTime = byteArr[6];
          break;
        } //report255syncSleepTime
        case 0x571c: {
          cmd.commandName = "report255syncSleepTimeChangeSuccess";
          cmd.meshSyncSleepTime = byteArr[6];
          break;
        } //report255syncSleepTimeChangeSuccess
        case 0x521d: {
          cmd.commandName = "report255Repeater";
          cmd.meshRepeater = byteArr[6]; //255 is not repeat
          break;
        } //report255Repeater
        case 0x571d: {
          cmd.commandName = "report255RepeaterChangeSuccess";
          cmd.meshRepeater = byteArr[6]; //255 is not repeat
          break;
        } //report255RepeaterChangeSuccess
        case 0x521e: {
          cmd.commandName = "report255HandshakeLength";
          cmd.meshHandshakeLength = this.bin2dec(`${this.bitRead(byteArr[6], 3)}${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255HandshakeLength
        case 0x571e: {
          cmd.commandName = "report255HandshakeLengthChangeSuccess";
          cmd.meshHandshakeLength = this.bin2dec(`${this.bitRead(byteArr[6], 3)}${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255HandshakeLengthChangeSuccess
        case 0x521f: {
          cmd.commandName = "report255Handshake";
          cmd.meshHandshake = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshHandshake = cmd.meshHandshake + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255Handshake
        case 0x571f: {
          cmd.commandName = "report255HandshakeChangeSuccess";
          cmd.meshHandshake = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshHandshake = cmd.meshHandshake + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255HandshakeChangeSuccess
        case 0x522e: {
          cmd.commandName = "report255Freq";
          cmd.meshOffset2E_reserved_7 = this.bin2dec(`${this.bitRead(byteArr[6], 7)}`);
          cmd.meshOffset2E_reserved_6 = this.bin2dec(`${this.bitRead(byteArr[6], 6)}`);
          cmd.meshFreq = this.bin2dec(`${this.bitRead(byteArr[6], 5)}${this.bitRead(byteArr[6], 4)}`);
          cmd.meshEmptyBufferLength = this.bin2dec(`${this.bitRead(byteArr[6], 3)}${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255Freq
        case 0x572e: {
          cmd.commandName = "report255FreqChangeSuccess";
          cmd.meshOffset2E_reserved_7 = this.bin2dec(`${this.bitRead(byteArr[6], 7)}`);
          cmd.meshOffset2E_reserved_6 = this.bin2dec(`${this.bitRead(byteArr[6], 6)}`);
          cmd.meshFreq = this.bin2dec(`${this.bitRead(byteArr[6], 5)}${this.bitRead(byteArr[6], 4)}`);
          cmd.meshEmptyBufferLength = this.bin2dec(`${this.bitRead(byteArr[6], 3)}${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255FreqChangeSuccess
        case 0x522f: {
          cmd.commandName = "report255EmptyBuffer";
          cmd.meshEmptyBuffer = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshEmptyBuffer = cmd.meshEmptyBuffer + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255EmptyBuffer
        case 0x572f: {
          cmd.commandName = "report255EmptyBufferChangeSuccess";
          cmd.meshEmptyBuffer = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshEmptyBuffer = cmd.meshEmptyBuffer + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255EmptyBufferChangeSuccess
        case 0x523e: {
          cmd.commandName = "report255Speed";
          cmd.meshSpeed = byteArr[6];
          break;
        } //report255Speed
        case 0x573e: {
          cmd.commandName = "report255SpeedChangeSuccess";
          cmd.meshSpeed = byteArr[6];
          break;
        } //report255SpeedChangeSuccess
        case 0x524e: {
          cmd.commandName = "report255SuccessPacketLength";
          cmd.meshSuccessPacketLength = this.bin2dec(`${this.bitRead(byteArr[6], 3)}${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255SuccessPacketLength
        case 0x574e: {
          cmd.commandName = "report255SuccessPacketLengthChangeSuccess";
          cmd.meshSuccessPacketLength = this.bin2dec(`${this.bitRead(byteArr[6], 3)}${this.bitRead(byteArr[6], 2)}${this.bitRead(byteArr[6], 1)}${this.bitRead(byteArr[6], 0)}`);
          break;
        } //report255SuccessPacketLengthChangeSuccess
        case 0x524f: {
          cmd.commandName = "report255SuccessPacket";
          cmd.meshSuccessPacket = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshSuccessPacket = cmd.meshSuccessPacket + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255SuccessPacket
        case 0x574f: {
          cmd.commandName = "report255SuccessPacketChangeSuccess";
          cmd.meshSuccessPacket = "";
          for (let i = 6; i < byteLength - 1; i++)
            cmd.meshSuccessPacket = cmd.meshSuccessPacket + `${byteArr[i].toString(16).padStart(2, 0)}`;
          break;
        } //report255SuccessPacketChangeSuccess
        case 0x062c: {
          cmd.commandName = "enableSensorWithDelay"
          cmd.delaySec = (byteArr[6] << 8) + byteArr[7];
          break;
        }
        case 0x062d: {
          cmd.commandName = "disableSensorWithDelay";
          cmd.delaySec = (byteArr[6] << 8) + byteArr[7];
          break;
        }
        default:
          return false;
      }
      return cmd;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
  jsonCommandToDtk(cmd) {
    const { dtkAdd, commandCode, broadcast } = cmd || {};
    const headByte = broadcast ? "f0" : "ed";
    let str = `${headByte}XX${dtkAdd}`;
    str += this.intToHexStr(commandCode, 2);
    let data;
    switch (commandCode) {
      // ED head,  Gateway to Light:0200-03fc
      // ED head,  Gateway to Sensor: 0600-07fc
      // ED head,  Gateway to DaliCtl: 0a00-0bfc
      case 0xfc01: //get dtk infomation

        str = `FC030144544B`;
        break;
      case 0xfc02:
        //get dtk infomation
        str = `FC030244544B`;
        break;
      case 0xfc03:
        //set dtk command
        str = `FCXX0344544BA5`;
        str += this.intToHexStr(cmd.dtkType);
        str += cmd.dtkPanID;
        str += this.intToHexStr(cmd.dtkChannel);
        str += this.intToHexStr(cmd.dtkTransferMode);
        str += cmd.dtkAdd;
        str += this.intToHexStr(cmd.reservedValue1, 2);
        str += this.intToHexStr(cmd.baudRate);
        str += this.intToHexStr(cmd.dataBit);
        str += this.intToHexStr(cmd.stopBit);
        str += this.intToHexStr(cmd.parityBit);
        str += "4Baa";
        str += this.intToHexStr(cmd.unNamed20);
        str += this.intToHexStr(cmd.slave_dtkType);
        str += cmd.dtkPanID;
        str += this.intToHexStr(cmd.dtkChannel);
        str += this.intToHexStr(cmd.slave_dtkTransferMode);
        str += cmd.dtkAdd;
        str += "4454";
        str += this.intToHexStr(cmd.slave_baudRate);
        str += this.intToHexStr(cmd.slave_dataBit);
        str += this.intToHexStr(cmd.slave_stopBit);
        str += this.intToHexStr(cmd.slave_parityBit);
        str += "4baa";
        str += "01";
        str += "01";
        str += "01";
        str += cmd.password;
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0xfc04:
        //restart dtk device
        str = `FC030444544B`;
        break;
      case 0xfc06:
        //get other dtk infomation thought lora
        str = `FC050644544B`;
        str += this.intToHexStr(cmd.dtkAdd, 2);
        break;
      case 0xfc07:
        //restart other dtk device thought lora
        str = `FC050744544B`;
        str += this.intToHexStr(cmd.dtkAdd, 2);
        break;
      case 0xfc08:
        //write other dtk infomation thought lora
        str = `FCXX0844544B`;
        str += this.intToHexStr(cmd.dtkAdd, 2);
        str += this.intToHexStr(cmd.dtkType);
        str += this.intToHexStr(cmd.dtkPanID, 2);
        str += this.intToHexStr(cmd.dtkChannel);
        str += this.intToHexStr(cmd.dtkTransferMode);
        str += this.intToHexStr(cmd.selfDesignedAdd, 2);
        str += this.intToHexStr(cmd.baudRate);
        str += this.intToHexStr(cmd.dataBit);
        str += this.intToHexStr(cmd.stopBit);
        str += this.intToHexStr(cmd.parityBit);
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0xfc09:
        //set dtk enter low power consumption mode
        str = `FC030944544B`;
        break;
      case 0xfc0c:
        //set dtk enter distribution network mode
        str = `FC030C44544B`;
        break;
      case 0xfc31:
        str = `FC043144544B`;
        str = this.intToHexStr(cmd.dBm, 2);
        break;
      case 0x0201: //request current data
        break;
      case 0x0202: //controlA
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        str += this.intToHexStr(cmd.pwm);
        break;
      case 0x0203: //controlADelay
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        str += this.intToHexStr(cmd.pwm);
        str += this.intToHexStr(cmd.delayedPwm);
        str += this.intToHexStr(cmd.delaySec || cmd.delayed_action, 2);
        break;
      case 0x0204: //controlADelay2
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        str += this.intToHexStr(cmd.pwm);
        str += this.intToHexStr(cmd.delayedPwm);
        str += this.intToHexStr(cmd.delaySec || cmd.delayed_action, 2);
        str += this.intToHexStr(cmd.delayedPwm2);
        str += this.intToHexStr(cmd.delaySec2 || cmd.delayed_action2, 2);
        break;
      case 0x0205: //controlAReverse
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        str += this.intToHexStr(cmd.uniqueActionID)
        break;
      case 0x0206: //controlL
        str += this.intToHexStr(cmd.onoffcontrolL); //normal:0, cut:1
        break;
      case 0x0207: //start setting
        const typeByte =
          cmd.typeA +
          (cmd.typeL << 1) +
          (cmd.typeBatVI << 2) +
          (cmd.typePwm << 3) +
          (cmd.reverseA << 4) +
          (cmd.cutDimOnBypass << 5) +
          (cmd.enableMotion << 6);
        str += this.intToHexStr(typeByte);
        str += this.intToHexStr(cmd.dimTransition);
        str += this.intToHexStr(cmd.dimTransitON);
        str += this.intToHexStr(cmd.dimTransitOFF);
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += this.intToHexStr(cmd.gatewayAdd0);
        str += this.intToHexStr(cmd.gatewayAdd1);
        break;
      case 0x0208: //flashControlA
        str += this.intToHexStr(cmd.flashTimes);
        break;
      case 0x0209: //requestBatTestStart
        // const reportID_hex = cmd.reportID.split("_")[1];
        str += this.intToHexStr(cmd.time_pretest);
        str += this.intToHexStr(cmd.time_cutOff);
        str += this.intToHexStr(cmd.time_recharge);
        str += this.intToHexStr(cmd.time_interval);
        str += this.intToHexStr(cmd.minV, 2);
        str += this.intToHexStr(cmd.minI, 2);
        // str += reportID_hex;
        break;
      case 0x020a: //terminate battery test
        break;
      case 0x020b: //acknowledge receive regular
        break;
      case 0x020c: //change lockLevel
        str += this.intToHexStr(cmd.lockLevel);
        break;
      case 0x020d: //change enableA
        str += this.intToHexStr(cmd.enableA);
        break;
      case 0x020e: //change enableL
        str += this.intToHexStr(cmd.enableL);
        break;
      case 0x020f: //change enableBatVI
        str += this.intToHexStr(cmd.enableBatVI);
        break;
      case 0x0210: //change enableDim
        str += this.intToHexStr(cmd.enableDim);
        break;
      case 0x0211: //change dimTransition
        str += this.intToHexStr(cmd.dimTransition);
        break;
      case 0x0212: //change dimTransitON
        str += this.intToHexStr(cmd.dimTransitON);
        break;
      case 0x0213: //change dimTransitOFF
        str += this.intToHexStr(cmd.dimTransitOFF);
        break;
      case 0x0214: //change cutDimOnBypass
        str += this.intToHexStr(cmd.cutDimOnBypass);
        break;
      case 0x0215: //change changeReverseA
        str += this.intToHexStr(cmd.reverseA);
        break;
      case 0x0216: //change controlAPin
        str += this.intToHexStr(cmd.controlAPin);
        break;
      case 0x0217: //change controlLPin
        str += this.intToHexStr(cmd.controlLPin);
        break;
      case 0x0218: //change regular interval
        str += this.intToHexStr(cmd.regular_time_interval);
        break;
      case 0x0219: //change survival interval
        str += this.intToHexStr(cmd.survival_time_interval);
        break;
      case 0x021a: //restart system
        break;
      case 0x021b: //request general reply
        break;
      case 0x021c: //not use
        str += this.intToHexStr(cmd.requestCommandCode, 2);
        break;
      case 0x021d: //acknowledge receive command
        str += this.intToHexStr(cmd.replyCommandCode, 2);
        break;
      case 0x021e: //controlAirconOn
        str += this.intToHexStr(cmd.acType);
        break;
      case 0x021f: //controlAirconOff
        str += this.intToHexStr(cmd.acType);
        break;
      case 0x0220: //controlAirconFan
        str += this.intToHexStr(cmd.acType);
        str += this.intToHexStr(cmd.fanValue);
        break;
      case 0x0221: //controlAirconSetTemp
        str += this.intToHexStr(cmd.acType);
        str += this.intToHexStr(cmd.tempValue);
        break;
      case 0x0222: //change enableAirconControl
        str += this.intToHexStr(cmd.enableAirconControl);
        break;
      case 0x0223: //change inputBypassPin
        str += this.intToHexStr(cmd.inputBypassPin);
        break;
      case 0x0224: //updateFirmware
        str += cmd?.updateSpiffs ? "33" : "66";
        break;
      case 0x0225: //light changeOtaSsid
        {
          const otaSsid = cmd.otaSsid;
          for (let i = 0; i < otaSsid.length; i++) {
            const code = otaSsid.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x0226: //light changeOtaPassword
        {
          const otaPassword = cmd.otaPassword;
          for (let i = 0; i < otaPassword.length; i++) {
            const code = otaPassword.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x0227: //requestLightSendStart
        break;
      case 0x0228: //test setting read write
        break;
      case 0x0229: //change disableEspNow
        str += cmd.disableEspNow ? "01" : "00";
        break;
      case 0x022a: //controlARelay
        str += this.intToHexStr(cmd.controlA);
        break;
      case 0x022b: //controlBRelay
        str += this.intToHexStr(cmd.controlB);
        break;
      case 0x022c: //controlDRelay
        str += this.intToHexStr(cmd.controlD);
        break;
      case 0x022d: //change enableEspOut
        str += cmd.enableEspOut ? "01" : "00";
        break;
      case 0x022e: //change controlBPin
        str += this.intToHexStr(cmd.controlBPin);
        break;
      case 0x022f: //change controlDPin
        str += this.intToHexStr(cmd.controlDPin);
        break;
      case 0x0230: //updateFirmware from IP
        str += cmd?.updateSpiffs ? "33" : "66";
        str += this.intToHexStr(cmd.serverIP[0]);
        str += this.intToHexStr(cmd.serverIP[1]);
        str += this.intToHexStr(cmd.serverIP[2]);
        str += this.intToHexStr(cmd.serverIP[3]);
        break;
      case 0x0231: //light changeEnableDali
        str += this.intToHexStr(cmd.enableDali);
        break;
      case 0x0232: //light changeEnableTurnOnOnDisconnect
        str += this.intToHexStr(cmd.enableTurnOnOnDisconnect);
        break;
      case 0x0233: //light resetOnDisconnectTimer
        break;
      case 0x0234: //light changeSwitchSequence
        str += this.intToHexStr(cmd.switchSequence);
        break;
      case 0x0235: //light lightStepDim
        // str += this.intToHexStr(cmd.stepUp);
        str += cmd.stepUp ? "33" : "66";
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        str += this.intToHexStr(cmd.dimStepSize)
        str += this.intToHexStr(cmd.uniqueActionID || 254)

        break;
      case 0x0236: //light lightStepDim
        break;
      case 0x0237: //light stopFlashLight
        break;
      case 0x0238: //light save group action
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum);
        str += cmd.command.substring(8, cmd.command.length - 4)
        break;
      case 0x0239: //light delete group action
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum);
        break;
      case 0x023a: //light enableAcknowledge
        str += this.intToHexStr(cmd.enableAcknowledge);
        break;
      case 0x023b: //light executeGroupAction
        str = "f0" + str.substring(2)
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum);
        str += this.intToHexStr(cmd?.uniqueActionID || 254);
        break;
      case 0x023c: //light deleteAllGroupAction
        break;
      case 0x023d: //light changeDisableDtk
        str += this.intToHexStr(cmd.disableDtk);
        break;
      case 0x0280: //light changeDtkInfo
        str += this.intToHexStr(cmd.dtkType);
        str +=
          typeof cmd.dtkPanID == "string"
            ? cmd.dtkPanID
            : this.intToHexStr(cmd.dtkPanID, 2);
        str += this.intToHexStr(cmd.dtkChannel);
        str += this.intToHexStr(cmd.dtkTransferMode);
        const new_dtkAdd = cmd.newdtkAdd || cmd.dtkAdd;
        str +=
          typeof new_dtkAdd == "string"
            ? new_dtkAdd
            : this.intToHexStr(new_dtkAdd, 2);
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0x0281: //changeDtkType
        str += this.intToHexStr(cmd.dtkType);
        break;
      case 0x0282: //changeDtkPanID
        str +=
          typeof cmd.dtkPanID == "string"
            ? cmd.dtkPanID
            : this.intToHexStr(cmd.dtkPanID, 2);
        break;
      case 0x0283: //changeDtkChannel
        str += this.intToHexStr(cmd.dtkChannel);
        break;
      case 0x0284: //changeDtkTransferMode
        str += this.intToHexStr(cmd.dtkTransferMode);
        break;
      case 0x0285: //changeDtkDefinedAdd
        str +=
          typeof cmd.dtkAdd == "string"
            ? cmd.dtkAdd
            : this.intToHexStr(cmd.dtkAdd, 2);
        break;
      case 0x0286: //changeDtkLoraParameter
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0x0287: //dtkResetModule
        break;
      case 0x0288: //light ChangeDtkBaudrateCode
        str += this.intToHexStr(cmd.dtkBaudrateCode);
        break;
      case 0x02a2: //light changeMeshChannel
        str += this.intToHexStr(cmd.meshChannel);
        break;
      case 0x02a3: //light changeMeshFreq
        str += this.intToHexStr(cmd.meshFreq);
        break;
      case 0x02a4: //light changeMeshSpeed
        str += this.intToHexStr(cmd.meshSpeed >> 4);
        break;
      case 0x02a5: //light changeMeshPower
        str += this.intToHexStr(cmd.meshPower);
        break;
      case 0x02a6: //light changeMeshNetworkID
        str += cmd.meshNetworkID;
        break;
      case 0x02a7: //light changeMeshDefinedAdd
        str += this.intToHexStr(cmd.meshDefindAdd, 2);
        break;
      case 0x02a8: //light changeMeshEnableRepeat
        str += this.intToHexStr(cmd.meshEnableRepeat);
        break;
      case 0x02a9: //light changeMeshBaudrate
        str += this.intToHexStr(cmd.meshBaudrate);
        break;
      case 0x02aa: //light meshRestart
        break;
      case 0x0301: //query lock level
        break;
      case 0x0302: //query enableA
        break;
      case 0x0303: //query enableL
        break;
      case 0x0304: //query enableBat
        break;
      case 0x0305: //query enableDim
        break;
      case 0x0306: //query dimTransition
        break;
      case 0x0307: //query dimTransitON
        break;
      case 0x0308: //query dimTransitOFF
        break;
      case 0x0309: //query cutDimOnBypass
        break;
      case 0x030a: //query reverseA
        break;
      case 0x030b: //query controlAPin
        break;
      case 0x030c: //query controlLPin
        break;
      case 0x030d: //query regular interval
        break;
      case 0x030e: //query survival interval
        break;
      case 0x030f: //query free ram
        break;
      case 0x0310: //query enableAirconControl
        break;
      case 0x0311: // query inputBypassPin
        break;
      case 0x0312: //query queryOtaSsid
        break;
      case 0x0313: //query queryOtaPassword
        break;
      case 0x0314: //query reportCurrentProgramVersion
        break;
      case 0x0315: //query queryMacAddress
        break;
      case 0x0316: //query queryDisableEspNow
        break;
      case 0x0317: //queryEnableEspOut
        break;
      case 0x0318: //query controlBPin
        break;
      case 0x0319: //query controlDPin
        break;
      case 0x031a: //query queryDtkInfo
        break;
      case 0x031b: //query enableDali
        break;
      case 0x031c: //query wifiApMacAddress
        break;
      case 0x031d: //query enableTurnOnOnDisconnect
        break;
      case 0x031e: //query switchSequence
        break;
      case 0x031f: //query MacUploadNode
        str += this.coverFF(cmd.mac);
        break;
      case 0x0320: //query queryLightFault
        break;
      case 0x0321:
        str += cmd.groupID;
        str += this.intToHexStr(cmd.settingNum);
        break;
      case 0x0322: //query enableAcknowledge
        break;
      case 0x0323: //query queryGroupActionQuantity
        str += cmd?.groupID || "00000000";
        break;
      case 0x0324: //query queryBypassStatus
        break;
      case 0x0325: //query queryDisableDtk
        break;
      case 0x0380: //query dtk info
        break;
      case 0x0381: //query dtk type
        break;
      case 0x0382: //query dtk panID
        break;
      case 0x0383: //query dtk channel
        break;
      case 0x0384: //query dtk transfer mode
        break;
      case 0x0385: //query dtk defined add
        break;
      case 0x0386: //query dtk lora parameter
        break;
      case 0x0387: //query dtk internal add
        break;
      case 0x0389: //queryDtkBaudrate
        break;
      case 0x03a0: //queryMeshMacAddress
        break;
      case 0x03a1: //queryMeshInfo
        break;
      case 0x03a2: //queryMeshChannel
        break;
      case 0x03a3: //queryMeshFreq
        break;
      case 0x03a4: //queryMeshSpeed
        break;
      case 0x03a5: //queryMeshPower
        break;
      case 0x03a6: //queryMeshNetworkID
        break;
      case 0x03a7: //queryMeshDefinedAdd
        break;
      case 0x03a8: //queryMeshEnableRepeat
        break;
      case 0x03a9: //queryMeshBaudrate
        break;
      case 0x0601: //request sensor current data
        break;
      case 0x0602: //disable sensor
        str += cmd.disabledSensor == 0 || cmd.disabledSensor == 1 ? (cmd.disabledSensor == 1 ? "33" : "66") : this.intToHexStr(cmd.disabledSensor);
        break;
      case 0x0603: //motion sensor start setting
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += this.intToHexStr(cmd.sensorMode);
        str += cmd.disabledSensor == 0 || cmd.disabledSensor == 1 ? (cmd.disabledSensor == 1 ? "33" : "66") : this.intToHexStr(cmd.disabledSensor);
        str += cmd.hasIR == 0 || cmd.hasIR == 1 ? (cmd.hasIR == 1 ? "33" : "66") : this.intToHexStr(cmd.hasIR);
        str += this.intToHexStr(cmd.delaySec, 2);
        str += this.intToHexStr(cmd.delaySec2, 2);
        str += this.intToHexStr(cmd.sensorDist);
        str += this.intToHexStr(cmd.gatewayAdd0);
        str += this.intToHexStr(cmd.gatewayAdd1);
        break;
      case 0x0604: //daylight sensor start setting
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += cmd.disabledSensor == 0 || cmd.disabledSensor == 1 ? (cmd.disabledSensor == 1 ? "33" : "66") : this.intToHexStr(cmd.disabledSensor);
        str += this.intToHexStr(cmd.gatewayAdd0);
        str += this.intToHexStr(cmd.gatewayAdd1);
        break;
      case 0x0605: //lightswitch start setting
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += cmd.disabledSensor == 0 || cmd.disabledSensor == 1 ? (cmd.disabledSensor == 1 ? "33" : "66") : this.intToHexStr(cmd.disabledSensor);
        str += this.intToHexStr(cmd.gang);
        str += this.intToHexStr(cmd.btn1Pin);
        str += this.intToHexStr(cmd.btn2Pin);
        str += this.intToHexStr(cmd.btn3Pin);
        str += this.intToHexStr(cmd.btn4Pin);
        str += this.intToHexStr(cmd.gatewayAdd0);
        str += this.intToHexStr(cmd.gatewayAdd1);
        break;
      case 0x0606: //daylightmotion sensor start setting
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += this.intToHexStr(cmd.sensorMode);
        str += cmd.disabledSensor == 0 || cmd.disabledSensor == 1 ? (cmd.disabledSensor == 1 ? "33" : "66") : this.intToHexStr(cmd.disabledSensor);
        str += cmd.hasIR == 0 || cmd.disabledSensor == 1 ? (cmd.disabledSensor == 1 ? "33" : "66") : this.intToHexStr(cmd.hasIR);
        str += this.intToHexStr(cmd.delaySec, 2);
        str += this.intToHexStr(cmd.delaySec2, 2);
        str += this.intToHexStr(cmd.sensorDist);
        str += this.intToHexStr(cmd.gatewayAdd0);
        str += this.intToHexStr(cmd.gatewayAdd1);
        break;
      case 0x0607: //scene button start setting
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += cmd.disabledSensor == 0 || cmd.disabledSensor == 1 ? (cmd.disabledSensor == 1 ? "33" : "66") : this.intToHexStr(cmd.disabledSensor);
        str += this.intToHexStr(cmd.gang);
        str += this.intToHexStr(cmd.btn1Pin);
        str += this.intToHexStr(cmd.btn2Pin);
        str += this.intToHexStr(cmd.btn3Pin);
        str += this.intToHexStr(cmd.btn4Pin);
        str += this.intToHexStr(cmd.gatewayAdd0);
        str += this.intToHexStr(cmd.gatewayAdd1);
        break;
      case 0x0608: //sensor restart system
        break;
      case 0x0609: //acknowledge receive command from sensor
        str += this.intToHexStr(cmd.replyCommandCode, 2);
        break;
      case 0x060a: //sensor updateFirmware
        break;
      case 0x060b: //sensor changeOtaSsid
        {
          const otaSsid = cmd.otaSsid;
          for (let i = 0; i < otaSsid.length; i++) {
            const code = otaSsid.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x060c: //sensor changeOtaPassword
        {
          const otaPassword = cmd.otaPassword;
          for (let i = 0; i < otaPassword.length; i++) {
            const code = otaPassword.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x060d: //sensor changeSensorType
        str += this.intToHexStr(cmd.sensorType);
        break;
      case 0x060e: //sensor changeSensorDist
        str += this.intToHexStr(cmd.sensorDist);
        break;
      case 0x060f: //sensor changeSensorMode
        str += this.intToHexStr(cmd.sensorMode);
        break;
      case 0x0610: //sensor changeHasIR
        str += cmd.hasIR ? "33" : "66";
        break;
      case 0x0611: //sensor changeDisabledSensor 0x33 true, 0x66 false
        str += cmd.disabledSensor ? "33" : "66";
        break;
      case 0x0612: //sensor changeDisabledLux
        str += this.intToHexStr(cmd.disabledLux);
        break;
      case 0x0613: //sensor changeDisabledMotion
        str += this.intToHexStr(cmd.disabledMotion);
        break;
      case 0x0614: //sensor changeGang
        str += this.intToHexStr(cmd.gang);
        break;
      case 0x0615: //sensor changeCheckLuxLevel
        str += this.intToHexStr(cmd.check_lux_interval);
        break;
      case 0x0616: //sensor changeEnable_delayed_action
        str += this.intToHexStr(cmd.enable_delayed_action);
        break;
      case 0x0617: //sensor changeEnable_delayed_action2
        str += this.intToHexStr(cmd.enable_delayed_action2);
        break;
      case 0x0618: //sensor changeMotion_off_delay
        const delaySec = cmd.delaySec || cmd.motion_off_delay;
        str += this.intToHexStr(delaySec, 2);
        break;
      case 0x0619: //sensor changeMotion_off_delay2
        const delaySec2 = cmd.delaySec2 || cmd.motion_off_delay2;
        str += this.intToHexStr(delaySec2, 2);
        break;
      case 0x061a: //sensor changeDelayCountdown
        str += this.intToHexStr(cmd.delayCountDown, 2);
        break;
      case 0x061b: //sensor changeDisabledRelay
        str += this.intToHexStr(cmd.disabledRelay);
        break;
      case 0x061c: //sensor changeDisabledContact
        str += this.intToHexStr(cmd.disabledContact);
        break;
      case 0x061d: //sensor changeBtn1Pin
        str += this.intToHexStr(cmd.btn1Pin);
        break;
      case 0x061e: //sensor changeBtn2Pin
        str += this.intToHexStr(cmd.btn2Pin);
        break;
      case 0x061f: //sensor changeBtn3Pin
        str += this.intToHexStr(cmd.btn3Pin);
        break;
      case 0x0620: //sensor changeBtn4Pin
        str += this.intToHexStr(cmd.btn4Pin);
        break;
      case 0x0621: //sensor flashSensorHeadLED
        str += this.intToHexStr(cmd.flashSec);
        break;
      case 0x0622: //sensor changeMotionI2C
        str += this.intToHexStr(cmd.motionI2C);
        break;
      case 0x0623: //sensor changeRegularInterval
        str += this.intToHexStr(cmd.regular_time_interval);
        break;
      case 0x0624: //sensor changeSurvivalInterval
        str += this.intToHexStr(cmd.survival_time_interval);
        break;
      case 0x0625: //sensor testSettingReadWrite
        break;
      case 0x0626: //sensor changeDisableEspNow
        str += this.intToHexStr(cmd.disableEspNow);
        break;
      case 0x0627: //sensor changeEnableEspOut
        str += this.intToHexStr(cmd.enableEspOut);
        break;
      case 0x0628: //sensor saveNearFieldLightSetting
        (cmd.macAddressArray || []).forEach((mac) => {
          str += this.intToHexStr(mac);
        });
        str += this.intToHexStr(cmd.settingNum);
        str += this.intToHexStr(cmd.shortAdd || 0);
        (cmd.msgArray || []).forEach((byte) => {
          str += this.intToHexStr(byte);
        });
        break;
      case 0x0629: //sensor deleteNearFieldLightSetting
        (cmd.macAddressArray || []).forEach((mac) => {
          str += this.intToHexStr(mac);
        });
        str += this.intToHexStr(cmd.settingNum);
        str += this.intToHexStr(cmd.shortAdd || 0);
        break;
      case 0x062a: //sensor executeNearFieldLightSetting
        (cmd.macAddressArray || []).forEach((mac) => {
          str += this.intToHexStr(mac);
        });
        str += this.intToHexStr(cmd.settingNum);
        str += this.intToHexStr(cmd.shortAdd || 0);
        break;
      case 0x062b: //sensor executeAllNearFieldLightSetting
        str += this.intToHexStr(cmd.settingNum);
        break;
      case 0x062c: //sensor enableSensorWithDelay
        str += this.intToHexStr(cmd.delaySec, 2);
        break;
      case 0x062d: //sensor disableSensorWithDelay
        str += this.intToHexStr(cmd.delaySec, 2);
        break;
      case 0x062e: //sensor changeLuxFactor
        str += this.intToHexStr(parseInt(cmd.multiplier * 10000), 2);
        str += this.intToHexStr(parseInt(cmd.power * 10000), 2);
        break;
      case 0x062f: //sensor updateFirmware from IP
        str += cmd?.updateSpiffs ? "33" : "66";
        str += this.intToHexStr(cmd.serverIP[0]);
        str += this.intToHexStr(cmd.serverIP[1]);
        str += this.intToHexStr(cmd.serverIP[2]);
        str += this.intToHexStr(cmd.serverIP[3]);
        break;
      case 0x0630: //sensor deleteAllNearFieldSetting
        break;
      case 0x0631: //sensor changeSceneBtnMinTime
        str += this.intToHexStr(cmd.sceneBtnMinTime >> 16);
        str += this.intToHexStr(cmd.sceneBtnMinTime >> 8);
        str += this.intToHexStr(cmd.sceneBtnMinTime);
        break;
      case 0x0632: //sensor changeSceneBtnRepeatTime
        str += this.intToHexStr(cmd.sceneBtnRepeatTime >> 16);
        str += this.intToHexStr(cmd.sceneBtnRepeatTime >> 8);
        str += this.intToHexStr(cmd.sceneBtnRepeatTime);
        break;
      case 0x0633: //sensor changeTouchPanelType
        str += this.intToHexStr(cmd.touchPanelType); //1:momentary 2:latch
        break;
      case 0x0634: //sensor dimController start setting
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += this.intToHexStr(cmd.disabledSensor);
        str += this.intToHexStr(cmd.gang);
        break;
      case 0x0635: //sensor flash touch panel led
        str += this.intToHexStr(cmd.buttonNo);
        break;
      case 0x0636: //sensor startFlashDeviceLight
        break;
      case 0x0637: //sensor stopFlashDeviceLight
        break;
      case 0x0638: //touch panel update firmware
        break;
      case 0x0639: //sensor sve batch near field setting
        (cmd.macAddressArray || []).forEach((mac) => {
          str += this.intToHexStr(mac);
        });
        str += this.intToHexStr(cmd.shortAdd || 0);
        (cmd.lightLvArray || []).forEach((lv) => {
          str += this.intToHexStr(lv);
        });
        break;
      case 0x063a: //sensor change enableAcknowledge
        str += this.intToHexStr(cmd.enableAcknowledge);
        break;
      case 0x063b: //sensor changeTouchPanelReverseLed
        str += this.intToHexStr(cmd.reverseLed);
        break;
      case 0x063c: //sensor saveGroupAction
        str += this.intToHexStr(cmd.groupID);
        str += this.intToHexStr(cmd.settingNum);
        str += cmd.command.substring(8, cmd.command.length - 4);
        break;
      case 0x063d: //sensor excuteGroupAction
        str = "f0" + str.substring(2);
        str += this.intToHexStr(cmd.groupID);
        str += this.intToHexStr(cmd.settingNum);
        str += this.intToHexStr(cmd.uniqueActionID || 254);
        break;
      case 0x063e: //sensor deleteGroupAction
        str += this.intToHexStr(cmd.groupID);
        str += this.intToHexStr(cmd.settingNum);
        break;
      case 0x063f: //sensor deleteAllGroupAction
        break;
      case 0x0640: //sensor changeDisabledLightAction
        str += this.intToHexStr(cmd.disabledLightAction);
        break;
      case 0x0641: //sensor changeDisableDtk
        str += this.intToHexStr(cmd.disableDtk);
        break;
      case 0x0680: //sensor changeDtkInfo
        str += this.intToHexStr(cmd.dtkType);
        str +=
          typeof cmd.dtkPanID == "string"
            ? cmd.dtkPanID
            : this.intToHexStr(cmd.dtkPanID, 2);
        str += this.intToHexStr(cmd.dtkChannel);
        str += this.intToHexStr(cmd.dtkTransferMode);
        str += cmd.newdtkAdd
          ? this.intToHexStr(cmd.newdtkAdd, 2)
          : this.intToHexStr(cmd.dtkAdd, 2);
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0x0681: //sensor changeDtkType
        str += this.intToHexStr(cmd.dtkType);
        break;
      case 0x0682: //sensor changeDtkPanID
        str += this.intToHexStr(cmd.dtkPanID, 2);
        break;
      case 0x0683: //sensor changeDtkChannel
        str += this.intToHexStr(cmd.dtkChannel);
        break;
      case 0x0684: //sensor changeDtkTransferMode
        str += this.intToHexStr(cmd.dtkTransferMode);
        break;
      case 0x0685: //sensor changeDtkDefinedAdd
        str += this.intToHexStr(cmd.dtkAdd, 2);
        break;
      case 0x0686: //sensor changeDtkLoraParameter
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0x0687: //sensor dtkReset
        break;
      case 0x0688: //sensor changeDtkBaudrate
        str += this.intToHexStr(cmd.dtkBaudrate);
        break;
      case 0x06a1: //sensor changeMeshInfo
        str += this.intToHexStr(cmd.meshChannel);
        str += this.intToHexStr(cmd.meshFreq);
        str += this.intToHexStr(cmd.meshSpeed);
        str += this.intToHexStr(cmd.meshPower);
        break;
      case 0x06a2://sensor changeMeshChannel
        str += this.intToHexStr(cmd.meshChannel);
        break;
      case 0x06a3://sensor changeMeshFreq
        str += this.intToHexStr(cmd.meshFreq);
        break;
      case 0x06a4: //sensor changeMeshSpeed
        str += this.intToHexStr(cmd.meshSpeed >> 4);
        break;
      case 0x06a5: //sensor changeMeshPower
        str += this.intToHexStr(cmd.meshPower);
        break;
      case 0x06a6: //sensor changeMeshNetworkID
        str += cmd.meshNetworkID
        break;
      case 0x06a7: //sensor changeMeshDefinedAdd
        str += this.intToHexStr(cmd.meshDefindAdd, 2);
        break;
      case 0x06a8: //sensor changeEnableRepeat
        str += this.intToHexStr(cmd.meshEnableRepeat);
        break;
      case 0x06a9: //sensor changeMeshBaudrate
        str += this.intToHexStr(cmd.meshBaudrate);
        break;
      case 0x06aa: //meshRestart
        break;
      case 0x0701: //query sensor type
        break;
      case 0x0702: //query sensor dist
        break;
      case 0x0703: //query sensor mode
        break;
      case 0x0704: //query sensor hasIR
        break;
      case 0x0705: //query disabledSensor
        break;
      case 0x0706: //query DisabledLux
        break;
      case 0x0707: //query DisabledMotion
        break;
      case 0x0708: //query gang
        break;
      case 0x0709: //query checkLuxLevel
        break;
      case 0x070a: //query enable_delayed_action
        break;
      case 0x070b: //query enable_delayed_action2
        break;
      case 0x070c: //query motion_off_delay
        break;
      case 0x070d: //query motion_off_delay2
        break;
      case 0x070e: //query delayCountdown
        break;
      case 0x070f: //query disabledRelay
        break;
      case 0x0710: //query disabledContact
        break;
      case 0x0711: //query queryCurrentProgramVersion
        break;
      case 0x0712: //query btn1Pin
        break;
      case 0x0713: //query btn2Pin
        break;
      case 0x0714: //query btn3Pin
        break;
      case 0x0715: //query btn4Pin
        break;
      case 0x0716: //sensor queryOtaSsid
        break;
      case 0x0717: //sensor query queryOtaPassword
        break;
      case 0x0718: //sensor query queryMacAddress
        break;
      case 0x0719: //sensor queryMotionI2C
        break;
      case 0x071a: //sensor queryRegularInterval
        break;
      case 0x071b: //sensor querySurvivalInterval
        break;
      case 0x071c: //sensor queryDisableEspNow
        break;
      case 0x071d: //sensor querySensorFault
        break;
      case 0x071e: //sensor queryEnableEspOut
        break;
      case 0x071f: //sensor queryNearFieldLightSetting
        (cmd.macAddressArray || []).forEach((mac) => {
          str += this.intToHexStr(mac);
        });
        str += this.intToHexStr(cmd.settingNum);
        str += this.intToHexStr(cmd.shortAdd || 0);
        break;
      case 0x0720: //sensor queryWifiApMacAddress
        break;
      case 0x0721: //sensor queryLuxFactor
        break;
      case 0x0722: //sensor queryMacUploadNode
        str += this.coverFF(cmd.mac);
        break;
      case 0x0723: //sensor querySceneBtnMinTime
        break;
      case 0x0724: //sensor querySceneBtnRepeatTime
        break;
      case 0x0725: //sensor queryTouchPanelType
        break;
      case 0x0726: //query sensorHeadType
        break;
      case 0x0727: //query touchPanelVersion
        break;
      case 0x0728: //query touchPanelGang
        break;
      case 0x0729: //query batch near field setting
        (cmd.macAddressArray || []).forEach((mac) => {
          str += this.intToHexStr(mac);
        });
        str += this.intToHexStr(cmd.shortAdd || 0);
        break;
      case 0x072a: //query enableAcknowledge
        break;
      case 0x072b: //query touchPanelReverseLed
        break;
      case 0x072c: //query groupAction
        str += this.intToHexStr(cmd.groupID);
        str += this.intToHexStr(cmd.settingNum);
        break;
      case 0x072d: //query groupActionQuantity
        str += this.intToHexStr(cmd.groupID);
        break;
      case 0x072e: //query disabledLightAction
        break;
      case 0x072f: //query disableDtk
        break;
      case 0x0780: //sensor queryDtkInfo
        break;
      case 0x0781: //sensor queryDtkType
        break;
      case 0x0782: // sensor queryDtkPanID
        break;
      case 0x0783: //sensor queryDtkChannel
        break;
      case 0x0784: // queryDtkTransferMode
        break;
      case 0x0785: //sensor queryDtkDefinedAdd
        break;
      case 0x0786: //sensor queryDtkLoraParameter
        break;
      case 0x0787: //sensor queryDtkInternalAdd
        break;
      case 0x0788: // sensor queryDtkBaudrate
        break;
      case 0x07a0: //sensor queryMeshMacAddress
        break;
      case 0x07a1: //sensor queryMeshInfo
        break;
      case 0x07a2: //sensor queryMeshChannel
        break;
      case 0x07a3: //sensor queryMeshFreq
        break;
      case 0x07a4: //sensor queryMeshSpeed
        break;
      case 0x07a5: //sensor queryMeshPower
        break;
      case 0x07a6: //sensor queryMeshNetworkID
        break;
      case 0x07a7: //sensor queryMeshDefindAdd
        break;
      case 0x07a8: //sensor queryEnableRepeat
        break;
      case 0x07a9: //sensor queryMeshBaudrate
        break;
      case 0x07e0: //sensorHeadTestStart
        break;
      case 0x07e1: //sensorHeadTestEnd
        break;
      case 0x07e2: //querySensorHeadTestResult
        break;
      case 0x0a01: //dali requestCurrentData
        break;
      case 0x0a02: //dali sendStartSetting
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.regular_time_interval);
        break;
      case 0x0a03: //dali initialise
        break;
      case 0x0a04: //dali general query
        str += this.intToHexStr(cmd.daliCmd);
        str += Array.isArray(cmd.shortAdd)
          ? cmd.shortAdd.map((d) => this.intToHexStr(d)).join("")
          : this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0a05: //dali scanShortAdd
        break;
      case 0x0a06: //dali changeShortAdd
        str += this.intToHexStr(cmd.currentAdd);
        str += this.intToHexStr(cmd.newAdd);
        break;
      case 0x0a07: //dali broadcastLight
        str += this.intToHexStr(cmd.arcLv);
        break;
      case 0x0a08: // dali flash light
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.times);
        break;
      case 0x0a09: //dali controlSingleLight
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.pwm);
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.delayedPwm);
        str += this.intToHexStr(cmd?.delaySec || cmd?.delayed_action, 2);
        str += this.intToHexStr(cmd.delayedPwm2);
        str += this.intToHexStr(cmd?.delaySec2 || cmd?.delayed_action2, 2);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        break;
      case 0x0a0a: //dali changeFadeTime
        str += this.intToHexStr(cmd.fadeTime);
        Array.isArray(cmd.shortAdd)
          ? cmd.shortAdd.forEach((add) => {
            str += this.intToHexStr(add);
          })
          : (str += this.intToHexStr(cmd.shortAdd));
        break;
      case 0x0a0b: //dali writeMemoryBank
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.memoryAdd);
        str += this.intToHexStr(cmd.value);
        break;
      case 0x0a0c: //daliReset
        str += this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0a0d: //changeLockLevel
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.lockLevel);
        break;
      case 0x0a0e: //acknowledgeReceiveCommand
        str += this.intToHexStr(cmd.replyCommandCode, 2);
        break;
      case 0x0a0f: //releaseLockLevelAll
        break;
      case 0x0a10: //addToGroup
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.groupNo);
        break;
      case 0x0a11: //removeFromGroup
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.groupNo);
        break;
      case 0x0a12: //dali cancelScanShortAdd
        break;
      case 0x0a13: //daliResetAll
        break;
      case 0x0a14: //dali changeFadeTimeAll
        str += this.intToHexStr(cmd.fadeTime);
        break;
      case 0x0a15: //dali changeMinLv
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.minLv);
        break;
      case 0x0a16: //dali changeMaxLv
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.maxLv);
        break;
      case 0x0a17: //dali changeMinLvAll
        str += this.intToHexStr(cmd.minLv);
        break;
      case 0x0a18: //dali changeMaxLvAll
        str += this.intToHexStr(cmd.maxLv);
        break;
      case 0x0a19: //dali controrlMultiLight_noDelay lightLv250 no action
        if (cmd?.partByte) {
          str += this.intToHexStr(cmd.data);
          // str += this.intToHexStr(cmd.partByteH);
          str += this.intToHexStr(cmd.partByte);
          str += this.intToHexStr(cmd.actionID);
        } else {
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
          cmd.lightLvAry.forEach((lv) => {
            str += this.intToHexStr(lv);
          });
        }
        break;
      case 0x0a1a: //dali controrlMultiLight_1Delay lightLv250 no action
        if (cmd?.partByte) {
          str += this.intToHexStr(cmd.data);
          // str += this.intToHexStr(cmd.partByteH);
          str += this.intToHexStr(cmd.partByte);
          str += this.intToHexStr(cmd.actionID);
        } else {
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
          str += this.intToHexStr(cmd?.delayedAction || cmd?.delaySec, 2);
          cmd.lightLvAry.forEach((lv) => {
            str += this.intToHexStr(lv);
          });
          cmd.D1LightLvAry.forEach((lv) => {
            str += this.intToHexStr(lv);
          });
        }
        break;
      case 0x0a1b: //dali controrlMultiLight_2Delay lightLv250 no action
        if (cmd?.partByte) {
          str += this.intToHexStr(cmd.data);
          // str += this.intToHexStr(cmd.partByteH);
          str += this.intToHexStr(cmd.partByte);
          str += this.intToHexStr(cmd.actionID);
        } else {
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
          str += this.intToHexStr(cmd?.delayedAction || cmd?.delaySec, 2);
          str += this.intToHexStr(cmd?.delayedAction2 || cmd?.delaySec2, 2);
          cmd.lightLvAry.forEach((lv) => {
            str += this.intToHexStr(lv);
          });
          cmd.D1LightLvAry.forEach((lv) => {
            str += this.intToHexStr(lv);
          });
          cmd.D2LightLvAry.forEach((lv) => {
            str += this.intToHexStr(lv);
          });
        }
        break;
      case 0x0a1c: //dali deleteAllLights
        break;
      case 0x0a1d: //dali deleteAllSensors
        break;
      case 0x0a1e: //dali deleteLight
        str += this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0a1f: //dali deleteSensor
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.instance);
        break;
      case 0x0a20: //dali changeControlAPin
        str += this.intToHexStr(cmd.controlAPin);
        break;
      case 0x0a21: //dali changeControlBPin
        str += this.intToHexStr(cmd.controlBPin);
        break;
      case 0x0a22: //dali changeControlDPin
        str += this.intToHexStr(cmd.controlDPin);
        break;
      case 0x0a23: //dali changeDisableEspNow
        str += this.intToHexStr(cmd.disableEspNow);
        break;
      case 0x0a24: //dali changeEnableEspOut
        str += this.intToHexStr(cmd.enableEspOut);
        break;
      case 0x0a25: //dali changeRegularInterval
        str += this.intToHexStr(cmd.regular_time_interval);
        break;
      case 0x0a26: //dali changeSurvivalInterval
        str += this.intToHexStr(cmd.survival_time_interval);
        break;
      case 0x0a27: // dali change enableDali
        str += this.intToHexStr(cmd.enableDali);
        break;
      case 0x0a28: // dali changeEnableTurnOnOnDisconnect
        str += this.intToHexStr(cmd.enableTurnOnOnDisconnect);
        break;
      case 0x0a29:// dali resetOnDisconnectTimer
        break;
      case 0x0a2a: //dali PowerOnOff
        str += this.intToHexStr(cmd.powerOnOff);
        break;
      case 0x0a2b: //dali updateFirmware
        break;
      case 0x0a2c: //dali update firmware from IP
        str += cmd?.updateSpiffs ? "33" : "66";
        str += this.intToHexStr(cmd.serverIP[0]);
        str += this.intToHexStr(cmd.serverIP[1]);
        str += this.intToHexStr(cmd.serverIP[2]);
        str += this.intToHexStr(cmd.serverIP[3]);
        break;
      case 0x0a2d: //dali changeOtaSsid
        {
          const otaSsid = cmd.otaSsid;
          for (let i = 0; i < otaSsid.length; i++) {
            const code = otaSsid.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x0a2e: //dali changeOtaPassword
        {
          const otaPassword = cmd.otaPassword;
          for (let i = 0; i < otaPassword.length; i++) {
            const code = otaPassword.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x0a30: //dali changeSwitchSequence
        str += this.intToHexStr(cmd.switchSequence);
        break;
      case 0x0a31: //dali restartDaliCtl
        break;
      case 0x0a32: //dali changeCutDimOnBypass
        str += this.intToHexStr(cmd.cutDimOnBypass);
        break;
      case 0x0a33: //dali daliMultiLightStepDim
        str += cmd.stepUp ? "33" : "66";
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnEnd);
        str += this.intToHexStr(cmd.dimStepSize)
        str += this.intToHexStr(cmd.uniqueActionID || 254)
        if (cmd?.shortAddAry)
          (Array.isArray(cmd?.shortAddAry) ? cmd.shortAddAry : Object.keys(JSON.parse(cmd.shortAddAry))).forEach((shortAdd) => {
            str += this.intToHexStr(shortAdd);
          });
        break;
      case 0x0a34: //daliMultiLightToggle
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnEnd);
        str += this.intToHexStr(cmd.uniqueActionID || 254)
        if (cmd?.shortAddAry)
          (Array.isArray(cmd?.shortAddAry) ? cmd.shortAddAry : Object.keys(JSON.parse(cmd.shortAddAry))).forEach((shortAdd) => {
            str += this.intToHexStr(shortAdd);
          })
        break;
      case 0x0a35: //daliSingleLightStepDim
        str += this.intToHexStr(cmd.shortAdd);
        str += cmd.stepUp ? "33" : "66";
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnEnd);
        str += this.intToHexStr(cmd.dimStepSize);
        str += this.intToHexStr(cmd.uniqueActionID || 254)
        break;
      case 0x0a36: //daliSingleLightToggle
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnEnd);
        str += this.intToHexStr(cmd.uniqueActionID || 254)
        break;
      case 0x0a37://daliStartFlashLight
        break;
      case 0x0a38://daliStopFlashLight
        break;
      case 0x0a39: //dali controrlMultiLight_noDelay lightLv250 no action
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        cmd.lightLvAry.forEach((lv) => {
          str += this.intToHexStr(lv);
        });
        break;
      case 0x0a3a: //dali controrlMultiLight_1Delay lightLv250 no action
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        str += this.intToHexStr(cmd?.delayedAction || cmd?.delaySec, 2);
        cmd.lightLvAry.forEach((lv) => {
          str += this.intToHexStr(lv);
        });
        cmd.D1LightLvAry.forEach((lv) => {
          str += this.intToHexStr(lv);
        });
        break;
      case 0x0a3b: //dali controrlMultiLight_2Delay lightLv250 no action
        str += this.intToHexStr(cmd.lockLevel);
        str += this.intToHexStr(cmd.releaseOnDelayEnd);
        str += this.intToHexStr(cmd?.delayedAction || cmd?.delaySec, 2);
        str += this.intToHexStr(cmd?.delayedAction2 || cmd?.delaySec2, 2);
        cmd.lightLvAry.forEach((lv) => {
          str += this.intToHexStr(lv);
        });
        cmd.D1LightLvAry.forEach((lv) => {
          str += this.intToHexStr(lv);
        });
        cmd.D2LightLvAry.forEach((lv) => {
          str += this.intToHexStr(lv);
        });
        break;
      case 0x0a3c: //dali enableAcknowledge
        str += this.intToHexStr(cmd.enableAcknowledge);
        break;
      case 0x0a3d: //dali save group action
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum)
        str += cmd.command.substring(8, cmd.command.length - 4)
        break;
      case 0x0a3e: //dali delete group action
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum)
        break;
      case 0x0a3f: //dali execute group action
        str = "f0" + str.substring(2)
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum)
        str += this.intToHexStr(cmd?.uniqueActionID || 254)
        break;
      case 0x0a40: //dali deleteAllGroupAction
        break;
      case 0x0a41: //dali controlARelay
        str += this.intToHexStr(cmd.controlA);
        break;
      case 0x0a42: //dali controlBRelay
        str += this.intToHexStr(cmd.controlB);
        break;
      case 0x0a43: //dali controlDRelay
        str += this.intToHexStr(cmd.controlD);
        break;
      case 0x0a44: //dali changeGeneralDaliParameter
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.changeCmdNum);
        str += this.intToHexStr(cmd.value);
        str += this.intToHexStr(cmd.queryCmdNum);
        break;
      case 0x0a45: //daliCtlReportDisableDtk
        str += this.intToHexStr(cmd.disableDtk);
        break;
      case 0x0a80: //dali changeDtkInfo
        str += this.intToHexStr(cmd.dtkType);
        str += typeof cmd.dtkPanID == "string" ? cmd.dtkPanID : this.intToHexStr(cmd.dtkPanID, 2);
        str += this.intToHexStr(cmd.dtkChannel);
        str += this.intToHexStr(cmd.dtkTransferMode);
        str += typeof cmd.dtkAdd == "string" ? cmd.dtkAdd : this.intToHexStr(cmd.dtkAdd, 2);
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0x0a81: //dali changeDtkType
        str += this.intToHexStr(cmd.dtkType);
        break;
      case 0x0a82: //dali changeDtkPanID
        str += this.intToHexStr(cmd.dtkPanID, 2);
        break;
      case 0x0a83: //dali changeDtkChannel
        str += this.intToHexStr(cmd.dtkChannel);
        break;
      case 0x0a84: //dali changeDtkTransferMode
        str += this.intToHexStr(cmd.dtkTransferMode);
        break;
      case 0x0a85: //dali changeDtkDefinedAdd
        str += this.intToHexStr(cmd.dtkAdd, 2);
        break;
      case 0x0a86: //dali changeDtkLoraParameter
        str += this.intToHexStr(cmd.loraParameter);
        break;
      case 0x0a87: //dali dtkResetModule
        break;
      case 0x0a88: //dali changeDtkBaudrate
        str += this.intToHexStr(cmd.dtkBaudrate);
        break;
      case 0x0aa1: //dali changeMeshInfo
        str += this.intToHexStr(cmd.meshChannel);
        str += this.intToHexStr(cmd.meshFreq);
        str += this.intToHexStr(cmd.meshSpeed);
        str += this.intToHexStr(cmd.meshPower);
        break;
      case 0x0aa2: //dali changeMeshChannel
        str += this.intToHexStr(cmd.meshChannel);
        break;
      case 0x0aa3: //dali changeMeshFreq
        str += this.intToHexStr(cmd.meshFreq);
        break;
      case 0x0aa4: //dali changeMeshSpeed
        str += this.intToHexStr(cmd.meshSpeed >> 4);
        break;
      case 0x0aa5: //dali changeMeshPower
        str += this.intToHexStr(cmd.meshPower);
        break;
      case 0x0aa6: //dali changeMeshNetworkID
        str += cmd.meshNetworkID
        break;
      case 0x0aa7: //dali changeMeshDefindAdd
        str += this.intToHexStr(cmd.meshDefindAdd, 2);
        break;
      case 0x0aa8: //dali changeEnableRepeat
        str += this.intToHexStr(cmd.meshEnableRepeat);
        break;
      case 0x0aa9: //dali changeMeshBaudrate
        str += this.intToHexStr(cmd.meshBaudrate);
        break;
      case 0x0aaa: //dali meshRestart
        break;
      case 0x0b01: //dali queryShortAddList
        break;
      case 0x0b02: //dali queryAllLightLv
        break;
      case 0x0b03: //dali queryLockLevelAll
        break;
      case 0x0b04: //dali queryLightLv
        str += this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0b05: // dali queryLockLevel
        str += this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0b06: //dali queryFadeTime
        str += this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0b07: //dali queryMemoryBank
        str += this.intToHexStr(cmd.shortAdd);
        str += this.intToHexStr(cmd.memoryAdd);
        break;
      case 0x0b08: // dali queryMinLv
        str += this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0b09: //dali queryMaxLv
        str += this.intToHexStr(cmd.shortAdd);
        break;
      case 0x0b0a: //dali queryFadeTimeAll
        break;
      case 0x0b0b: //dali queryMinLvAll
        break;
      case 0x0b0c: //dali queryMaxLvAll
        break;
      case 0x0b0d: //dali queryBypass
        break;
      case 0x0b0e: //dali queryControlAPin
        break;
      case 0x0b0f: //dali queryControlBPin
        break;
      case 0x0b10: //dali queryControlDPin
        break;
      case 0x0b11: //dali queryDisableEspNow
        break;
      case 0x0b12: //dali queryEnableEspOut
        break;
      case 0x0b13: //dali queryRegularInterval
        break;
      case 0x0b14: //dali querySurvivalInterval
        break;
      case 0x0b15: //dali queryEnableDali
        break;
      case 0x0b16: //dali queryWifiApMacAddress
        break;
      case 0x0b17: //dali enableTurnOnOnDisconnect
        break;
      case 0x0b18: //dali queryPowerOnOff
        break;
      case 0x0b19: //dali queryOtaSsid
        break;
      case 0x0b1a: //dali queryOtaPassword
        break;
      case 0x0b1b: //dali querySwitchSequence
        break;
      case 0x0b1c: //dali queryCurrentProgramVersion
        break;
      case 0x0b1d: //dali queryMacUploadNode
        str += this.coverFF(cmd.mac);
        break;
      case 0x0b1e: //dali queryCutDimOnBypass
        break;
      case 0x0b1f: //dali queryDaliFault
        break;
      case 0x0b20: //dali queryEnableAcknowledge
        break;
      case 0x0b21: //dali queryGroupAction
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum)
        break;
      case 0x0b22: //dali queryGroupActionQuantity
        str += cmd?.groupID || "000000"
        break;
      case 0x0b23: //dali querBypassStatus
        break;
      case 0x0b24: //dali queryDisableDtk
        break;
      case 0x0b80: //dali queryDtkInfo
        break;
      case 0x0b81: //dali queryDtkType
        break;
      case 0x0b82: //dali queryDtkPanID
        break;
      case 0x0b83: //dali queryDtkChannel
        break;
      case 0x0b84: //dali queryDtkTransferMode
        break;
      case 0x0b85: //dali queryDtkDefinedAdd
        break;
      case 0x0b86: //dali queryDtkLoraParameter
        break;
      case 0x0b87: //dali queryDtkInternalAdd
        break;
      case 0x0b89: //dali queryDtkBaudrate
        break;
      case 0x0ba0: //dali queryMeshMacAddress
        break;
      case 0x0ba1: //dali queryMeshInfo
        break;
      case 0x0ba2: //dali queryMeshChannel
        break;
      case 0x0ba3: //dali queryMeshFreq
        break;
      case 0x0ba4: //dali queryMeshSpeed
        break;
      case 0x0ba5: //dali queryMeshPower
        break;
      case 0x0ba6: //dali queryMeshNetworkID
        break;
      case 0x0ba7: //dali queryMeshDefindAdd
        break;
      case 0x0ba8: //dali queryEnableRepeat
        break;
      case 0x0ba9: //dali queryMeshBaudrate
        break;
      case 0x0e01: //pointToPointPing
        str += this.intToHexStr(cmd.selfDtkAdd, 2);
        break;
      case 0x0e02: //pointToPointPingReply
        str += this.intToHexStr(cmd.selfDtkAdd, 2);
        break;
      case 0x0e03: //esp broadcast search nearby mac
        // let check_ff = "";
        // for (i = 0; i < cmd.selfMacAddress.length; i += 2) {
        //   if (cmd.selfMacAddress.substring(i, i + 2) == "ff") {
        //     str += "02";
        //     check_ff += "1";
        //   } else {
        //     str += cmd.selfMacAddress.substring(i, i + 2);
        //     check_ff += "0";
        //   }
        // }
        // str += parseInt(check_ff, 2).toString(16);
        str = "f0" + str.substring(2)
        if (cmd?.broadcastLifeTime)
          str += this.intToHexStr(cmd.broadcastLifeTime, 1);
        if (cmd?.randomDigit)
          str += this.intToHexStr(cmd.randomDigit, 1);
        if (cmd?.gatewayID)
          str += cmd.gatewayID
        if (cmd?.dtk_command)
          str += cmd.dtk_command.substring(8, cmd?.dtk_command.length - 4);
        break;
      case 0x0e04: //esp repeater command container
        if (cmd?.dtk_command)
          str += cmd.dtk_command.substring(8, cmd?.dtk_command.length - 4);
        // let remaindLayer = -1;
        let remaindLayer = 0;
        for (let i = 20; i > 0; i--) {
          if (cmd[`layer${i}MacAddress`]) {
            str += this.coverFF(cmd[`layer${i}MacAddress`]);
            remaindLayer += 1;
          }
        }
        if (cmd?.targeMac) str += cmd.targeMac
        str += this.intToHexStr(remaindLayer)
        break;
      case 0x0e05: //espGwInstruct
        str += this.intToHexStr(cmd.instruct, 1);
        if (cmd?.gatewayID)
          str += cmd.gatewayID
        break;
      case 0x0e06: //reclaimDelayList
        str += this.intToHexStr(cmd.selfDtkAdd, 2);
        break;
      case 0x0e09: //esp test mac usability
        str += this.coverFF(cmd.mac);
        break;
      case 0x0e0a: // ping count
        str += this.intToHexStr(cmd.count, 2);
        break;
      case 0x0e0b: // executeGroupAction
        str = "f0" + str.substring(2)
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum);
        str += this.intToHexStr(cmd?.uniqueActionID || 254);
        break;
      case 0x0e0c: // deleteGroupAction
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum);
        break;
      case 0x0e0d: // queryGroupAction
        str += cmd.groupID
        str += this.intToHexStr(cmd.settingNum);
        break;
      case 0x0e0e: // deleteAllGroupAction
        break;
      case 0x0e0f: // queryGroupActionQuantity
        str += cmd?.groupID || "00000000"
        break;
      case 0x1001: //gw to esp internal command checkConnetion
        break;
      case 0x1002: //gw to esp internal command getMacAddress
        break;
      case 0x1003: //gw to esp internal command getVersion
        break;
      case 0x1004: //gw to esp internal command updateFirmware
        str += cmd.updateSpiffs ? "33" : "66";
        break;
      case 0x1005: //gw to esp internal command updateFirmware from IP
        str += cmd.updateSpiffs ? "33" : "66";
        str += this.intToHexStr(cmd.serverIP[0]);
        str += this.intToHexStr(cmd.serverIP[1]);
        str += this.intToHexStr(cmd.serverIP[2]);
        str += this.intToHexStr(cmd.serverIP[3]);
        break;
      case 0x1006: //gw to esp internal command changeOtaSsid
        const espMester_otaSsid = cmd.otaSsid;
        for (let i = 0; i < espMester_otaSsid.length; i++) {
          const code = espMester_otaSsid.charCodeAt(i);
          const hex = code.toString(16);
          str += hex;
        }
        break;
      case 0x1007: //gw to esp internal command changeOtaPassword
        const espMester_otaPassword = cmd.otaPassword;
        for (let i = 0; i < espMester_otaPassword.length; i++) {
          const code = espMester_otaPassword.charCodeAt(i);
          const hex = code.toString(16);
          str += hex;
        }
        break;
      case 0x1008: //gw to esp internal command restart
        break;
      case 0x100a: //gw to esp internal command querySystemInfo
        break;
      case 0x100b: //gw to esp internal command DelayList
        break;
      case 0x1011: //gw to esp internal command queryOtaSsid
        break;
      case 0x1012: //gw to esp internal command queryOtaPassword
        break;
      case 0x1013: //esp32 changeOtaSsid
        {
          const otaSsid = cmd.otaSsid;
          for (let i = 0; i < otaSsid.length; i++) {
            const code = otaSsid.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x1014: //esp32 changeOtaPassword
        {
          const otaPassword = cmd.otaPassword;
          for (let i = 0; i < otaPassword.length; i++) {
            const code = otaPassword.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
          break;
        }
      case 0x1017: //gw to esp internal command queryOtaPassword
        break;
      case 0x4349:
        str = `415443490D`;
        break;
      case 0x5200:
        str = `415452440300010d`;
        break;
      case 0x5201:
        str = `415452440301010d`;
        break;
      case 0x5204:
        str = `415452440304010d`;
        break;
      case 0x5205:
        str = `415452440305010d`;
        break;
      case 0x5206:
        str = `415452440306010d`;
        break;
      case 0x5207:
        str = `415452440307010d`;
        break;
      case 0x520c:
        str = `41545244030c060d`;
        break;
      case 0x5212:
        str = `415452440312030d`;
        break;
      case 0x5215:
        str = `415452440315010d`;
        break;
      case 0x5218:
        str = `415452440318010d`;
        break;
      case 0x521a:
        str = `41545244031a010d`;
        break;
      case 0x521c:
        str = `41545244031c010d`;
        break;
      case 0x521d:
        str = `41545244031d010d`;
        break;
      case 0x521e:
        str = `41545244031e010d`;
        break;
      case 0x521f:
        str = `41545244031f0f0d`;
        break;
      case 0x522e:
        str = `41545244032e010d`;
        break;
      case 0x522f:
        str = `41545244032f0f0d`;
        break;
      case 0x523e:
        str = `41545244033e010d`;
        break;
      case 0x524e:
        str = `41545244034e010d`;
        break;
      case 0x524f:
        str = `41545244034f010d`;
        break;
      case 0x5700:
        str = "41545752";
        str += "XX00";
        data = "";
        data += this.dec2bin(cmd.meshPower, 3);
        data += cmd.meshRepeat_enable == "1" ? "1" : "0";
        data += cmd.meshCom_enable == "1" ? "1" : "0";
        data += cmd.meshSleep_enable == "1" ? "1" : "0";
        data += cmd.meshOffset00_reserved_1 == "1" ? "1" : "0";
        data += cmd.meshOffset00_reserved_0 == "1" ? "1" : "0";
        str += this.bin2hex(data);
        break;
      case 0x5701:
        str = "41545752";
        str += "XX01";
        data = "";
        data += "00";
        data += cmd.meshDelimiter_end_enable == "1" ? "1" : "0";
        data += cmd.meshDelimiter_start_enable == "1" ? "1" : "0";
        data += "0";
        data += cmd.meshExtended_head_enable == "1" ? "1" : "0";
        data += "00";
        str += this.bin2hex(data);
        break;
      case 0x5704:
        str = "41545752";
        str += "XX04";
        data = "";
        data += this.dec2bin(cmd.meshChannel, 5);
        data += this.dec2bin(cmd.meshBaudRate, 3);
        str += this.bin2hex(data);
        break;
      case 0x5705:
        str = "41545752";
        str += "XX05";
        data = "";
        data += this.dec2bin(cmd.meshParity, 2);
        data += this.dec2bin(cmd.meshStop, 2);
        data += "0000";
        str += this.bin2hex(data);
        break;
      case 0x5706:
        str = "41545752";
        str += "XX06";
        str += this.intToHexStr(cmd.meshDelimiter_start, 2);
        break;
      case 0x5707:
        str = "41545752";
        str += "XX07";
        str += this.intToHexStr(cmd.meshDelimiter_end, 2);
        break;
      case 0x5712:
        str = "41545752";
        str += "XX12";
        str += this.intToHexStr(cmd.meshNetworkID, 6);
        break;
      case 0x571a:
        str = "41545752";
        str += "XX1a";
        str += this.intToHexStr(cmd.meshAsyncSleepTime, 2);
        break;
      case 0x571c:
        str = "41545752";
        str += "XX1c";
        str += this.intToHexStr(cmd.meshSyncSleepTime, 2);
        break;
      case 0x571d:
        str = "41545752";
        str += "XX1d";
        str += this.intToHexStr(cmd.meshRepeater, 2);
        break;
      case 0x571e:
        str = "41545752";
        str += "XX1e";
        data = "";
        data += "0000";
        data += this.dec2bin(cmd.meshHandshakeLength, 4);
        str += this.bin2hex(data);
        break;
      case 0x571f:
        str = "41545752";
        str += "XX1f";
        str += cmd.meshHandshake;
        break;
      case 0x572e:
        str = "41545752";
        str += "XX2e";
        data = "";
        data += "00";
        data += cmd.meshOffset2E_reserved_7 == "1" ? "1" : "0";
        data += cmd.meshOffset2E_reserved_6 == "1" ? "1" : "0";
        data += this.dec2bin(cmd.meshFreq, 2);
        data += this.dec2bin(cmd.meshEmptyBufferLength, 4);
        str += this.bin2hex(data);
        break;
      case 0x572f:
        str = "41545752";
        str += "XX2f";
        str += cmd.meshEmptyBuffer;
        break;
      case 0x573e:
        str = "41545752";
        str += "XX3e";
        str += this.intToHexStr(cmd.meshSpeed)
        break;
      case 0x574e:
        str = "41545752";
        str += "XX4e";
        data = "";
        data += "0000";
        data += this.dec2bin(cmd.meshSuccessPacketLength, 4);
        str += this.bin2hex(data);
        break;
      case 0x574f:
        str = "41545752";
        str += "XX4f";
        str += cmd.meshSuccessPacket;
        break;
      default:
        return false;
    }
    if (str.substring(0, 8) == "41545244" || str.substring(0, 8) == "41544349") {
      return str;
    } else if (str.substring(0, 8) == "41545752") {
      str += "0d";
      str = str.replace("XX", this.intToHexStr(str.length / 2 - 5));
    } else if (str.substring(0, 2) === "FC") {
      const dataLen = str.length / 2 - 3;
      str = str.replace("XX", this.intToHexStr(dataLen));
      str = str + this.getChecksum_dtk(str);
    } else {
      const dataLen = str.length / 2 - 4 + 2; //minus 4 bytes for first 4 byte that is not data , add 2 bytes for checksum and ff
      str = str.replace("XX", this.intToHexStr(dataLen));
      str = str + this.getChecksum_dtk(str);
      str += "ff";
    }
    return str;
  }

  ////////////Other general functions/////////////////Other general functions////////////////////Other general functions/////////////
  /**
   *
   * @param {number} i
   * @param {(1|2)} noOfByte
   * @returns
   */
  intToHexStr(i, noOfByte) {
    if (typeof i === "string") return i.padStart(noOfByte || 2, "0");
    const hb = (i >> 8) & 0xff;
    const lb = i & 0xff;
    const hbh = hb < 16 ? "0" + hb.toString(16) : hb.toString(16);
    const lbh = lb < 16 ? "0" + lb.toString(16) : lb.toString(16);
    if (!noOfByte || noOfByte === 1) {
      return lbh;
    } else {
      return hbh + lbh;
    }
  }
  /**
   *
   * @param {string} hexStr
   * @returns
   */
  hexToInt(hexStr) {
    return parseInt(hexStr, 16);
  }
  /**
 * Executes a callback function on each item in an array, up to a specified concurrency limit, and then calls a completion callback with the results.
 * replaced old version asyncForEach that commanted below
 * @async
 * @param {Array} array - The array to iterate over.
 * @param {function} callback - The callback function to execute on each item. This function should return a Promise and accept three arguments: the current item, its index, and the original array.
 * @param {function} onCompleteCallback - The callback function to execute after all items have been processed. This function will be passed an array of the results of the callback function.
 * @param {number} [concurrency=1] - The maximum number of concurrent executions of the callback function.
 * @returns {Promise<Array>} A Promise that resolves to an array of the results of the callback function when all items have been processed and the completion callback has been called.
 *
 * @example
 * asyncForEach(
 *   [1, 2, 3],
 *   (item, index, array) => new Promise((resolve) => {
 *     setTimeout(() => {
 *       console.log(item);
 *       resolve(item * 2);
 *     }, 1000);
 *   }),
 *   (results) => console.log('All done:', results),
 *   2
 * );
 */
  async asyncForEach(array, callback, onCompleteCallback, concurrency) {
    var promiseLimit = require('promise-limit')
    var limit = promiseLimit(concurrency || 1)
    let results = []
    if (array?.length > 0)
      await Promise.all(array.map((item, index) => {
        return limit(() => callback(item, index, array, limit.queue))
      })).then(async r => results = r)
    if (onCompleteCallback) await onCompleteCallback(results);
    return results
  }
  // async asyncForEach(array, callback, onCompleteCallback) {
  //   if (array?.length > 0) {
  //     for (let index = 0; index < array?.length; index++) {
  //       await callback(array[index], index, array);
  //     }
  //   }
  //   if (onCompleteCallback) await onCompleteCallback();
  // }
  waitFor(ms) {
    return new Promise((r) => setTimeout(r, ms));
  }
  /**
   *
   * @param {number} min
   * @param {number} max
   * @returns
   */
  randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  arrayEquals(a, b) {
    if ((a || []).length !== (b || []).length) return false;
    const uniqueVal = new Set([...a, ...b]);
    for (const v of uniqueVal) {
      const aCount = a.filter((e) => e === v).length;
      const bCount = b.filter((e) => e === v).length;
      if (aCount !== bCount) return false;
    }
    return true;
  }
  getRandomHexID(noOfByte) {
    let randomID = "";

    for (let i = 0; i < noOfByte; i++) {
      const b = Math.floor(Math.random() * 254);
      const h = b < 16 ? "0" + b.toString(16) : b.toString(16);
      randomID += h;
    }
    return randomID;
  }
  newArrayBetween(start, end) {
    if (start === undefined || end === undefined || start > end || start === null || end === null) return [];
    return Array(end - start + 1)
      .fill()
      .map((_, idx) => start + idx);
  }
  isEmptyJson(obj) {
    return Object.keys(obj || {}).length === 0;
  }
  arrayRemoveDuplicateBy(arr, duplicateField) {
    let newArray = [];
    let uniqueObject = {};
    for (let i in arr) {
      const objTitle = arr[i][duplicateField];
      uniqueObject[objTitle] = arr[i];
    }
    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }
    return newArray;
  }
  weekDayStringOf(isoWeekDay) {
    const obj = {
      1: "Mon",
      2: "Tue",
      3: "Wed",
      4: "Thu",
      5: "Fri",
      6: "Sat",
      7: "Sun",
      100: "All week",
    };
    return obj[isoWeekDay];
  }
  weekDayShortStringOf(isoWeekDay) {
    const obj = {
      1: "M",
      2: "T",
      3: "W",
      4: "T",
      5: "F",
      6: "S",
      7: "S",
      100: "All",
    };
    return obj[isoWeekDay];
  }
  macStringOf(arr) {
    let macString = "";
    arr?.forEach((m, key) => {
      if (m < 16) {
        macString += "0" + m.toString(16);
      } else {
        macString += m.toString(16);
      }

      if (key < 5) macString += ".";
    });
    return macString;
  }
  apStringOf(arr) {
    let apString = "Skymon_";
    arr?.forEach((m, key) => {
      if (m < 16) {
        apString += "0" + m.toString(16);
      } else {
        apString += m.toString(16);
      }
    });
    return apString;
  }
  ipStringOf(arr) {
    let ipString = "";
    arr?.forEach((p, key) => {
      ipString += p;
      if (key < 3) ipString += ".";
    });
    return ipString;
  }
  validateEmail(inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.match(mailformat)) {
      return true;
    } else {
      return false;
    }
  }
  randomstring(n) {
    const str = Math.random().toString(36).slice(-n);
    return str;
  }
  async fetchWithTimeout(resource, options = {}) {
    const { timeout = 8000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);

    return response;
  }
  calculateChecksum(strWithoutFF) {
    //for gwCommandToZbStr use
    const zbAddValH = this.hexToInt(strWithoutFF.substring(8, 10));
    const zbAddValL = this.hexToInt(strWithoutFF.substring(10, 12));
    let sum = 0;
    for (let i = 0; i < strWithoutFF.length / 2; i++) {
      const val = this.hexToInt(strWithoutFF.substring(2 * i, 2 * i + 2));
      sum += val;
    }
    sum = sum - zbAddValH - zbAddValL; //sum not include zigbee address
    // console.log({ sum });
    let checksum = sum & 0xff; //low byte
    if (checksum === 0xff || checksum === 0xfe || checksum === 0xfd) {
      checksum = checksum - 9;
    }
    // console.log(checksum.toString(16));
    return checksum;
  }
  insertChecksumZB(str) {
    const strWithoutFELenFF = str.substring(4, str.length - 2);
    const originalDataLen = this.hexToInt(str.substring(2, 4));
    const newDataLen = originalDataLen + 1;
    const newDataLenStr = this.intToHexStr(newDataLen);
    const strWithoutFF = "fe" + newDataLenStr + strWithoutFELenFF;
    const checksum = this.calculateChecksum(strWithoutFF);
    let output = strWithoutFF + this.intToHexStr(checksum) + "ff";
    return output;
  }
  removeChecksumZB(str) {
    let newStr = str.substring(4, str.length - 4);
    const newDataLen = this.hexToInt(str.substring(2, 4)) - 1;
    const newDataLenStr = this.intToHexStr(newDataLen);
    newStr = "fe" + newDataLenStr + newStr + "ff";
    return newStr;
  }
  verifyChecksum(str) {
    // for zbStrToJson use
    const len = str.length;
    const checksum = this.hexToInt(str.substring(len - 4, len - 2));
    const strForCheck = str.substring(0, len - 4);
    const checksumCalc = this.calculateChecksum(strForCheck);
    return { checksumByte: checksum, checksumCalc };
  }
  getChecksum_dtk = (str) => {
    let ary = [];
    for (let i = 0; i < str.length; i += 2) {
      ary.push(parseInt(str[i] + str[i + 1], 16));
    }
    if (ary.length === 0) return "00";
    const sum = ary.reduce((a, b) => a + b);
    const sumStr = sum.toString(2);
    const sumStr_dec = sumStr.substring(sumStr.length - 8, sumStr.length);
    const sumStr16 = parseInt(sumStr_dec, 2).toString(16).padStart(2, "0");
    if (sumStr16 === "ff") return "fe";
    return sumStr16;
  };
  bitRead = (a, b) => {
    return (a >> b) & 1;
  };
  bitWrite = (n, offset, value) => {
    return (n & ~(1 << offset)) | ((value & 1) << offset);
  };
  bin2dec = (bin) => {
    return parseInt(bin, 2).toString(10);
  };
  dec2bin = (dec, pad) => {
    return (dec >>> 0).toString(2).padStart(pad, "0");
  };
  bin2hex = (bin) => {
    return parseInt(bin, 2).toString(16).padStart(2, "0");
  };
  dtkActionCmdToMsg = (json, deviceID, returnName) => {
    if (this.isEmptyJson(json)) return "";
    const { commandCode, dtkAdd, pwm, lockLevel, releaseOnDelayEnd, delayedPwm, delayedPwm2, shortAdd } = json || {};
    const delaySec = json?.delaySec || json?.delayed_action;
    const delaySec2 = json?.delaySec2 || json?.delayed_action2;
    let msg = "", commandName = "";
    if (deviceID) {
      msg += `\u{01f194}${deviceID} `;
      if (dtkAdd) msg += `@${dtkAdd} `;
    }
    const hexCommandCode = typeof commandCode === "string" ? parseInt(commandCode, 10) : commandCode;
    const codeMsg = { 1: "successfully", 3: "fail on get latest ver", 4: "fail on update spiffs", 5: "fail on update firmware", 6: "fail on connect wifi" };
    switch (hexCommandCode) {
      case 0x0201:
        msg += "request light report current data";
        commandName = "controlLight_requestCurrentData";
        break;
      case 0x0202:
        msg += `light \u{01f512}${lockLevel} ${pwm > 0 ? "ON" : "OFF"}  `;
        if (pwm > 0) msg += ` ${pwm}%`;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlLight_noDelay";
        break;
      case 0x0203:
        msg += `light \u{01f512}${lockLevel} ${pwm}% ->${delaySec}s-> ${delayedPwm}%`;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlLight_1delay";
        break;
      case 0x0204:
        msg += `light \u{01f512}${lockLevel} ${pwm}% ->${delaySec}s-> ${delayedPwm}% ->${delaySec2}s-> ${delayedPwm2}%`;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlLight__2delay";
        break;
      case 0x0205:
        msg += `light \u{01f512}${lockLevel} light on/off toggle ->`;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlLight_toggle";
        break;
      case 0x0206:
        msg += `bat light ${json.onoffcontrolL === 0 ? "resume" : "cut"} power`;
        commandName = "controlLight_controlL";
        break;
      case 0x0207:
        msg += `Start setting to light`;
        commandName = "controlLight_startSettingToLight";
        break;
      case 0x0208:
        msg += `Light on/off flashing ${json.flashTimes} times`;
        commandName = "controlLight_flashControlA";
        break;
      case 0x0209:
        msg += `Light battery test start | ${json.reportType} | ID${json.reportID} | ${json.totalTestTime}s | reschedule ${json.rescheduleCount}`;
        commandName = "controlLight_batteryTestStart";
        break;
      case 0x020a:
        msg += `Terminate battery test`;
        commandName = "controlLight_batteryTestTerminate";
        break;
      case 0x020c:
        msg += `Light change lock level to ${json.lockLevel}`;
        commandName = "controlLight_changeLockLevel";
        break;
      case 0x020d:
        msg += `Light change enableA to ${json.enableA?.toString()}`;
        commandName = "controlLight_changeEnableA";
        break;
      case 0x020e:
        msg += `Light change enableL to ${json.enableL?.toString()}`;
        commandName = "controlLight_changeEnableL";
        break;
      case 0x020f:
        msg += `Light change enableBat to ${json.enableBat?.toString()}`;
        commandName = "controlLight_changeEnableBat";
        break;
      case 0x0210:
        msg += `Light change enableDim to ${json.enableDim?.toString()}`;
        commandName = "controlLight_changeEnableDim";
        break;
      case 0x0211:
        msg += `Light change dimTransition to ${json.dimTransition}`;
        commandName = "controlLight_changeDimTransition";
        break;
      case 0x0212:
        msg += `Light change dimTransitON to ${json.dimTransitON}`;
        commandName = "controlLight_changeDimTransitON";
        break;
      case 0x0213:
        msg += `Light change dimTransitOFF to ${json.dimTransitOFF}`;
        commandName = "controlLight_changeDimTransitOFF";
        break;
      case 0x0214:
        msg += `Light change cutDimOnBypass to ${json.cutDimOnBypass?.toString()}`;
        commandName = "controlLight_changeCutDimOnBypass";
        break;
      case 0x0215:
        msg += `Light change reverseA to ${json.reverseA?.toString()}`;
        commandName = "controlLight_changeReverseA";
        break;
      case 0x0216:
        msg += `Light change controlA pin to ${json.controlAPin}`;
        commandName = "controlLight_changeControlAPin";
        break;
      case 0x0217:
        msg += `Light change controlL pin to ${json.controlLPin}`;
        commandName = "controlLight_changeControlLPin";
        break;
      case 0x0218:
        msg += `Light change regular_time_interval to ${json.regular_time_interval}`;
        commandName = "controlLight_changeRegularTimeInterval";
        break;
      case 0x0219:
        msg += `Light change survival_time_interval to ${json.survival_time_interval}`;
        commandName = "controlLight_changeSurvivalTimeInterval";
        break;
      case 0x021a:
        msg += `Command light restart system`;
        commandName = "controlLight_restartSystem";
        break;
      case 0x021b:
        msg += `Command light general reply`;
        commandName = "controlLight_requestGeneralReply";
        break;
      case 0x021d:
        msg += `Acknowledge receive msg from light | ${json.replyCommandCode?.toString(16)}`;
        commandName = "controlLight_acknowledgeReceiveMsg";
        break;
      case 0x021e:
        msg += `Control aircon ON type ${json.acType}`;
        commandName = "controlLight_controlAirconON";
        break;
      case 0x021f:
        msg += `Control aircon OFF type ${json.acType}`;
        commandName = "controlLight_controlAirconOFF";
        break;
      case 0x0220:
        msg += `Control aircon set fan type ${json.acType} | fan ${json.fanValue}`;
        commandName = "controlLight_controlAirconSetFan";
        break;
      case 0x0221:
        msg += `Control aircon set temp type ${json.acType} | temp ${json.tempValue}`;
        commandName = "controlLight_controlAirconSetTemp";
        break;
      case 0x0222:
        msg += `Change enable aircon control ${json.enableAirconControl?.toString()}`;
        commandName = "controlLight_changeEnableAirconControl";
        break;
      case 0x0223:
        msg += `Change input bypass pin ${json.inputBypassPin}`;
        commandName = "controlLight_changeInputBypassPin";
        break;
      case 0x0224:
        msg += `Request light update firmware - updateSpiffs ${json.updateSpiffs?.toString()}`;
        commandName = "controlLight_requestUpdateFirmware";
        break;
      case 0x0225:
        msg += `Change ota ssid ${json.otaSsid}`;
        commandName = "controlLight_changeOtaSsid";
        break;
      case 0x0226:
        msg += `Change ota password ${json.otaPassword}`;
        commandName = "controlLight_changeOtaPassword";
        break;
      case 0x0227:
        msg += `Request light send start msg`;
        commandName = "controlLight_requestSendStartMsg";
        break;
      case 0x0228:
        msg += `Request light test setting read/write`;
        commandName = "controlLight_requestTestSettingReadWrite";
        break;
      case 0x0229:
        msg += `Change disable ESPNOW ${json.disableEspNow?.toString()}`;
        commandName = "controlLight_changeDisableEspNow";
        break;
      case 0x022a:
        msg += `Control A relay ${json.controlA}`;
        commandName = "controlLight_controlARelay";
        break;
      case 0x022b:
        msg += `Control B relay ${json.controlB}`;
        commandName = "controlLight_controlBRelay";
        break;
      case 0x022c:
        msg += `Control D relay ${json.controlD}`;
        commandName = "controlLight_controlDRelay";
        break;
      case 0x022d:
        msg += `Change enable EspOut ${json.enableEspOut?.toString()}`;
        commandName = "controlLight_changeEnableEspOut";
        break;
      case 0x022e:
        msg += `Change controlB pin to ${json.controlBPin}`;
        commandName = "controlLight_changeControlBPin";
        break;
      case 0x022f:
        msg += `Change controlD pin to ${json.controlDPin}`;
        commandName = "controlLight_changeControlDPin";
        break;
      case 0x0230:
        const serverIP0230 = json?.serverIP || [];
        const ip = serverIP0230.join(".");
        msg += `Request light update firmware - updateSpiffs ${json.updateSpiffs?.toString()} from IP ${ip}`;
        commandName = "controlLight_requestUpdateFirmwareFromIP";
        break;
      case 0x0231:
        msg += `Change enableDali ${json.enableDali?.toString()}`;
        commandName = "controlLight_changeEnableDali";
        break;
      case 0x0232:
        msg += `Change enable turn on on disconnect ${json.enableTurnOnOnDisconnect?.toString()}`;
        commandName = "controlLight_changeEnableTurnOnOnDisconnect";
        break;
      case 0x0233:
        msg += "Reset on disconnect timer";
        commandName = "controlLight_resetOnDisconnectTimer";
        break;
      case 0x0234:
        msg += `Change switch sequence ${json.switchSequence}`;
        commandName = "controlLight_changeSwitchSequence";
        break;
      case 0x0235:
        msg += `light \u{01f512}${lockLevel} `;
        if (json.stepUp) msg += `\u{01f53c} ${json.dimStepSize}%`;
        else msg += `\u{01f53d} ${json.dimStepSize}%`;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlLight_stepDim";
        break;
      case 0x0236:
        msg += `Start flash light on/off`;
        commandName = "controlLight_startFlash";
        break;
      case 0x0237:
        msg += `Stop flash light on/off`;
        commandName = "controlLight_stopFlash";
        break;
      case 0x0238:
        msg += `light save group action - groupID ${json.groupID} setting${json.settingNum} command: ${json.command}`;
        commandName = "controlLight_saveGroupAction";
        break;
      case 0x0239:
        msg += `light delete group action - groupID ${json.groupID} setting${json.settingNum}`;
        commandName = "controlLight_deleteGroupAction";
        break;
      case 0x023a:
        msg += `light enableAcknowledge - ${json.enableAcknowledge ? "true" : "false"}`;
        commandName = "controlLight_enableAcnowledge";
        break;
      case 0x023b:
        msg += `light execute group action - ${json.groupID} setting${json.settingNum}`;
        commandName = "controlLight_executeGroupAction";
        break;
      case 0x023c:
        msg += "light delete all group action";
        commandName = "controlLight_deleteAllGroupAction";
        break;
      case 0x023d:
        msg += `Change disableDtk ${json.disableDtk?.toString()}`;
        commandName = "controlLight_changeDisableDtk";
        break;
      case 0x0280:
        msg += `Change dtkInfo - type:${json.dtkType} | panID:${json.dtkPanID} | channel:${json.dtkChannel} | transferMode:${json.dtkTransferMode} | add:${json.dtkAdd} | loraParameter:${json.loraParameter}`;
        commandName = "controlLight_changeDtkInfo";
        break;
      case 0x0287:
        msg += `Request reset DTK module`;
        commandName = "controlLight_requestResetDtkModule";
        break;
      case 0x02a2:
        msg += `Change mesh channel to ${json.meshChannel}`;
        commandName = "controlLight_changeMeshChannel";
        break;
      case 0x02a3:
        msg += `Change mesh frequency to ${json.meshFreq}`;
        commandName = "controlLight_changeMeshFrequency";
        break;
      case 0x02a4:
        msg += `Change mesh speed to ${json.meshSpeed}`;
        commandName = "controlLight_changeMeshSpeed";
        break;
      case 0x02a5:
        msg += `Change mesh power to ${json.meshPower}`;
        commandName = "controlLight_changeMeshPower";
        break;
      case 0x02a6:
        msg += `Change mesh networkID to ${json.meshNetworkID}`;
        commandName = "controlLight_changeMeshNetworkID";
        break;
      case 0x02a7:
        msg += `Change mesh definedAdd to ${json.meshDefinedAdd}`;
        commandName = "controlLight_changeMeshDefinedAdd";
        break;
      case 0x02a8:
        msg += `Change mesh enableRepeat to ${json.meshEnableRepeat?.toString()}`;
        commandName = "controlLight_changeMeshEnableRepeat";
        break;
      case 0x02aa:
        msg += `Request mesh module restart`;
        commandName = "controlLight_requestMeshModuleRestart";
        break;
      case 0x0301:
        msg += "query lock level";
        commandName = "controlLight_queryLockLevel";
        break;
      case 0x0302:
        msg += "query enableA";
        commandName = "controlLight_queryEnableA";
        break;
      case 0x0303:
        msg += "query enableL";
        commandName = "controlLight_queryEnableL";
        break;
      case 0x0304:
        msg += "query enableBat";
        commandName = "controlLight_queryEnableBat";
        break;
      case 0x0305:
        msg += "query enableDim";
        commandName = "controlLight_queryEnableDim";
        break;
      case 0x0306:
        msg += "query dimTransition";
        commandName = "controlLight_queryDimTransition";
        break;
      case 0x0307:
        msg += "query dimTransitON";
        commandName = "controlLight_queryDimTransitON";
        break;
      case 0x0308:
        msg += "query dimTransitOFF";
        commandName = "controlLight_queryDimTransitOFF";
        break;
      case 0x0309:
        msg += "query cutDimOnBypass";
        commandName = "controlLight_queryCutDimOnBypass";
        break;
      case 0x030a:
        msg += "query reverseA";
        commandName = "controlLight_queryReverseA";
        break;
      case 0x030b:
        msg += "query controlA pin";
        commandName = "controlLight_queryControlAPin";
        break;
      case 0x030c:
        msg += "query controlL pin";
        commandName = "controlLight_queryControlLPin";
        break;
      case 0x030d:
        msg += "query regular time interval";
        commandName = "controlLight_queryRegularTimeInterval";
        break;
      case 0x030e:
        msg += "query survival time interval";
        commandName = "controlLight_querySurvivalTimeInterval";
        break;
      case 0x0310:
        msg += "query enable aircon control";
        commandName = "controlLight_queryEnableAirconControl";
        break;
      case 0x0311:
        msg += "query input bypass pin";
        commandName = "controlLight_queryInputBypassPin";
        break;
      case 0x0312:
        msg += "query ota ssid";
        commandName = "controlLight_queryOtaSsid";
        break;
      case 0x0313:
        msg += "query ota password";
        commandName = "controlLight_queryOtaPassword";
        break;
      case 0x0314:
        msg += "query current firmware version";
        commandName = "controlLight_queryCurrentFirmwareVersion";
        break;
      case 0x0315:
        msg += "query mac address";
        commandName = "controlLight_queryMacAddress";
        break;
      case 0x0316:
        msg += "query disableEspNow";
        commandName = "controlLight_queryDisableEspNow";
        break;
      case 0x0317:
        msg += "query enableEspOut";
        commandName = "controlLight_queryEnableEspOut";
        break;
      case 0x0318:
        msg += "query controlB pin";
        commandName = "controlLight_queryControlBPin";
        break;
      case 0x0319:
        msg += "query controlD pin";
        commandName = "controlLight_queryControlDPin";
        break;
      case 0x031a:
        msg += "query delay countdown";
        commandName = "controlLight_queryDelayCountdown";
        break;
      case 0x031b:
        msg += "query enableDali";
        commandName = "controlLight_queryEnableDali";
        break;
      case 0x031c:
        msg += "query wifiApMacAddress";
        commandName = "controlLight_queryWifiApMacAddress";
        break;
      case 0x031d:
        msg += "query enableTurnOnOnDisconnect";
        commandName = "controlLight_queryEnableTurnOnOnDisconnect";
        break;
      case 0x031e:
        msg += "query switch sequence";
        commandName = "controlLight_querySwitchSequence";
        break;
      case 0x031f:
        msg += "query macUploadNode";
        commandName = "controlLight_queryMacUploadNode";
        break;
      case 0x0320:
        msg += "query light fault";
        commandName = "controlLight_queryLightFault";
        break;
      case 0x0321:
        msg += `query light group action - groupID:${json.groupID} setting${json.settingNum}`;
        commandName = "controlLight_queryLightGroupAction";
        break;
      case 0x0322:
        msg += "query light enable acknowledge";
        commandName = "controlLight_queryLightEnableAcknowledge";
        break;
      case 0x0323:
        msg += "query light group action quantity";
        commandName = "controlLight_queryLightGroupActionQuantity";
        break;
      case 0x0324:
        msg += "query bypass status";
        commandName = "controlLight_queryBypassStatus";
        break;
      case 0x0325:
        msg += "query disableDtk";
        commandName = "controlLight_queryDisableDtk";
        break;
      case 0x0380:
        msg += "query dtkInfo";
        commandName = "controlLight_queryDtkInfo";
        break;
      case 0x0383:
        msg += "query dtkChannel";
        commandName = "controlLight_queryDtkChannel";
        break;
      case 0x03a0:
        msg += "query meshMacAddress";
        commandName = "controlLight_queryMeshMacAddress";
        break;
      case 0x03a1:
        msg += "query meshInfo";
        commandName = "controlLight_queryMeshInfo";
        break;
      case 0x03a2:
        msg += "query meshChannel";
        commandName = "controlLight_queryMeshChannel";
        break;
      case 0x03a3:
        msg += "query meshFrequency";
        commandName = "controlLight_queryMeshFrequency";
        break;
      case 0x03a4:
        msg += "query meshSpeed";
        commandName = "controlLight_queryMeshSpeed";
        break;
      case 0x03a5:
        msg += "query meshPower";
        commandName = "controlLight_queryMeshPower";
        break;
      case 0x03a6:
        msg += "query meshNetworkID";
        commandName = "controlLight_queryMeshNetworkID";
        break;
      case 0x03a7:
        msg += "query meshDefinedAdd";
        commandName = "controlLight_queryMeshDefinedAdd";
        break;
      case 0x03a8:
        msg += "query meshEnableRepeat";
        commandName = "controlLight_queryMeshEnableRepeat";
        break;
      case 0x03a9:
        msg += "query meshBaudrate";
        commandName = "controlLight_queryMeshBaudrate";
        break;
      case 0x03fc:
        msg += "broadcast ping light";
        commandName = "controlLight_broadcastPingLight";
        break;
      case 0x0401:
        msg += `light general reply`;
        commandName = "lightReport_generalReply";
        break;
      case 0x0402:
        msg += `light request gateway send start`;
        commandName = "lightReport_requestGatewaySendStart";
        break;
      case 0x0403:
        msg += `Report batteryStatus - power ${json.onoffstatusL === 0 ? "resume" : "cut"} | ${json.voltage}V | ${json.current}A`;
        commandName = "lightReport_batteryStatus";
        break;
      case 0x0404:
        msg += `Report lightStatus - Switch ${json.lightLv > 0 ? "ON" : "OFF"} ${json.lightLv}% \u{01f512}${json.lockLevel} `;
        commandName = "lightReport_lightStatus";
        break;
      case 0x0406:
        msg += `System start - ver ${json.version}`;
        commandName = "lightReport_systemStart";
        break;
      case 0x0408:
        msg += "Battery test start";
        commandName = "lightReport_batteryTestStart";
        break;
      case 0x0409:
        msg += `Battery test upload data | reportID ${json.reportID} | ${json.progress}% | ${json.voltage}V | ${json.current}A`;
        commandName = "lightReport_batteryTestUploadData";
      case 0x040a:
        msg += `Battery test finished ${json.reportID} | result ${json.result} | testTime ${json.testTime}s`;
        commandName = 'lightReport_batteryTestFinish';
      case 0x040b:
        msg += `System start - ver ${json.version}`;
        commandName = "lightReport_meshLightSystemStart";
        break;
      case 0x040c:
        msg += `Report confirm change dtk setting`;
        commandName = "lightReport_confirmChangeDtkSetting";
        break;
      case 0x0501:
        msg += `Report lock level - ${json.lockLevel}`;
        commandName = "lightReport_lockLevel";
        break;
      case 0x0502:
        msg += `Report enableA - ${json.enableA?.toString()}`;
        commandName = "lightReport_enableA";
        break;
      case 0x0503:
        msg += `Report enableL - ${json.enableL?.toString()}`;
        commandName = "lightReport_enableL";
        break;
      case 0x0504:
        msg += `Report enableBat - ${json.enableBat?.toString()}`;
        commandName = "lightReport_enableBat";
        break;
      case 0x0505:
        msg += `Report enableDim - ${json.enableDim?.toString()}`;
        commandName = "lightReport_enableDim";
        break;
      case 0x0506:
        msg += `Report dimTransition - ${json.dimTransition}`;
        commandName = "lightReport_dimTransition";
        break;
      case 0x0507:
        msg += `Report dimTransitON - ${json.dimTransitON}`;
        commandName = "lightReport_dimTransitON";
        break;
      case 0x0508:
        msg += `Report dimTransitOFF - ${json.dimTransitOFF}`;
        commandName = "lightReport_dimTransitOFF";
        break;
      case 0x0509:
        msg += `Report cutDimOnBypass - ${json.cutDimOnBypass?.toString()}`;
        commandName = "lightReport_cutDimOnBypass";
        break;
      case 0x050a:
        msg += `Report reverseA - ${json.reverseA?.toString()}`;
        commandName = "lightReport_reverseA";
        break;
      case 0x050b:
        msg += `Report controlA pin - ${json.controlAPin}`;
        commandName = 'lightReport_controlAPin';
        break;
      case 0x050c:
        msg += `Report controlL pin - ${json.controlLPin}`;
        commandName = 'lightReport_controlLPin';
        break;
      case 0x050d:
        msg += `Report regular_time_interval - ${json.regular_time_interval}`;
        commandName = 'lightReport_regular_time_interval';
        break;
      case 0x050e:
        msg += `Report survival_time_interval - ${json.survival_time_interval}`;
        commandName = 'lightReport_survival_time_interval';
        break;
      case 0x0510:
        msg += `Report enable aircon control - ${json.enableAirconControl?.toString()}`;
        commandName = 'lightReport_enableAirconControl';
        break;
      case 0x0511:
        msg += `Report input bypass pin - ${json.inputBypassPin}`;
        commandName = 'lightReport_inputBypassPin';
        break;
      case 0x0512:
        msg += `Report ota ssid - ${json.otaSsid}`;
        commandName = 'lightReport_otaSsid';
        break;
      case 0x0513:
        msg += `Report ota password - ${json.otaPassword}`;
        commandName = 'lightReport_otaPassword';
        break;
      case 0x0514:
        msg += `Report current firmware version - ${json.version}`;
        commandName = 'lightReport_currentFirmwareVersion';
        break;
      case 0x0515:
        msg += `report update firmware status - [${json.statusCode}] ${codeMsg[json.statusCode]}`;
        commandName = 'lightReport_updateFirmwareStatus';
        break;
      case 0x0516:
        msg += `Report mac address - ${json.macAddress}`;
        commandName = "lightReport_macAddress";
        break;
      case 0x0517:
        msg += `Report test setting read/write - ${json.result?.toString()}`;
        commandName = "lightReport_testSettingReadWrite";
        break;
      case 0x0518:
        msg += `Report disabledEspNow - ${json.disableEspNow?.toString()}`;
        commandName = "lightReport_disabledEspNow";
        break;
      case 0x0519:
        msg += `Report enableEspOut - ${json.enableEspOut?.toString()}`;
        commandName = "lightReport_enableEspOut";
        break;
      case 0x051a:
        msg += `Report controlB pin - ${json.controlBPin}`;
        commandName = "lightReport_controlBPin";
        break;
      case 0x051b:
        msg += `Report controlD pin - ${json.controlDPin}`;
        commandName = "lightReport_controlDPin";
        break;
      case 0x051c:
        msg += `Report delay countdown - ${json.delayCountDown} / ${json.delayCountDown2}`;
        commandName = "lightReport_delayCountDown";
        break;
      case 0x051d:
        msg += `Report enable dali - ${json.enableDali?.toString()}`;
        commandName = "lightReport_enableDali";
        break;
      case 0x051e:
        msg += `Report enable turn on on disconnect - ${json.enableTurnOnOnDisconnect?.toString()}`;
        commandName = "lightReport_turnOnOnDisconnect";
        break;
      case 0x051f:
        msg += `Report wifiApMacAddress - ${json.wifiApMacAddress} `;
        commandName = "lightReport_wifiApMacAddress";
        break;
      case 0x0520:
        msg += `light report switch sequence - ${json.switchSequence}`;
        commandName = "lightReport_switchSequence";
        break;
      case 0x0521:
        const macStr0521 = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `light reportMacUploadNode - ${macStr0521}`;
        commandName = "lightReport_macUploadNode";
        break;
      case 0x0522:
        msg += `light report fault - ${json.faultCode} -`;
        if (json.lowMemory) msg += "RAM, ";
        if (json.i2cError) msg += "i2c eror, ";
        if (json.batLowVolt) msg += "bat low volt, ";
        if (json.batHighVolt) msg += "bat high volt, ";
        if (json.statusAMismatch) msg += "status A mismatch, ";
        if (json.mcpFail) msg += "mcp fail, ";
        if (json.coreTempFault) msg += "coreTemp, ";
        commandName = "lightReport_fault";
        break;
      case 0x0523:
        msg += `light report enableAcknowledge - ${json.enableAcknowledge?.toString()}`;
        commandName = "lightReport_enableAcknowledge";
        break;
      case 0x0524:
        msg += `light report group action - groupID:${json.groupID} setting${json.settingNum} | command:${json.command || "-"}`;
        commandName = "lightReport_groupAction";
        break;
      case 0x0525:
        msg += `light report delete all group action`;
        commandName = "lightReport_deleteAllGroupAction";
        break;
      case 0x0526:
        msg += `light report group action quantity`;
        commandName = "lightReport_GroupActionQuantity";
        break;
      case 0x0527:
        msg += `light report bypass status - ${json.bypass}`;
        commandName = "lightReport_bypassStatus";
        break;
      case 0x0528:
        msg += `report update firmware start`;
        commandName = "lightReport_updateFirmwareStart";
        break;
      case 0x0529:
        msg += `report disableDtk - ${json.disableDtk?.toString()}`;
        commandName = "lightReport_disableDtk";
        break;
      case 0x0580:
        msg += `report dtkInfo - type:${json.dtkType} | panID:${json.dtkPanID} | channel:${json.dtkChannel} | transferMode:${json.dtkTransferMode} | add:${json.dtkAdd} | loraParameter:${json.loraParameter}`;
        commandName = "lightReport_dtkInfo";
        break;
      case 0x0583:
        msg += `report dtkChannel - ${json.dtkChannel}`;
        commandName = "lightReport_dtkChannel";
        break;
      case 0x05a0:
        msg += `report meshMacAddress - ${json.meshMacAddress}`;
        commandName = "lightReport_meshMacAddress";
        break;
      case 0x05a1:
        msg += `report meshInfo - ${json.meshInfo}`;
        commandName = "lightReport_meshInfo";
        break;
      case 0x05a2:
        msg += `report meshChannel - ${json.meshChannel}`;
        commandName = "lightReport_meshChannel";
        break;
      case 0x05a3:
        msg += `report meshFrequency - ${json.meshFreq}`;
        commandName = "lightReport_meshFrequency";
        break;
      case 0x05a4:
        msg += `report meshSpeed - ${json.meshSpeed}`;
        commandName = "lightReport_meshSpeed";
        break;
      case 0x05a5:
        msg += `report meshPower - ${json.meshPower}`;
        commandName = "lightReport_meshPower";
        break;
      case 0x05a6:
        msg += `report meshNetworkID - ${json.meshNetworkID}`;
        commandName = "lightReport_meshNetworkID";
        break;
      case 0x05a7:
        msg += `report meshDefinedAdd - ${json.meshDefinedAdd}`;
        commandName = "lightReport_meshDefinedAdd";
        break;
      case 0x05a8:
        msg += `report meshEnableRepeat - ${json.meshEnableRepeat?.toString()}`;
        commandName = "lightReport_meshEnableRepeat";
        break;
      case 0x05a9:
        msg += `report change mesh info fail`;
        commandName = "lightReport_changeMeshInfoFail";
        break;
      case 0x0601:
        msg += "request sensor report current data";
        commandName = "controlSensor_requestCurrentData";
        break;
      case 0x0602:
        msg += `Change disable sensor to ${json.disabledSensor?.toString()}`;
        commandName = "controlSensor_changeDisableSensor";
        break;
      case 0x0603:
        msg += `Start setting to motion sensor | mode:${json.sensorMode} disable:${json.disabledSensor?.toString()} hasIR:${json.hasIR?.toString()} delaySec:${json.delaySec} delaySec2:${json.delaySec2} dist:${json.dist} dist2:${json.sensorDist}`;
        commandName = "controlSensor_startSettingToMotionSensor";
        break;
      case 0x0604:
        msg += `Start setting to daylight snesor | diable:${json.disabledSensor?.toString()}`;
        commandName = "controlSensor_startSettingToDaylightSensor";
        break;
      case 0x0605:
        msg += `Start setting to light switch | disable:${json.disabledSensor?.toString()} gang:${json.gang}`;
        commandName = "controlSensor_startSettingToLightSwitch";
        break;
      case 0x0606:
        msg += `Start setting to daylight motion sensor | mode:${json.sensorMode} disable:${json.disabledSensor?.toString()} hasIR:${json.hasIR?.toString()} delaySec:${json.delaySec} delaySec2:${json.delaySec2} dist:${json.dist} dist2:${json.sensorDist}`;
        commandName = "controlSensor_startSettingToDaylightMotionSensor";
        break;
      case 0x0607:
        msg += `Start setting to scene button | disable:${json.disabledSensor?.toString()} gang:${json.gang}`;
        commandName = "controlSensor_startSettingToSceneButton";
        break;
      case 0x0608:
        msg += `Request sensor restart system`;
        commandName = "controlSensor_restartSystem";
        break;
      case 0x0609:
        msg += `Acknowledge receive msg from sensor | ${json.replyCommandCode?.toString(16)}`;
        commandName = "controlSensor_acknowledgeReceiveMsg";
        break;
      case 0x060a:
        msg += `Request sensor update firmware - updateSpiffs ${json.updateSpiffs?.toString()}`;
        commandName = "controlSensor_requestUpdateFirmware";
        break;
      case 0x060b:
        msg += `Change sensor ota ssid ${json.otaSsid}`;
        commandName = "controlSensor_changeOtaSsid";
        break;
      case 0x060c:
        msg += `Change sensor ota password ${json.otaPassword}`;
        commandName = "controlSensor_changeOtaPassword";
        break;
      case 0x060d:
        msg += `Change sensor type ${json.sensorType}`;
        commandName = "controlSensor_changeSensorType";
        break;
      case 0x060e:
        msg += `Change sensor dist ${json.sensorDist}`;
        commandName = "controlSensor_changeSensorDist";
        break;
      case 0x060f:
        const mode = { 0: "microwave only", 1: "microwave & PIR", 2: "microwave or PIR", 3: "PIR only" };
        msg += `Change sensor mode to ${mode[json.sensorMode]}[${json.sensorMode}]`;
        commandName = "controlSensor_changeSensorMode";
        break;
      case 0x0610:
        msg += `Change sensor IR status to ${json.hasIR?.toString()}`;
        commandName = "controlSensor_changeSensorIRStatus";
        break;
      case 0x0611:
        if (json.disabledSensor) msg += "disable \u{01f6ab} sensor";
        else msg += "enable \u{02705} sensor";
        commandName = "controlSensor_changeDisableSensor";
        break;
      case 0x0612:
        msg += `Change sensor disabledLux to ${json.disabledLux?.toString()}`;
        commandName = "controlSensor_changeDisabledLux";
        break;
      case 0x0613:
        msg += `Change sensor disabledMotion to ${json.disabledMotion?.toString()}`;
        commandName = "controlSensor_changeDisabledMotion";
        break;
      case 0x0614:
        msg += `Change sensor gang to ${json.gang}`;
        commandName = "controlSensor_changeSensorGang";
        break;
      case 0x0615:
        msg += `Change sensor check lux interval to ${json.check_lux_interval}`;
        commandName = "controlSensor_changeCheckLuxInterval";
        break;
      case 0x0616:
        msg += `Change sensor enable_delayed_action to ${json.enable_delayed_action?.toString()}`;
        commandName = "controlSensor_changeEnableDelayedAction";
        break;
      case 0x0617:
        msg += `Change sensor enable_delayed_action2 to ${json.enable_delayed_action2?.toString()}`;
        commandName = "controlSensor_changeEnableDelayedAction2";
        break;
      case 0x0618:
        msg += `Change sensor delaySec to ${json.delaySec}s`;
        commandName = "controlSensor_changeDelaySec";
        break;
      case 0x0619:
        msg += `Change sensor delaySec2 to ${json.delaySec2}s`;
        commandName = "controlSensor_changeDelaySec2";
        break;
      case 0x061a:
        msg += `Change sensor delay countdown to ${json.delayCountDown}s`;
        commandName = "controlSensor_changeDelayCountdown";
        break;
      case 0x061b:
        msg += `Change sensor disable relay to ${json.disabledRelay?.toString()}`;
        commandName = "controlSensor_changeDisabledRelay";
        break;
      case 0x061c:
        msg += `Change sensor disable contact to ${json.disabledContact?.toString()}`;
        commandName = "controlSensor_changeDisabledContact";
        break;
      case 0x0621:
        msg += `Flash sensor head LED for ${json.flashSec}s`;
        commandName = "controlSensor_flashSensorHeadLED";
        break;
      case 0x0623:
        msg += `Change sensor regular_time_interval to ${json.regular_time_interval}min`;
        commandName = "controlSensor_changeRegularTimeInterval";
        break;
      case 0x0624:
        msg += `Change sensor survival_time_interval to ${json.survival_time_interval}s`;
        commandName = "controlSensor_changeSurvivalTimeInterval";
        break;
      case 0x0625:
        msg += `sensor test setting read/write`;
        commandName = "controlSensor_testSettingReadWrite";
        break;
      case 0x0626:
        msg += `Change sensor disable ESPNOW ${json.disableEspNow?.toString()}`;
        commandName = "controlSensor_changeDisableEspNow";
        break;
      case 0x0627:
        msg += `Change sensor enableEspOut ${json.enableEspOut?.toString()}`;
        commandName = "controlSensor_changeEnableEspOut";
        break;
      case 0x0628:
        const macArrStr = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `Save near field light setting - mac${macArrStr} settingNum${json.settingNum} shortAdd${json.shortAdd}`;
        commandName = "controlSensor_saveNearFieldLightSetting";
        break;
      case 0x0629:
        const macArrStrA = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `Delete near field light setting - mac${macArrStrA} settingNum${json.settingNum} shortAdd${json.shortAdd}`;
        commandName = "controlSensor_deleteNearFieldLightSetting";
        break;
      case 0x062a:
        const macArrStrB = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `Execute near field light setting - mac${macArrStrB} settingNum${json.settingNum} shortAdd${json.shortAdd}`;
        commandName = "controlSensor_executeNearFieldLightSetting";
        break;
      case 0x062b:
        msg += `Execute all near field light setting - settingNum${json.settingNum}`;
        commandName = "controlSensor_executeAllNearFieldLightSetting";
        break;
      case 0x062c:
        msg += `enable \u{02705} \u{023e9} ${delaySec}s \u{023e9} disable \u{01f6ab}`;
        commandName = "controlSensor_enableSensorWithDelay";
        break;
      case 0x062d:
        msg += `disable \u{01f6ab} \u{023e9} ${delaySec}s \u{023e9} enable \u{02705}`;
        commandName = "controlSensor_disableSensorWithDelay";
        break;
      case 0x062e:
        msg += `Change sensor luxFactor to multiplier:${json.multiplier} power:${json.power}`;
        commandName = "controlSensor_changeLuxFactor";
        break;
      case 0x062f:
        const serverIP = json?.serverIP || [];
        const ipA = serverIP.join(".");
        msg += `Request sensor update firmware - updateSpiffs ${json.updateSpiffs?.toString()} from IP ${ipA}`;
        commandName = "controlSensor_requestUpdateFirmwareFromIP";
        break;
      case 0x0630:
        msg += "Delete all neaar field setting";
        commandName = "controlSensor_deleteAllNearFieldLightSetting";
        break;
      case 0x0631:
        msg += `Change scene button min time to ${json.sceneBtnMinTime}s`;
        commandName = "controlSensor_changeSceneBtnMinTime";
        break;
      case 0x0632:
        msg += `Change scene button repeat time to ${json.sceneBtnRepeatTime}s`;
        commandName = "controlSensor_changeSceneBtnRepeatTime";
        break;
      case 0x0633:
        const typeNameOf = { 1: "momentary", 2: "latch" }
        msg += `Change touch panel type to ${typeNameOf[json.touchPanelType]}[${json.touchPanelType}]`;
        commandName = "controlSensor_changeTouchPanelType";
        break;
      case 0x0634:
        msg += `Start setting to dim controller | disable:${json.disabledSensor?.toString()} gang:${json.gang}`;
        commandName = "controlSensor_startSettingToDimController";
        break;
      case 0x0635:
        msg += `Flash touch panel LED for `;
        if (json.buttonNo > 0) msg += `btn${json.buttonNo}`;
        else msg += "all btn";
        commandName = "controlSensor_flashTouchPanelLED";
        break;
      case 0x0636:
        msg += "Start flash device light";
        commandName = "controlSensor_startFlashDeviceLight";
        break;
      case 0x0637:
        msg += "Stop flash device light";
        commandName = "controlSensor_stopFlashDeviceLight";
        break;
      case 0x0638:
        msg += `Request touch panel update firmware`;
        commandName = "controlSensor_requestTouchPanelUpdateFirmware";
        break;
      case 0x0639:
        const macArrStr_0639 = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `Sensor save batch near field setting - mac${macArrStr} shortAdd${json.shortAdd}`;
        commandName = "controlSensor_saveBatchNearFieldSetting";
        break;
      case 0x063a:
        msg += `sensor enable acknowledge - ${json.enableAcknowledge ? "true" : "false"}`;
        commandName = "controlSensor_enableAcknowledge";
        break;
      case 0x063b:
        msg += `sensor reverse touch panel led - ${json.reverseTouchPanelLed ? "Reversed" : "No reversed"}`;
        commandName = "controlSensor_reverseTouchPanelLed";
        break;
      case 0x063c:
        msg += `sensor save group action - groupID:${json.groupID} setting${json.settingNum} | command:${json.command || "-"}`;
        commandName = "controlSensor_saveGroupAction";
        break;
      case 0x063d:
        msg += `sensor execute group action - groupID:${json.groupID} setting${json.settingNum}`;
        commandName = "controlSensor_executeGroupAction";
        break;
      case 0x063e:
        msg += `sensor delete group action - groupID:${json.groupID} setting${json.settingNum}`;
        commandName = "controlSensor_deleteGroupAction";
        break;
      case 0x063f:
        msg += `sensor delete all group action`;
        commandName = "controlSensor_deleteAllGroupAction";
        break;
      case 0x0640:
        msg += `sensor change disabled light action to ${json.disabledLightAction?.toString()}`;
        commandName = "controlSensor_changeDisabledLightAction";
        break;
      case 0x0641:
        msg += `sensor change disableDtk to ${json.disableDtk?.toString()}`;
        commandName = "controlSensor_changeDisableDtk";
        break;
      case 0x0680:
        msg += `Change dtkInfo - type:${json.dtkType} | panID:${json.dtkPanID} | channel:${json.dtkChannel} | transferMode:${json.dtkTransferMode} | add:${json.dtkAdd} | loraParameter:${json.loraParameter}`;
        commandName = "controlSensor_changeDtkInfo";
        break;
      case 0x0687:
        msg += `Request reset DTK module`;
        commandName = "controlSensor_requestResetDtkModule";
        break;
      case 0x06a2:
        msg += `Change mesh channel to ${json.meshChannel}`;
        commandName = "controlSensor_changeMeshChannel";
        break;
      case 0x06a3:
        msg += `Change mesh frequency to ${json.meshFreq}`;
        commandName = "controlSensor_changeMeshFrequency";
        break;
      case 0x06a4:
        msg += `Change mesh speed to ${json.meshSpeed}`;
        commandName = "controlSensor_changeMeshSpeed";
        break;
      case 0x06a5:
        msg += `Change mesh power to ${json.meshPower}`;
        commandName = "controlSensor_changeMeshPower";
        break;
      case 0x06a6:
        msg += `Change mesh networkID to ${json.meshNetworkID}`;
        commandName = "controlSensor_changeMeshNetworkID";
        break;
      case 0x06a7:
        msg += `Change mesh definedAdd to ${json.meshDefinedAdd}`;
        commandName = "controlSensor_changeMeshDefinedAdd";
        break;
      case 0x06a8:
        msg += `Change mesh enableRepeat to ${json.meshEnableRepeat?.toString()}`;
        commandName = "controlSensor_changeMeshEnableRepeat";
        break;
      case 0x06aa:
        msg += `Request mesh module restart`;
        commandName = "controlSensor_requestMeshModuleRestart";
        break;
      case 0x0701:
        msg += `Query sensor type`;
        commandName = "controlSensor_querySensorType";
        break;
      case 0x0702:
        msg += `Query sensor distance`;
        commandName = "controlSensor_querySensorDist";
        break;
      case 0x0703:
        msg += `Query sensor mode`;
        commandName = "controlSensor_querySensorMode";
        break;
      case 0x0704:
        msg += `Query sensor hasIR`;
        commandName = "controlSensor_querySensorHasIR";
        break;
      case 0x0705:
        msg += `Query sensor disabledSensor`;
        commandName = "controlSensor_queryDisabledSensor";
        break;
      case 0x0706:
        msg += `Query sensor disabledLux`;
        commandName = "controlSensor_queryDisabledLux";
        break;
      case 0x0707:
        msg += `Query sensor disabledMotion`;
        commandName = "controlSensor_queryDisabledMotion";
        break;
      case 0x0708:
        msg += `Query sensor gang`;
        commandName = "controlSensor_querySensorGang";
        break;
      case 0x0709:
        msg += `Query sensor check lux interval`;
        commandName = "controlSensor_queryCheckLuxInterval";
        break;
      case 0x070a:
        msg += `Query sensor enable_delayed_action`;
        commandName = "controlSensor_queryEnableDelayedAction";
        break;
      case 0x070b:
        msg += `Query sensor enable_delayed_action2`;
        commandName = "controlSensor_queryEnableDelayedAction2";
        break;
      case 0x070c:
        msg += `Query sensor delaySec`;
        commandName = "controlSensor_queryDelaySec";
        break;
      case 0x070d:
        msg += `Query sensor delaySec2`;
        commandName = "controlSensor_queryDelaySec2";
        break;
      case 0x070e:
        msg += `Query sensor delay countdown`;
        commandName = "controlSensor_queryDelayCountdown";
        break;
      case 0x070f:
        msg += `Query sensor disabledRelay`;
        commandName = "controlSensor_queryDisabledRelay";
        break;
      case 0x0710:
        msg += `Query sensor disabledContact`;
        commandName = "controlSensor_queryDisabledContact";
        break;
      case 0x0711:
        msg += `Query sensor firmware version`;
        commandName = "controlSensor_queryFirmwareVersion";
        break;
      case 0x0716:
        msg += "Query ota ssid";
        commandName = "controlSensor_queryOtaSsid";
        break;
      case 0x0717:
        msg += "Query ota password";
        commandName = "controlSensor_queryOtaPassword";
        break;
      case 0x0718:
        msg += "Query mac address";
        commandName = "controlSensor_queryMacAddress";
        break;
      case 0x071a:
        msg += "Query regular time interval";
        commandName = "controlSensor_queryRegularTimeInterval";
        break;
      case 0x071b:
        msg += "Query survival time interval";
        commandName = "controlSensor_querySurvivalTimeInterval";
        break;
      case 0x071c:
        msg += "Query disableEspNow";
        commandName = "controlSensor_queryDisableEspNow";
        break;
      case 0x071d:
        msg += "Query sensor fault";
        commandName = "controlSensor_querySensorFault";
        break;
      case 0x071e:
        msg += "Query enableEspOut";
        commandName = "controlSensor_queryEnableEspOut";
        break;
      case 0x071f:
        const macArrStrC = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `Query near field light setting mac${macArrStrC} settingNum${json.settingNum} shortAdd${json.shortAdd}`;
        commandName = "controlSensor_queryNearFieldLightSetting";
        break;
      case 0x0720:
        msg += "Query wifiApMacAddress";
        commandName = "controlSensor_queryWifiApMacAddress";
        break;
      case 0x0721:
        msg += "Query luxFactor";
        commandName = "controlSensor_queryLuxFactor";
        break;
      case 0x0722:
        msg += "Query macUploadNode";
        commandName = "controlSensor_queryMacUploadNode";
        break;
      case 0x0723:
        msg += "Query scene button min time";
        commandName = "controlSensor_querySceneBtnMinTime";
        break;
      case 0x0724:
        msg += "Query scene button repeat time";
        commandName = "controlSensor_querySceneBtnRepeatTime";
        break;
      case 0x0725:
        msg += "Query touch panel type";
        commandName = "controlSensor_queryTouchPanelType";
        break;
      case 0x0726:
        msg += "Query sensor head type";
        commandName = "controlSensor_querySensorHeadType";
        break;
      case 0x0727:
        msg += "Query touch panel firmware version";
        commandName = "controlSensor_queryTouchPanelFirmwareVersion";
        break;
      case 0x0728:
        msg += "Query touch panel gang";
        commandName = "controlSensor_queryTouchPanelGang";
        break;
      case 0x0729:
        const macArrStr_0729 = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `Query batch near field setting mac${macArrStr_0729} shortAdd${json.shortAdd}`;
        commandName = "controlSensor_queryBatchNearFieldSetting";
        break;
      case 0x072a:
        msg += "Query sensor enable acknowledge";
        commandName = "controlSensor_queryEnableAcknowledge";
        break;
      case 0x072b:
        msg += "Query touch panel reverse led";
        commandName = "controlSensor_queryTouchPanelReverseLed";
        break;
      case 0x072c:
        msg += `Query group action - groupID:${json.groupID} settingNum:${json.settingNum}`;
        commandName = "controlSensor_queryGroupAction";
        break;
      case 0x072d:
        msg += `Query group action quantity - groupID:${json.groupID}`;
        commandName = "controlSensor_queryGroupActionQuantity";
        break;
      case 0x072e:
        msg += `Query disabled light action`;
        commandName = "controlSensor_queryDisabledLightAction";
        break;
      case 0x0780:
        msg += `Query dtkInfo`;
        commandName = "controlSensor_queryDtkInfo";
        break;
      case 0x0783:
        msg += "Query dtkChannel";
        commandName = "controlSensor_queryDtkChannel";
        break;
      case 0x07a0:
        msg += `Query meshMacAddress`;
        commandName = "controlSensor_queryMeshMacAddress";
        break;
      case 0x07a1:
        msg += `Query meshInfo`;
        commandName = "controlSensor_queryMeshInfo";
        break;
      case 0x07a2:
        msg += `Query meshChannel`;
        commandName = "controlSensor_queryMeshChannel";
        break;
      case 0x07a3:
        msg += `Query meshFrequency`;
        commandName = "controlSensor_queryMeshFrequency";
        break;
      case 0x07a4:
        msg += `Query meshSpeed`;
        commandName = "controlSensor_queryMeshSpeed";
        break;
      case 0x07a5:
        msg += `Query meshPower`;
        commandName = "controlSensor_queryMeshPower";
        break;
      case 0x07a6:
        msg += `Query meshNetworkID`;
        commandName = "controlSensor_queryMeshNetworkID";
        break;
      case 0x07a7:
        msg += `Query meshDefinedAdd`;
        commandName = "controlSensor_queryMeshDefinedAdd";
        break;
      case 0x07a8:
        msg += `Query meshEnableRepeat`;
        commandName = "controlSensor_queryMeshEnableRepeat";
        break;
      case 0x07a9:
        msg += `Query meshBaudrate`;
        commandName = "controlSensor_queryMeshBaudrate";
        break;
      case 0x07e0:
        msg += "sensor head test start";
        commandName = "controlSensor_sensorHeadTestStart";
        break;
      case 0x07e1:
        msg += 'sensor head test stop';
        commandName = "controlSensor_sensorHeadTestStop";
        break;
      case 0x07e2:
        msg += "query sensor head test result";
        commandName = "controlSensor_querySensorHeadTestResult";
        break;
      case 0x0802:
        msg += "Request gateway send start";
        commandName = "sensorReport_requestGatewaySendStart";
        break;
      case 0x0803:
        msg += json.motionStatus === 1 ? "Motion detected" : "No motion detected";
        commandName = "sensorReport_motionStatus";
        break;
      case 0x0804:
        msg += `Lux lv ${json.luxLv} [${json.lux}lux]`;
        commandName = "sensorReport_daylightStatus";
        break;
      case 0x0805:
        msg = `Sw1 ${json.currentStatus ? "ON" : "OFF"} `;
        if (json.gang > 1) msg += `/Sw2 ${json.currentStatus2 ? "ON" : "OFF"} `;
        if (json.gang > 2) msg += `/Sw3 ${json.currentStatus3 ? "ON" : "OFF"} `;
        if (json.gang > 3) msg += `/Sw4 ${json.currentStatus4 ? "ON" : "OFF"} `;
        commandName = "sensorReport_lightSwitchStatus";
        break;
      case 0x0806:
        msg += json.motionStatus === 1 ? "Motion detected" : "No motion detected";
        msg += ` / Lux lv ${json.luxLv} [${json.lux}lux]`;
        commandName = "sensorReport_daylightMotionStatus";
        break;
      case 0x0808:
        msg += `System start - ver ${json.version}`;
        commandName = "sensorReport_systemStart";
        break;
      case 0x080a:
        msg = `Btn1 ${json.currentStatus ? "ON" : "OFF"} `;
        if (json.gang > 1) msg += `/Btn2 ${json.currentStatus2 ? "ON" : "OFF"} `;
        if (json.gang > 2) msg += `/Btn3 ${json.currentStatus3 ? "ON" : "OFF"} `;
        if (json.gang > 3) msg += `/Btn4 ${json.currentStatus4 ? "ON" : "OFF"} `;
        commandName = "sensorReport_sceneButtonStatus";
        break;
      case 0x080b:
        msg += `ultrasonic sensor ${json.detected ? "detected" : "not detected"}`;
        commandName = "sensorReport_ultrasonicSensorStatus";
        break;
      case 0x080c:
        msg += `System start - ver ${json.version}`;
        commandName = "sensorReport_meshSensorSystemStart";
        break;
      case 0x0901:
        const typeOf = { 0: 'motion', 1: "daylight", 2: "lightswitch", 3: "daylightMotion", 4: "scenebutton", 5: "dimController" };
        msg += `sensor report sensorType - ${typeOf[json.sensorType]}[${json.sensorType}]`;
        commandName = "sensorReport_sensorType";
        break;
      case 0x0902:
        msg += `sensor report sensorDist - ${json.sensorDist}`;
        commandName = "sensorReport_sensorDist";
        break;
      case 0x0903:
        const modeOf = { 0: "microwave only", 1: "microwave & PIR", 2: "microwave or PIR", 3: "PIR only" };
        msg += `sensor report sensorMode - ${modeOf[json.sensorMode]}[${json.sensorMode}]`;
        commandName = "sensorReport_sensorMode";
        break;
      case 0x0904:
        msg += `sensor report sensorHasIR - ${json.hasIR?.toString()}`;
        commandName = "sensorReport_sensorHasIR";
        break;
      case 0x0905:
        msg += `sensor report disabledSensor - ${json.disabledSensor?.toString()}`;
        commandName = "sensorReport_disabledSensor";
        break;
      case 0x0906:
        msg += `sensor report disabledLux - ${json.disabledLux?.toString()}`;
        commandName = "sensorReport_disabledLux";
        break;
      case 0x0907:
        msg += `sensor report disabledMotion - ${json.disabledMotion?.toString()}`;
        commandName = "sensorReport_disabledMotion";
        break;
      case 0x0908:
        msg += `sensor report sensorGang - ${json.gang}`;
        commandName = "sensorReport_sensorGang";
        break;
      case 0x0909:
        msg += `sensor report checkLuxInterval - ${json.check_lux_interval}`;
        commandName = "sensorReport_checkLuxInterval";
        break;
      case 0x090a:
        msg += `sensor report enableDelayedAction - ${json.enable_delayed_action?.toString()}`;
        commandName = "sensorReport_enableDelayedAction";
        break;
      case 0x090b:
        msg += `sensor report enableDelayedAction2 - ${json.enable_delayed_action2?.toString()}`;
        commandName = "sensorReport_enableDelayedAction2";
        break;
      case 0x090c:
        msg += `sensor report delaySec - ${json.delaySec}`;
        commandName = "sensorReport_delaySec";
        break;
      case 0x090d:
        msg += `sensor report delaySec2 - ${json.delaySec2}`;
        commandName = "sensorReport_delaySec2";
        break;
      case 0x090e:
        msg += `sensor report delayCountdown - ${json.delayCountDown}`;
        commandName = "sensorReport_delayCountdown";
        break;
      case 0x090f:
        msg += `sensor report disabledRelay - ${json.disabledRelay?.toString()}`;
        commandName = "sensorReport_disabledRelay";
        break;
      case 0x0910:
        msg += `sensor report disabledContact - ${json.disabledContact?.toString()}`;
        commandName = "sensorReport_disabledContact";
        break;
      case 0x0915:
        msg += `report update firmware status - [${json.statusCode}] ${codeMsg[json.statusCode]}`;
        commandName = "sensorReport_updateFirmwareStatus";
        break;
      case 0x0916:
        msg += `sensor report current firmware version - ${json.version}`;
        commandName = "sensorReport_currentFirmwareVersion";
        break;
      case 0x0917:
        msg += `sensor  report mac address - ${json.macAddress}`;
        commandName = "sensorReport_macAddress";
        break;
      case 0x0918:
        msg += `sensor report test setting read/write - ${json.result?.toString()}`;
        commandName = "sensorReport_testSettingReadWrite";
        break;
      case 0x0919:
        msg += `sensor report regular time interval - ${json.regular_time_interval}min`;
        commandName = "sensorReport_regularTimeInterval";
        break;
      case 0x091a:
        msg += `sensor report survival time interval - ${json.survival_time_interval}s`;
        commandName = "sensorReport_survivalTimeInterval";
        break;
      case 0x091b:
        msg += `sensor report disableEspNow - ${json.disableEspNow?.toString()}`;
        commandName = "sensorReport_disableEspNow";
        break;
      case 0x091c:
        msg += `sensor report fault - ${json.faultCode} -`;
        if (json.ramFault) msg += "RAM, ";
        if (json.luxFault) msg += "lux, ";
        if (json.pcfFault) msg += "PCF, ";
        if (json.coreTempFault) msg += "coreTemp, ";
        if (json.touchPanelFault) msg += "touchPanel, ";
        commandName = "sensorReport_fault";
        break;
      case 0x091d:
        msg += `sensor report ota ssid - ${json.otaSsid}`;
        commandName = "sensorReport_otaSsid";
        break;
      case 0x091e:
        msg += `sensor report ota password - ${json.otaPassword}`;
        commandName = "sensorReport_otaPassword";
        break;
      case 0x091f:
        msg += `sensor report enableEspOut - ${json.enableEspOut?.toString()}`;
        commandName = "sensorReport_enableEspOut";
        break;
      case 0x0922:
        msg += `sensor report near field setting - mac${json.macAddress} settingNum${json.settingNum} shortAdd${json.shortAdd}`;
        commandName = "sensorReport_nearFieldLightSetting";
        break;
      case 0x0923:
        msg += `sensor report wifiApMacAddress - ${json.wifiApMacAddress}`;
        commandName = "sensorReport_wifiApMacAddress";
        break;
      case 0x0924:
        msg += `sensor report luxFactor - multiplier:${json.multiplier} power:${json.power}`;
        commandName = "sensorReport_luxFactor";
        break;
      case 0x0925:
        msg += "sensor report change type fail";
        commandName = "sensorReport_changeTypeFail";
        break;
      case 0x0926:
        msg += "sensor report deleted all near field setting";
        commandName = "sensorReport_deleteAllNearFieldLightSetting";
        break;
      case 0x0927:
        const macStr0927 = (json.macAddressArray || []).map(mac => mac?.toString(16)?.padStart(2, "0"))?.join(":");
        msg += `sensor reportMacUploadNode - ${macStr0927}`;
        commandName = "sensorReport_macUploadNode";
        break;
      case 0x0928:
        msg += `sensor report scene button min time - ${json.sceneBtnMinTime}s`;
        commandName = "sensorReport_sceneBtnMinTime";
        break;
      case 0x0929:
        msg += `sensor report scene button repeat time - ${json.sceneBtnRepeatTime}s`;
        commandName = "sensorReport_sceneBtnRepeatTime";
        break;
      case 0x092a:
        msg += `sensor report touch panel type - ${json.touchPanelType === 1 ? "momentary" : json.touchPanelType === 2 ? "latch" : "unknown"}`;
        commandName = "sensorReport_touchPanelType";
        break;
      case 0x092b:
        msg += `sensor report btnPin and gang (obselete)`;
        commandName = "sensorReport_btnPinAndGang";
        break;
      case 0x092c:
        const headOf = { 0: "head_ufo", 1: "head_pcf_switch", 2: "head_esp_switch" }
        msg += `sensor report sensor head type - ${headOf[json.sensorHeadType]}[${json.sensorHeadType}]`;
        commandName = "sensorReport_sensorHeadType";
        break;
      case 0x092d:
        msg += `sensor report touch panel firmware version - ${json.version}`;
        commandName = "sensorReport_touchPanelFirmwareVersion";
        break;
      case 0x092e:
        msg += `sensor report touch panel gang - ${json.touchPanelGang}`;
        commandName = "sensorReport_touchPanelGang";
        break;
      case 0x092f:
        msg += `sensor report batch near field setting of ${json.macAddress} shortAdd:${json.shortAdd}`;
        commandName = "sensorReport_batchNearFieldLightSetting";
        break;
      case 0x0930:
        msg += `sensor report enable acknowledge - ${json.enableAcknowledge?.toString()}`;
        commandName = "sensorReport_enableAcknowledge";
        break;
      case 0x0931:
        msg += `sensor report enable touch panel reverse led - ${json.reverseLed?.toString()}`;
        commandName = "sensorReport_enableTouchPanelReverseLed";
        break;
      case 0x0932:
        msg += `sensor report group action - groupID:${json.groupID} setting${json.settingNum} | command:${json.command || "-"}`;
        commandName = "sensorReport_groupAction";
        break;
      case 0x0933:
        msg += `sensor report delete all group action - groupID:${json.groupID}`;
        commandName = "sensorReport_deleteAllGroupAction";
        break;
      case 0x0934:
        msg += `sensor report group action quantity - ${json.groupActionQuantity} groupID:${json.groupID}`;
        commandName = "sensorReport_groupActionQuantity";
        break;
      case 0x0935: {
        msg += `sensor report update firmware start`;
        commandName = "sensorReport_updateFirmwareStart";
        break;
      }
      case 0x0936: {
        msg += `sensor report disabledLightAction - ${json.disabledLightAction?.toString()}`;
        commandName = "sensorReport_disabledLightAction";
        break;
      }
      case 0x0937: {
        msg += `sensor report disableDtk - ${json.disableDtk?.toString()}`;
        commandName = "sensorReport_disableDtk";
        break;
      }
      case 0x0980:
        msg += `sensor report dtkInfo - type:${json.dtkType} | panID:${json.dtkPanID} | channel:${json.dtkChannel} | transferMode:${json.dtkTransferMode} | add:${json.dtkAdd} | loraParameter:${json.loraParameter}`;
        commandName = "sensorReport_dtkInfo";
        break;
      case 0x09a0:
        msg += `sensor report meshMacAddress - ${json.meshMacAddress}`;
        commandName = "sensorReport_meshMacAddress";
        break;
      case 0x09a1:
        msg += `sensor report meshInfo - ${json.meshInfo}`;
        commandName = "sensorReport_meshInfo";
        break;
      case 0x09a2:
        msg += `sensor report meshChannel - ${json.meshChannel}`;
        commandName = "sensorReport_meshChannel";
        break;
      case 0x09a3:
        msg += `sensor report meshFrequency - ${json.meshFreq}`;
        commandName = "sensorReport_meshFrequency";
        break;
      case 0x09a4:
        msg += `sensor report meshSpeed - ${json.meshSpeed}`;
        commandName = "sensorReport_meshSpeed";
        break;
      case 0x09a5:
        msg += `sensor report meshPower - ${json.meshPower}`;
        commandName = "sensorReport_meshPower";
        break;
      case 0x09a6:
        msg += `sensor report meshNetworkID - ${json.meshNetworkID}`;
        commandName = "sensorReport_meshNetworkID";
        break;
      case 0x09a7:
        msg += `sensor report meshDefinedAdd - ${json.meshDefinedAdd}`;
        commandName = "sensorReport_meshDefinedAdd";
        break;
      case 0x09a8:
        msg += `sensor report meshEnableRepeat - ${json.meshEnableRepeat?.toString()}`;
        commandName = "sensorReport_meshEnableRepeat";
        break;
      case 0x0a01:
        msg += `request daliCtl report current data`;
        commandName = "controlDaliCtl_requestCurrentData";
        break;
      case 0x0a02:
        msg += `Start setting to daliCtl`;
        commandName = "controlDaliCtl_startSetting";
        break;
      case 0x0a03:
        msg += "Request dali initialise";
        commandName = "controlDaliCtl_requestDaliInitialise";
        break;
      case 0x0a04:
        msg += `General dali query - daliCmd:${json.daliCmd} shortAdd:${json.shortAdd}`;
        commandName = "controlDaliCtl_generalDaliQuery";
        break;
      case 0x0a05:
        msg += "Scan short address";
        commandName = "controlDaliCtl_scanShortAddress";
        break;
      case 0x0a06:
        msg += `Change short address from ${json.currentAdd} to ${json.newAdd}`;
        commandName = "controlDaliCtl_changeShortAddress";
        break;
      case 0x0a07:
        msg += `Broadcast light arcLv:${json.arcLv}`;
        commandName = "controlDaliCtl_broadcastLightArc";
        break;
      case 0x0a08:
        msg += `Flash light shortAdd:${json.shortAdd} ${json.times} times`;
        commandName = "controlDaliCtl_flashLight";
        break;
      case 0x0a09:
        msg += `dali light #${shortAdd} \u{01f512}${lockLevel} ${pwm}%`;
        if (delaySec > 0) msg += `->${delaySec}s-> ${delayedPwm}% `;
        if (delaySec2 > 0) msg += `->${delaySec2}s-> ${delayedPwm2}%`;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_controlSingleLight";
        break;
      case 0x0a0a:
        msg += `Change fade time - shortAdd:${json.shortAdd} fadeTimeCode:${json.fadeTime}`;
        commandName = "controlDaliCtl_changeFadeTime";
        break;
      case 0x0a0b:
        msg += `Write memory bank - shortAdd:${json.shortAdd} memoryAdd:${json.memoryAdd} value:${json.value}`;
        commandName = "controlDaliCtl_writeMemoryBank";
        break;
      case 0x0a0c:
        msg += `Dali reset - shortAdd:${json.shortAdd}`;
        commandName = "controlDaliCtl_resetDali";
        break;
      case 0x0a0d:
        msg += `Change lock level - shortAdd:${json.shortAdd} lockLevel:${json.lockLevel}`;
        commandName = "controlDaliCtl_changeLockLevel";
        break;
      case 0x0a0e:
        msg += `Acknowledge receive msg from daliCtl | ${json.replyCommandCode?.toString(16)}`;
        commandName = "controlDaliCtl_acknowledgeReceiveMsg";
        break;
      case 0x0a0f:
        msg += "Release all lock level";
        commandName = "controlDaliCtl_releaseAllLockLevel";
        break;
      case 0x0a10:
        msg += `Add light shortAdd ${json.shortAdd} to group ${json.groupNo}`;
        commandName = "controlDaliCtl_addLightToGroup";
        break;
      case 0x0a11:
        msg += `Remove light shortAdd ${json.shortAdd} from group ${json.groupNo}`;
        commandName = "controlDaliCtl_removeLightFromGroup";
        break;
      case 0x0a12:
        msg += "Cancel scan short address";
        commandName = "controlDaliCtl_cancelScanShortAddress";
        break;
      case 0x0a13:
        msg += "Dali reset all";
        commandName = "controlDaliCtl_daliResetAll";
        break;
      case 0x0a14:
        msg += `Change all fade time to ${json.fadeTime}`;
        commandName = "controlDaliCtl_changeAllFadeTime";
        break;
      case 0x0a15:
        msg += `Change short add ${json.shortAdd} to min lv ${json.minLv}`;
        commandName = "controlDaliCtl_changeShortAddToMinLv";
        break;
      case 0x0a16:
        msg += `Change short add ${json.shortAdd} to max lv ${json.maxLv}`;
        commandName = "controlDaliCtl_changeShortAddToMaxLv";
        break;
      case 0x0a17:
        msg += `Change all light to min lv ${json.minLv}`;
        commandName = "controlDaliCtl_changeMinLvAll";
        break;
      case 0x0a18:
        msg += `Change all light to max lv ${json.maxLv}`;
        commandName = "controlDaliCtl_changeMaxLvAll";
        break;
      case 0x0a19:
        msg += `multi dali lights \u{01f512}${lockLevel}, lv `;
        if (json?.lightLvAry)
          (typeof json.lightLvAry === "string" ? json.lightLvAry.split(",") : json.lightLvAry).forEach(lv => {
            msg += `${lv}%, `;
          });
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_controlMultiLight_noDelay";
        break;
      case 0x0a1a:
        msg += `multi dali lights \u{01f512}${lockLevel}, lv `;
        if (json?.lightLvAry)
          (typeof json.lightLvAry === "string" ? json.lightLvAry.split(",") : json.lightLvAry).forEach(lv => {
            msg += `${lv}%, `;
          });
        msg += `-> ${delaySec} s -> `;
        if (json?.D1LightLvAry)
          (typeof json.D1LightLvAry === "string" ? json.D1LightLvAry.split(",") : json.D1LightLvAry).forEach(lv => {
            msg += `${lv}%, `;
          });
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_controlMultiLight_1Delay";
        break;
      case 0x0a1b:
        msg += `multi dali lights \u{01f512}${lockLevel}, lv `;
        if (json?.lightLvAry)
          (typeof json.lightLvAry === "string" ? json.lightLvAry.split(",") : json.lightLvAry).forEach(lv => {
            msg += `${lv}%, `;
          });
        msg += `-> ${delaySec} s -> `;
        if (json?.D1LightLvAry)
          (typeof json.D1LightLvAry === "string" ? json.D1LightLvAry.split(",") : json.D1LightLvAry).forEach(lv => {
            msg += `${lv}%, `;
          });
        msg += `-> ${delaySec2} s -> `;
        if (json?.D2LightLvAry)
          (typeof json.D2LightLvAry === "string" ? json.D2LightLvAry.split(",") : json.D2LightLvAry).forEach(lv => {
            msg += `${lv}%, `;
          });
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_controlMultiLight_2Delay";
        break;
      case 0x0a1c:
        msg += "dali delete all lights";
        commandName = "controlDaliCtl_deleteAllLights";
        break;
      case 0x0a1d:
        msg += "dali delete all sensors";
        commandName = "controlDaliCtl_deleteAllSensors";
        break;
      case 0x0a1e:
        msg += `dali delete light shortAdd ${json.shortAdd}`;
        commandName = "controlDaliCtl_deleteLight";
        break;
      case 0x0a1f:
        msg += `dali delete sensor shortAdd ${json.shortAdd} instance ${json.instance}`;
        commandName = "controlDaliCtl_deleteSensor";
        break;
      case 0x0a20:
        msg += `Change controlA pin to ${json.controlAPin}`;
        commandName = "controlDaliCtl_changeControlAPin";
        break;
      case 0x0a21:
        msg += `Change controlB pin to ${json.controlBPin}`;
        commandName = "controlDaliCtl_changeControlBPin";
        break;
      case 0x0a22:
        msg += `Change controlD pin to ${json.controlCPin}`;
        commandName = "controlDaliCtl_changeControlDPin";
        break;
      case 0x0a23:
        msg += `Change disableEspNow to ${json.disableEspNow?.toString()}`;
        commandName = "controlDaliCtl_changeDisableEspNow";
        break;
      case 0x0a24:
        msg += `ChangeEnableEspOut to ${json.enableEspOut?.toString()}`;
        commandName = "controlDaliCtl_changeEnableEspOut";
        break;
      case 0x0a25:
        msg += `Change regular time interval to ${json.regular_time_interval}min`;
        commandName = "controlDaliCtl_changeRegularTimeInterval";
        break;
      case 0x0a26:
        msg += `Change survival time interval to ${json.survival_time_interval}s`;
        commandName = "controlDaliCtl_changeSurvivalTimeInterval";
        break;
      case 0x0a27:
        msg += `Change enableDali to ${json.enableDali?.toString()}`;
        commandName = "controlDaliCtl_changeEnableDali";
        break;
      case 0x0a28:
        msg += `Change enable turn on on disconnect to ${json.enableTurnOnOnDisconnect?.toString()}`;
        commandName = "controlDaliCtl_changeEnableTurnOnOnDisconnect";
        break;
      case 0x0a29:
        msg += "Reset on disconnect timer";
        commandName = "controlDaliCtl_resetOnDisconnectTimer";
        break;
      case 0x0a2a:
        msg += `Dali power ${json.powerOnOff ? "on" : "off"}`;
        commandName = "controlDaliCtl_powerOnOff";
        break;
      case 0x0a2b:
        msg += `Request daliCtl update firmware - updateSpiffs ${json.updateSpiffs?.toString()}`;
        commandName = "controlDaliCtl_requestUpdateFirmware";
        break;
      case 0x0a2c:
        const ip_0a2c = json.serverIP.join(".");
        msg += `Request daliCtl update firmware - updateSpiffs ${json.updateSpiffs?.toString()} from IP ${ip_0a2c}`;
        commandName = "controlDaliCtl_requestUpdateFirmwareFromIP";
        break;
      case 0x0a2d:
        msg += `Change ota ssid to ${json.otaSsid}`;
        commandName = "controlDaliCtl_changeOtaSsid";
        break;
      case 0x0a2e:
        msg += `Change ota password to ${json.otaPassword}`;
        commandName = "controlDaliCtl_changeOtaPassword";
        break;
      case 0x0a30:
        msg += `Change switch sequence - ${json.switchSequence}`;
        commandName = "controlDaliCtl_changeSwitchSequence";
        break;
      case 0x0a31:
        msg += `DaliCtl restart system`;
        commandName = "controlDaliCtl_restartSystem";
        break;
      case 0x0a32:
        msg += `Change cut dim on bypass to ${json.cutDimOnBypass?.toString()}`;
        commandName = "controlDaliCtl_changeCutDimOnBypass";
        break;
      case 0x0a33:
        msg += `light \u{01f512}${lockLevel} `;
        if (json.stepUp) msg += `\u{01f53c} ${json.dimStepSize}%`;
        else msg += `\u{01f53d} ${json.dimStepSize}%`;
        (typeof json.shortAddAry === "string" ? json.shortAddAry.split(",") : json.shortAddAry).forEach(a => {
          msg += `#${a}, `;
        })
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_multiLightStepDim";
        break;
      case 0x0a34:
        msg += `light \u{01f512}${lockLevel} `;
        msg += `on/off toggle `;
        (typeof json.shortAddAry === "string" ? json.shortAddAry.split(",") : json.shortAddAry).forEach(a => {
          msg += `#${a}, `;
        })
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_multiLightToggle";
        break;
      case 0x0a35:
        msg += `light #${shortAdd} \u{01f512}${lockLevel} `;
        if (json.stepUp) msg += `\u{01f53c} ${json.dimStepSize}%`;
        else msg += `\u{01f53d} ${json.dimStepSize}%`;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_singleLightStepDim";
        break;
      case 0x0a36:
        msg += `light #${shortAdd} \u{01f512}${lockLevel} `;
        msg += `on/off toggle `;
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_singleLightToggle";
        break;
      case 0x0a37:
        msg += `Start flash lights`;
        commandName = "controlDaliCtl_startFlashLights";
        break;
      case 0x0a38:
        msg += `Stop flash lights`;
        commandName = "controlDaliCtl_stopFlashLights";
        break;
      case 0x0a39:
        msg += `light \u{01f512}${lockLevel} `;
        (json.lightLvAry || []).forEach(lv => {
          const val = lv > 100 ? "-%, " : `${lv}%, `
          msg += val;
        });
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_controlMultiLight_noDelay";
        break;
      case 0x0a3a:
        msg += `light \u{01f512}${lockLevel} `;
        (json.lightLvAry || []).forEach(lv => {
          const val = lv > 100 ? "-%, " : `${lv}%, `
          msg += val;
        });
        msg += `-> ${delaySec} s -> `;
        (json.D1LightLvAry || []).forEach(lv => {
          const val = lv > 100 ? "-%, " : `${lv}%, `
          msg += val;
        });
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_controlMultiLight_1Delay";
        break;
      case 0x0a3b:
        msg += `light \u{01f512}${lockLevel} `;
        (json.lightLvAry || []).forEach(lv => {
          const val = lv > 100 ? "-%, " : `${lv}%, `
          msg += val;
        });
        msg += `-> ${delaySec} s -> `;
        (json.D1LightLvAry || []).forEach(lv => {
          const val = lv > 100 ? "-%, " : `${lv}%, `
          msg += val;
        });
        msg += `-> ${delaySec2} s -> `;
        (json.D2LightLvAry || []).forEach(lv => {
          const val = lv > 100 ? "-%, " : `${lv}%, `
          msg += val;
        });
        if (releaseOnDelayEnd) msg = msg + " \u{01f513}";
        else msg = msg + ` \u{01f512}` + lockLevel;
        commandName = "controlDaliCtl_controlMultiLight_2Delay";
        break;
      case 0x0a3c:
        msg += `daliCtl enable acknowledge ${json.enableAcknowledge ? "true" : "false"}`;
        commandName = "controlDaliCtl_enableAcknowledge";
        break;
      case 0x0a3d:
        msg += `daliCtl save group action - groupID:${json.groupID} settingNum:${json.settingNum}`;
        commandName = "controlDaliCtl_saveGroupAction";
        break;
      case 0x0a3e:
        msg += `daliCtl delete group action - groupID:${json.groupID} settingNum:${json.settingNum}`;
        commandName = "controlDaliCtl_deleteGroupAction";
        break;
      case 0x0a3f:
        msg += `daliCtl execute group action - groupID:${json.groupID} settingNum:${json.settingNum}`;
        commandName = "controlDaliCtl_executeGroupAction";
        break;
      case 0x0a40:
        msg += `daliCtl delete all group action`;
        commandName = "controlDaliCtl_deleteAllGroupAction";
        break;
      case 0x0a41:
        msg += `daliCtl control A relay - ${json.controlA === 0x66 ? "ON" : "OFF"}`;
        commandName = "controlDaliCtl_controlARelay";
        break;
      case 0x0a42:
        msg += `daliCtl control B relay - ${json.controlB === 0x66 ? "ON" : "OFF"}`;
        commandName = "controlDaliCtl_controlBRelay";
        break;
      case 0x0a43:
        msg += `daliCtl control D relay - ${json.controlD === 0x66 ? "ON" : "OFF"}`;
        commandName = "controlDaliCtl_controlDRelay";
        break;
      case 0x0a44:
        msg += `daliCtl change general dali parameter - change command:${json.changeCmdNum} | value:${json.value} | query command:${json.queryCmdNum}`;
        commandName = "controlDaliCtl_changeGeneralDaliParameter";
        break;
      case 0x0a45: //daliCtlReportDisableDtk
        msg += `report disableDtk - ${json.disableDtk?.toString()}`;
        commandName = "daliCtlReport_disableDtk";
        break;
      case 0x0a80:
        msg += `Change dtkInfo - type:${json.dtkType} | panID:${json.dtkPanID} | channel:${json.dtkChannel} | transferMode:${json.dtkTransferMode} | add:${json.dtkAdd} | loraParameter:${json.loraParameter}`;
        commandName = "controlDaliCtl_changeDtkInfo";
        break;
      case 0x0a87:
        msg += `Request reset DTK module`;
        commandName = "controlDaliCtl_requestResetDtkModule";
        break;
      case 0x0aa2:
        msg += `Change meshChannel to ${json.meshChannel}`;
        commandName = "controlDaliCtl_changeMeshChannel";
        break;
      case 0x0aa3:
        msg += `Change meshFrequency to ${json.meshFreq}`;
        commandName = "controlDaliCtl_changeMeshFrequency";
        break;
      case 0x0aa4:
        msg += `Change meshSpeed to ${json.meshSpeed}`;
        commandName = "controlDaliCtl_changeMeshSpeed";
        break;
      case 0x0aa5:
        msg += `Change meshPower to ${json.meshPower}`;
        commandName = "controlDaliCtl_changeMeshPower";
        break;
      case 0x0aa6:
        msg += `Change meshNetworkID to ${json.meshNetworkID}`;
        commandName = "controlDaliCtl_changeMeshNetworkID";
        break;
      case 0x0aa7:
        msg += `Change meshDefinedAdd to ${json.meshDefinedAdd}`;
        commandName = "controlDaliCtl_changeMeshDefinedAdd";
        break;
      case 0x0aa8:
        msg += `Change meshEnableRepeat to ${json.meshEnableRepeat?.toString()}`;
        commandName = "controlDaliCtl_changeMeshEnableRepeat";
        break;
      case 0x0aaa:
        msg += `Request mesh module restart`;
        commandName = "controlDaliCtl_requestMeshModuleRestart";
        break;
      case 0x0b01:
        msg += "query short address list";
        commandName = "controlDaliCtl_queryShortAddressList";
        break;
      case 0x0b02:
        msg += "query all light status";
        commandName = "controlDaliCtl_queryAllLightStatus";
        break;
      case 0x0b03:
        msg += "query all lock level";
        commandName = "controlDaliCtl_queryAllLockLevel";
        break;
      case 0x0b04:
        msg += "query light lv - shortAdd:" + json.shortAdd;
        commandName = "controlDaliCtl_queryLightLv";
        break;
      case 0x0b05:
        msg += `query lock level - shortAdd:${json.shortAdd}`;
        commandName = "controlDaliCtl_queryLockLevel";
        break;
      case 0x0b06:
        msg += `query fade time - shortAdd:${json.shortAdd}`;
        commandName = "controlDaliCtl_queryFadeTime";
        break;
      case 0x0b07:
        msg += `query memory bank - shortAdd:${json.shortAdd} memoryAdd:${json.memoryAdd}`;
        commandName = "controlDaliCtl_queryMemoryBank";
        break;
      case 0x0b08:
        msg += `query min lv - shortAdd:${json.shortAdd}`;
        commandName = "controlDaliCtl_queryMinLv";
        break;
      case 0x0b09:
        msg += `query max lv - shortAdd:${json.shortAdd}`;
        commandName = "controlDaliCtl_queryMaxLv";
        break;
      case 0x0b0a:
        msg += "query all fade time";
        commandName = "controlDaliCtl_queryAllFadeTime";
        break;
      case 0x0b0b:
        msg += "query all min lv";
        commandName = "controlDaliCtl_queryAllMinLv";
        break;
      case 0x0b0c:
        msg += "query all max lv";
        commandName = "controlDaliCtl_queryAllMaxLv";
        break;
      case 0x0b0d:
        msg += "query bypass";
        commandName = "controlDaliCtl_queryBypass";
        break;
      case 0x0b0e:
        msg += "query controlA pin";
        commandName = "controlDaliCtl_queryControlAPin";
        break;
      case 0x0b0f:
        msg += "query controlB pin";
        commandName = "controlDaliCtl_queryControlBPin";
        break;
      case 0x0b10:
        msg += "query controlD pin";
        commandName = "controlDaliCtl_queryControlDPin";
        break;
      case 0x0b11:
        msg += "query disableEspNow";
        commandName = "controlDaliCtl_queryDisableEspNow";
        break;
      case 0x0b12:
        msg += "query enableEspOut";
        commandName = "controlDaliCtl_queryEnableEspOut";
        break;
      case 0x0b13:
        msg += "query regular time interval";
        commandName = "controlDaliCtl_queryRegularTimeInterval";
        break;
      case 0x0b14:
        msg += "query survival time interval";
        commandName = "controlDaliCtl_querySurvivalTimeInterval";
        break;
      case 0x0b15:
        msg += "query enable dali";
        commandName = "controlDaliCtl_queryEnableDali";
        break;
      case 0x0b16:
        msg += "query wifiApMacAddress";
        commandName = "controlDaliCtl_queryWifiApMacAddress";
        break;
      case 0x0b17:
        msg += "query enableTurnOnOnDisconnect";
        commandName = "controlDaliCtl_queryEnableTurnOnOnDisconnect";
        break;
      case 0x0b18:
        msg += "query dali power on off status";
        commandName = "controlDaliCtl_queryDaliPowerOnOffStatus";
        break;
      case 0x0b19:
        msg += "query ota ssid";
        commandName = "controlDaliCtl_queryOtaSsid";
        break;
      case 0x0b1a:
        msg += "query ota password";
        commandName = "controlDaliCtl_queryOtaPassword";
        break;
      case 0x0b1b:
        msg += "query switch sequence";
        commandName = "controlDaliCtl_querySwitchSequence";
        break;
      case 0x0b1c:
        msg += "query current firmware version";
        commandName = "controlDaliCtl_queryCurrentFirmwareVersion";
        break;
      case 0x0b1d:
        msg += `query macUploadNode`;
        commandName = "controlDaliCtl_queryMacUploadNode";
        break;
      case 0x0b1e:
        msg += "query cut dim on bypass";
        commandName = "controlDaliCtl_queryCutDimOnBypass";
        break;
      case 0x0b1f:
        msg += "query daliCtl fault";
        commandName = "controlDaliCtl_queryDaliCtlFault";
        break;
      case 0x0b20:
        msg += "query daliCtl enable acknowledge";
        commandName = "controlDaliCtl_queryEnableAcknowledge";
        break;
      case 0x0b21:
        msg += `query daliCtl group action - groupID:${json.groupID} setting${json.settingNum}`;
        commandName = "controlDaliCtl_queryGroupAction";
        break;
      case 0x0b22:
        msg += `query daliCtl group action quantity - groupID:${json?.groupID}`;
        commandName = "controlDaliCtl_queryGroupActionQuantity";
        break;
      case 0x0b23:
        msg += "query daliCtl bypass status";
        commandName = "controlDaliCtl_queryBypassStatus";
        break;
      case 0x0b24:
        msg += "query disableDtk";
        commandName = "controlDaliCtl_queryDisableDtk";
        break;
      case 0x0b80:
        msg += "query dtkInfo";
        commandName = "controlDaliCtl_queryDtkInfo";
        break;
      case 0x0b83:
        msg += "query dtkChannel";
        commandName = "controlDaliCtl_queryDtkChannel";
        break;
      case 0x0ba0:
        msg += "query meshMacAddress";
        commandName = "controlDaliCtl_queryMeshMacAddress";
        break;
      case 0x0ba1:
        msg += "query meshInfo";
        commandName = "controlDaliCtl_queryMeshInfo";
        break;
      case 0x0ba2:
        msg += "query meshChannel";
        commandName = "controlDaliCtl_queryMeshChannel";
        break;
      case 0x0ba3:
        msg += "query meshFrequency";
        commandName = "controlDaliCtl_queryMeshFrequency";
        break;
      case 0x0ba4:
        msg += "query meshSpeed";
        commandName = "controlDaliCtl_queryMeshSpeed";
        break;
      case 0x0ba5:
        msg += "query meshPower";
        commandName = "controlDaliCtl_queryMeshPower";
        break;
      case 0x0ba6:
        msg += "query meshNetworkID";
        commandName = "controlDaliCtl_queryMeshNetworkID";
        break;
      case 0x0ba7:
        msg += "query meshDefinedAdd";
        commandName = "controlDaliCtl_queryMeshDefinedAdd";
        break;
      case 0x0ba8:
        msg += "query meshEnableRepeat";
        commandName = "controlDaliCtl_queryMeshEnableRepeat";
        break;
      case 0x0c01:
        msg += `request gateway send start`;
        commandName = "daliCtlReport_requestGatewaySendStart";
        break;
      case 0x0c02:
        msg += `report short add list - ${json.shortAddArray.join(", ")}`;
        commandName = "daliCtlReport_shortAddList";
        break;
      case 0x0c03:
        msg += `reply general dali query -shortAdd:${json.shortAdd} daliCmd:${json.daliCmd} reply:${json.reply}`;
        commandName = "daliCtlReport_generalDaliQuery";
        break;
      case 0x0c04:
        msg += `System start - ver ${json.version}`;
        commandName = "daliCtlReport_systemStart";
        break;
      case 0x0c06:
        msg += `report light status - shortAdd:${json.shortAdd} lv:${json.lightLv} lockLv:${json.lockLv}`;
        commandName = "daliCtlReport_singleLightStatus";
        break;
      case 0x0c08:
        msg += `report all light lv - ${json.lightLvArray.join(", ")} / bypass: ${json.bypass}`;
        commandName = "daliCtlReport_allLightLv";
        break;
      case 0x0c09:
        msg += `report fade time - shortAdd:${json.shortAdd} fadeTimeCode:${json.fadeTime}`;
        commandName = "daliCtlReport_fadeTime";
        break;
      case 0x0c0a:
        msg += `report memory bank - shortAdd:${json.shortAdd} memoryAdd:${json.memoryAdd} value:${json.value}`;
        commandName = "daliCtlReport_memoryBank";
        break;
      case 0x0c0b:
        msg += `report lock level - shortAdd:${json.shortAdd} lockLevel:${json.lockLevel}`;
        commandName = "daliCtlReport_lockLevel";
        break;
      case 0x0c0c:
        msg += `report all lock level - ${json.lockLvArray.join(", ")}`;
        commandName = "daliCtlReport_allLockLevel";
        break;
      case 0x0c0d:
        msg += `report scan finish`;
        commandName = "daliCtlReport_scanFinish";
        break;
      case 0x0c0e:
        msg += 'report initialise finish';
        commandName = "daliCtlReport_initialiseFinish";
        break;
      case 0x0c0f:
        msg += `report all min lv - ${json.minLvArray.join(", ")}`;
        commandName = "daliCtlReport_allMinLv";
        break;
      case 0x0c10:
        msg += `report all max lv - ${json.maxLvArray.join(", ")}`;
        commandName = "daliCtlReport_allMaxLv";
        break;
      case 0x0c11:
        msg += `report min lv - shortAdd:${json.shortAdd} minLv:${json.minLv}`;
        commandName = "daliCtlReport_minLv";
        break;
      case 0x0c12:
        msg += `report max lv - shortAdd:${json.shortAdd} maxLv:${json.maxLv}`;
        commandName = "daliCtlReport_maxLv";
        break;
      case 0x0c13:
        msg += `report connected light - ${json.connectedLightArray.join(", ")}`;
        commandName = "daliCtlReport_connectedLight";
        break;
      case 0x0c14:
        msg += `report disconnected light - ${json.disconnectedLightArray.join(", ")}`;
        commandName = "daliCtlReport_disconnectedLight";
        break;
      case 0x0c15:
        msg += `report bypass - ${json.bypass}`;
        commandName = "daliCtlReport_bypass";
        break;
      case 0x0c17:
        msg += `report all fade time - ${json.fadeTimeArray.join(", ")}`;
        commandName = "daliCtlReport_allFadeTime";
        break;
      case 0x0c18:
        msg += `report controlA pin - ${json.controlAPin}`;
        commandName = "daliCtlReport_controlAPin";
        break;
      case 0x0c19:
        msg += `report controlB pin - ${json.controlBPin}`;
        commandName = "daliCtlReport_controlBPin";
        break;
      case 0x0c1a:
        msg += `report controlD pin - ${json.controlDPin}`;
        commandName = "daliCtlReport_controlDPin";
        break;
      case 0x0c1b:
        msg += `report disableEspNow - ${json.disableEspNow?.toString()}`;
        commandName = "daliCtlReport_disableEspNow";
        break;
      case 0x0c1c:
        msg += `report enableEspOut - ${json.enableEspOut?.toString()}`;
        commandName = "daliCtlReport_enableEspOut";
        break;
      case 0x0c1d:
        msg += `report regular time interval - ${json.regular_time_interval}`;
        commandName = "daliCtlReport_regularTimeInterval";
        break;
      case 0x0c1e:
        msg += `report survival time interval - ${json.survival_time_interval}`;
        commandName = "daliCtlReport_survivalTimeInterval";
        break;
      case 0x0c1f:
        msg += `report enableDali - ${json.enableDali?.toString()}`;
        commandName = "daliCtlReport_enableDali";
        break;
      case 0x0c20:
        msg += `report enable turn on on disconnected - ${json.enableTurnOnOnDisconnect?.toString()}`;
        commandName = "daliCtlReport_enableTurnOnOnDisconnect";
        break;
      case 0x0c21:
        msg += `report wifiApMacAddress - ${json.wifiApMacAddress}`;
        commandName = "daliCtlReport_wifiApMacAddress";
        break;
      case 0x0c22:
        msg += `report power on off status - ${json.powerOnOffStatus?.toString()}`;
        commandName = "daliCtlReport_powerOnOffStatus";
        break;
      case 0x0c23:
        msg += `report ota ssid - ${json.otaSsid}`;
        commandName = "daliCtlReport_otaSsid";
        break;
      case 0x0c24:
        msg += `report ota password - ${json.otaPassword}`;
        commandName = "daliCtlReport_otaPassword";
        break;
      case 0x0c25:
        msg += `report current firmware version - ${json.version}`;
        commandName = "daliCtlReport_currentFirmwareVersion";
        break;
      case 0x0c26:
        msg += `report update firmware status - [${json.statusCode}] ${codeMsg[json.statusCode]}`;
        commandName = "daliCtlReport_updateFirmwareStatus";
        break;
      case 0x0c27:
        msg += `report switch sequence - ${json.switchSequence}`;
        commandName = "daliCtlReport_switchSequence";
        break;
      case 0x0c28:
        msg += `report macUploadNode - ${json.macAddressArray.join(",")}`;
        commandName = "daliCtlReport_macUploadNode";
        break;
      case 0x0c29:
        msg += `report cut dim on bypass - ${json.cutDimOnBypass?.toString()}`;
        commandName = "daliCtlReport_cutDimOnBypass";
        break;
      case 0x0c2a:
        msg += `report fault - ${json.faultCode} -`;
        if (json.lowMemory) msg += "low memory, ";
        if (json.i2cError) msg += "i2c error, ";
        if (json.batLowVolt) msg += "bat low volt, ";
        if (json.batHighVolt) msg += "bat high volt, ";
        if (json.batLowCur) msg += "bat low current, ";
        if (json.mcpFail) msg += "mcpFail, ";
        if (json.coreTempHigh) msg += "core temp high, ";
        commandName = "daliCtlReport_fault";
        break;
      case 0x0c2c:
        msg += `report daliCtl group action - groupID:${json.groupID} - setting${json.settingNum} - command: ${json.command}`;
        commandName = "daliCtlReport_groupAction";
        break;
      case 0x0c2d:
        msg += "report daliCtl delete all group";
        commandName = "daliCtlReport_deleteAllGroup";
        break;
      case 0x0c2e:
        msg += `report daliCtl report group action quantity`;
        commandName = "daliCtlReport_reportGroupActionQuantity";
        break;
      case 0x0c2f:
        msg += `report bypass status - ${json.bypass}`;
        commandName = "daliCtlReport_bypassStatus";
        break;
      case 0x0c30:
        msg += `report daliCtl update firmware start`;
        commandName = "daliCtlReport_updateFirmwareStart";
        break;
      case 0x0c31:
        msg += `report disableDtk - ${json.disableDtk?.toString()}`;
        commandName = "daliCtlReport_disableDtk";
        break;
      case 0x0c80:
        msg += `report dtkInfo - type:${json.dtkType} | panID:${json.dtkPanID} | channel:${json.dtkChannel} | transferMode:${json.dtkTransferMode} | add:${json.dtkAdd} | loraParameter:${json.loraParameter}`;
        commandName = "daliCtlReport_dtkInfo";
        break;
      case 0x0c83:
        msg += `report dtkChannel - ${json.dtkChannel}`;
        commandName = "daliCtlReport_dtkChannel";
        break;
      case 0x0ca0:
        msg += `report meshMacAddress - ${json.meshMacAddress}`;
        commandName = "daliCtlReport_meshMacAddress";
        break;
      case 0x0ca1:
        msg += `report meshInfo - ${json.meshInfo}`;
        commandName = "daliCtlReport_meshInfo";
        break;
      case 0x0ca2:
        msg += `report meshChannel - ${json.meshChannel}`;
        commandName = "daliCtlReport_meshChannel";
        break;
      case 0x0ca3:
        msg += `report meshFrequency - ${json.meshFreq}`;
        commandName = "daliCtlReport_meshFrequency";
        break;
      case 0x0ca4:
        msg += `report meshSpeed - ${json.meshSpeed}`;
        commandName = "daliCtlReport_meshSpeed";
        break;
      case 0x0ca5:
        msg += `report meshPower - ${json.meshPower}`;
        commandName = "daliCtlReport_meshPower";
        break;
      case 0x0ca6:
        msg += `report meshNetworkID - ${json.meshNetworkID}`;
        commandName = "daliCtlReport_meshNetworkID";
        break;
      case 0x0ca7:
        msg += `report meshDefinedAdd - ${json.meshDefinedAdd}`;
        commandName = "daliCtlReport_meshDefinedAdd";
        break;
      case 0x0ca8:
        msg += `report meshEnableRepeat - ${json.meshEnableRepeat?.toString()}`;
        commandName = "daliCtlReport_meshEnableRepeat";
        break;
      case 0x0ca9:
        msg += `report change mesh info fail`;
        commandName = "daliCtlReport_changeMeshInfoFail";
        break;
      case 0x0e01:
        msg += `esp point to point ping`;
        commandName = "esp_PointToPoint_ping";
        break;
      case 0x0e02:
        msg += `esp point to point pong`;
        commandName = "esp_PointToPoint_pong";
        break;
      case 0x0e03:
        msg += "esp broadcast search nearby mac";
        commandName = "esp_Broadcast_searchNearbyMac";
        break;
      case 0x0e04:
        msg += "esp repeater command container to device";
        commandName = "esp_Repeater_commandContainer";
        break;
      case 0x0e05:
        const instructOf = { 1: "establish", 2: "return", 3: "refresh", 4: "delete" };
        msg += `esp gateway instruction ${instructOf[json.instruct]} delay list`;
        commandName = "esp_Gateway_instructionDelayList";
        break;
      case 0x0e06:
        msg += `esp reclaim delay list ${json.sourceDtkAdd}`;
        commandName = "esp_Reclaim_delayList";
        break;
      case 0x0e07:
        msg += `esp command container to gateway`;
        commandName = "esp_CommandContainer_toGateway";
        break;
      case 0x0e08:
        msg += `refresh delay list`;
        commandName = "esp_Refresh_delayList";
        break;
      case 0x0e09:
        msg += `esp test mac usability macAdd:${json.mac.map(m => m.toString(16).padStart(2, "0")).join(":")}`;
        commandName = "esp_TestMacUsability";
        break;
      case 0x0e84:
        msg += `esp set mac usability`;
        commandName = "esp_SetMacUsability";
        break;
      case 0x0f01:
        msg += `esp unicast verify nearby mac`;
        commandName = "esp_Unicast_verifyNearbyMac";
        break;
      default:
        msg = `Unknown command code ${hexCommandCode?.toString(16)}`;
        commandName = "unknown_command";
        break;
    }
    if (returnName) return commandName;
    return msg;
  };
  coverFF = (macAddress) => {
    // 6 -> 7
    let revealFFByte = 0
    for (let i = 0; i < macAddress.length; i += 2) {
      if (macAddress.substring(i, i + 2) == "ff") {
        macAddress.substring(0, i) + "02" + macAddress.substring(i + 2);
        revealFFByte = this.bitWrite(revealFFByte, (macAddress.length - i) / 2, 1)
      }
    }
    return macAddress + revealFFByte.toString(16).padStart(2, "0");
  }
  revealFF = (macAddress, revealFFByte) => {
    // 7 -> 6
    let macAddress_str = `${macAddress[0].toString(16).padStart(2, 0)}${macAddress[1].toString(16).padStart(2, 0)}${macAddress[2].toString(16).padStart(2, 0)}${macAddress[3].toString(16).padStart(2, 0)}${macAddress[4].toString(16).padStart(2, 0)}${macAddress[5].toString(16).padStart(2, 0)}`
    let revealFF = this.dec2bin(revealFFByte, 8).split('').reverse().join('');
    let mac = "";
    for (let i = 0; i < macAddress_str.length; i += 2) {
      if (revealFF[i / 2] == "1") {
        mac += "ff";
      } else {
        mac += macAddress_str.substring(i, i + 2);
      }
    }
    return mac;
  }
  unmapDelay = (distanceNum) => {
    let result;
    if (distanceNum == 0) result = 0;
    // else if (distanceNum == 254) result = 999;
    else if (distanceNum >= 254 || distanceNum < 0) {
      result = 1000;
    }
    else if (distanceNum >= 200) {
      result = this.unmap(distanceNum, 200, 255, 500, 1000);
    }
    else if (distanceNum >= 100) {
      result = this.unmap(distanceNum, 100, 200, 200, 500);
    }
    else {
      result = this.unmap(distanceNum, 1, 100, 1, 200);
    }
    return Math.round(result);
  }
  unmap = (x, in_min, in_max, out_min, out_max) => {
    return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
  }
  // sensorSettingFieldOf(settingType) {
  //   const map = {
  //     1: "sensorType",
  //     2: "sensorDist",
  //     3: "sensorMode",
  //     4: "hasIR",
  //     5: "disabledSensor",
  //     6: "disabledLux",
  //     7: "disabledMotion",
  //     8: "gang",
  //     9: "check_lux_interval",
  //     0x0a: "enable_delayed_action",
  //     0x0b: "enable_delayed_action2",
  //     0x0c: "motion_off_delay",
  //     0x0d: "motion_off_delay2",
  //     0x0e: "delayCountDown",
  //     0x0f: "disabledRelay",
  //     0x10: "disabledContact",
  //     0x11: "btn1Pin",
  //     0x12: "btn2Pin",
  //     0x13: "btn3Pin",
  //     0x14: "btn4Pin",
  //     0x15: "motionI2C",
  //   };
  //   return map[Number(settingType)];
  // }
  // lightSettingFieldOf(settingType) {
  //   const map = {
  //     2: "lockLevel",
  //     3: "enableA",
  //     4: "enableL",
  //     5: "enableBat",
  //     6: "enableDim",
  //     7: "dimTransition",
  //     8: "dimTransitON",
  //     9: "dimTransitOFF",
  //     10: "cutDimOnBypass",
  //     11: "reverseA",
  //     12: "freeRam",
  //     13: "controlAPin",
  //     14: "controlLPin",
  //     15: "delayCountdown",
  //     16: "inputBypassPin",
  //     17: "controlBPin",
  //     18: "controlDPin",
  //   };
  //   return map[Number(settingType)];
  // }
  // zbInternalCommand(type, target, setValue) {
  //   let targetCode;
  //   if (target === "self") targetCode = "0000";
  //   else if (target === "all") targetCode = "fefdfefd";
  //   else targetCode = target;
  //   let str;
  //   if (type === "readZigbeeAdd") {
  //     str = `fe059021${targetCode}01ff`;
  //   } else if (type === "readNetworkID") {
  //     str = `fe059021${targetCode}02ff`;
  //   } else if (type === "readChannel") {
  //     str = `fe059021${targetCode}03ff`;
  //   } else if (type === "readBaudrate") {
  //     str = `fe059021${targetCode}04ff`;
  //   } else if (type === "setZigbeeAdd") {
  //     str = `fe079021${targetCode}11${setValue}ff`;
  //     if (setValue?.length !== 4) return "fail";
  //   } else if (type === "setNetworkID") {
  //     str = `fe079021${targetCode}12${setValue}ff`;
  //     if (setValue?.length !== 4) return "fail";
  //   } else if (type === "setChannel") {
  //     str = `fe069021${targetCode}13${setValue}ff`;
  //     if (setValue?.length !== 2) return "fail";
  //   } else if (type === "setBaudrate") {
  //     str = `fe069021${targetCode}14${setValue}ff`;
  //     if (setValue?.length !== 2) return "fail";
  //   } else if (type === "resetZigbee") {
  //     str = `fe059021${targetCode}10ff`;
  //     if (targetCode?.length !== 4) return "fail";
  //   } else if (type === "flashRed") {
  //     str = `fe059020${targetCode}${setValue}ff`;
  //     if (setValue?.length !== 2) return "fail";
  //   } else if (type === "readRoute") {
  //     str = `fe058233000002ff`;
  //   } else if (type === "readRssi") {
  //     str = `fe068023${targetCode}ff`; //targetColde has 2 addresses
  //     if (targetCode?.length !== 8) return "fail";
  //   } else if (type === "switchPin4") {
  //     //setValue 10-LOW,  11-HIGH
  //     str = `fe058044${targetCode}${setValue}ff`;
  //     if (setValue?.length !== 2) return "fail";
  //   } else if (type === "switchPin5") {
  //     //setValue 10-LOW,  11-HIGH
  //     str = `fe058045${targetCode}${setValue}ff`;
  //     if (setValue?.length !== 2) return "fail";
  //   }
  //   return str;
  // }
  // zbStrToByteArr = (zbStr) => {
  //   let arr = [];
  //   for (let i = 0; i < zbStr.length; i += 2) {
  //     arr.push(parseInt(zbStr.substring(i, i + 2), 16));
  //   }
  //   return arr;
  // };
  // zbByteArrToStr = (zbArr) => {
  //   let str = "";
  //   zbArr.forEach((d) => {
  //     if (d < 16) {
  //       str += "0" + d.toString(16);
  //     } else {
  //       str += d.toString(16);
  //     }
  //   });
  //   return str;
  // };

  /**
 * Subscribes to a specific topic with a callback function.
 *
 * @param {string} topic - The topic to listen to.
 * @param {Function} callback - The function to execute when the topic receives a message.
 * @param {string} uniqueID - The unique ID for the callback.
 * @param {object} config - The config for the callback.
 * available topics:
 * - disk_monitor : disk info 
 *   {[disk_name:string]:percent}
 * - diskIO_monitor : disk io info
 * - cpu_monitor : cpu info
 * - ram_monitor : ram info
 */
  on(topic, callback, uniqueID, config) {
    if (!this.event_emitter_callback[uniqueID]) this.event_emitter_callback[uniqueID] = {};
    if (this.event_emitter_callback[uniqueID][topic]) return;
    this.event_emitter_callback[uniqueID][topic] = callback;
    on(topic, callback, config);
  }


  /**
 * Unsubscribes from a specific topic with a callback function.
 *
 * @param {string} topic - The topic to unsubscribe from.
 * @param {string} uniqueID - The unique ID for the callback.
 */
  off(topic, uniqueID) {
    if (!this.event_emitter_callback[uniqueID]) return;
    if (this.event_emitter_callback[uniqueID][topic]) {
      off(topic, this.event_emitter_callback[uniqueID][topic]);
      delete this.event_emitter_callback[uniqueID][topic];
    }
  }

  /**
 * Gets the event emitter listener status.
 *
 * @param {string} uniqueID - The unique ID for the callback.
 * @returns {object} - The event emitter listener status.
 */
  getEventEmitterListenerStatus(uniqueID) {
    if (!uniqueID) return this.event_emitter_callback;
    return this.event_emitter_callback[uniqueID];
  }
  wifiFreqToChannel = (freq) => {
    return Math.round((freq - 2407) / 5);
  }
  wifiChannelToFreq = (channel) => {
    return (channel * 5) + 2407;
  }
  //////zigbee////////////////zigbee////////////////zigbee////////////////zigbee///////////
  zbStrToJson(str) {
    const port = str.substring(4, 6);
    const port2 = str.substring(6, 8);
    const zigbeeAdd = str.substring(8, 12);
    const byteLength = str.length / 2;
    const dataLenStr = str.substring(2, 4);
    const dataLen = this.hexToInt(dataLenStr);
    if (port === "21" && port2 === "90") {
      const zbCmd = str.substring(12, 14);
      let obj;
      if (zbCmd === "21") {
        const zb = str.substring(14, 18);
        obj = { port: "21", zigbeeAdd: zb };
      } else if (zbCmd === "22") {
        const nid = str.substring(14, 18);
        obj = { port: "22", networkID: nid };
      } else if (zbCmd === "23") {
        const ch = str.substring(14, 16);
        obj = { port: "23", channel: ch };
      } else if (zbCmd === "24") {
        const br = str.substring(14, 16);
        obj = { port: "24", baudrate: br };
      }
      return obj;
    } else if (port === "23" && port2 === "80") {
      //rssi response:  fe 07 23 80 00 00 6b a6 22 ff
      const zb = str.substring(8, 12);
      const zb2 = str.substring(12, 16);
      const rssiStr = str.substring(16, 18);
      const rssi = this.hexToInt(rssiStr);
      const obj = { zbCmd: "2380", zigbeeAdd: zb, zigbeeAdd2: zb2, rssi: rssi };
      return obj;
    } else if (port === "33" && port2 === "82") {
      const len = this.hexToInt(str.substring(2, 4));
      const groupQty = (len - 5) / 5;
      const packetQty = str.substring(12, 14);
      // fe2d33820000821f141f1401b5a3b5a3017837783701e786e786019b269b2601dc9fdc9f01bda6bda6016ba66ba601ff;
      let routeArr = [];
      for (let i = 0; i < groupQty; i++) {
        const index = i * 10 + 14;
        const targetNode = str.substring(index, index + 4);
        const midNode = str.substring(index + 4, index + 8);
        const jump = this.hexToInt(str.substring(index + 8, index + 10));
        routeArr = [...routeArr, { targetNode, midNode, jump }];
      }
      const obj = { zbCmd: "3382", groupQty, packetQty, routeArr };
      return obj;
    } else if (port.toUpperCase() === "D0") {
      let obj = { port, zigbeeAdd, commandName: "lightRequestSetting" };
      if (byteLength === 8) {
        //VER0, do nothing
      }
      if (byteLength === 9) {
        //VER1
        const majorVer = this.hexToInt(str.substring(12, 14));
        const minorVer = this.hexToInt(str.substring(14, 16));
        const minorVerStr = minorVer < 10 ? `0${minorVer}` : minorVer;
        obj = {
          ...obj,
          version: `${majorVer}.${minorVerStr}`,
        };
      }
      return obj;
    } else if (port.toUpperCase() === "D1") {
      const obj = { port, zigbeeAdd, commandName: "lightReplyBroadcastSearch" };
      return obj;
    } else if (port.toUpperCase() === "D2") {
      let obj = { port, zigbeeAdd, commandName: "lightUploadData" };
      if (byteLength > 18) {
        //VER0
        const currentPolarity = this.hexToInt(str.substring(16, 18));
        let current = this.hexToInt(str.substring(18, 22)) / 100;
        if (currentPolarity === 1) {
          current = current * -1;
        }
        obj = {
          ...obj,
          voltage: this.hexToInt(str.substring(12, 16)) / 100,
          current,
          voltageL: this.hexToInt(str.substring(22, 26)) / 100,
          currentL: this.hexToInt(str.substring(26, 30)) / 100,
          onoffstatusA: this.hexToInt(str.substring(30, 32)),
          onoffstatusL: this.hexToInt(str.substring(32, 34)),
          lux: this.hexToInt(str.substring(34, 38)),
          lightLv: this.hexToInt(str.substring(38, 40)),
          destination: this.hexToInt(str.substring(40, 42)),
          bypass: this.hexToInt(str.substring(42, 44)),
        };
      } else if (byteLength === 17) {
        //VER1
        const currentPolarity = this.hexToInt(str.substring(16, 18));
        let current = this.hexToInt(str.substring(18, 22)) / 100;
        if (currentPolarity === 1) current = current * -1;
        obj = {
          ...obj,
          voltage: this.hexToInt(str.substring(12, 16)) / 100,
          current,
          voltageL: 0,
          currentL: 0,
          onoffstatusA: this.hexToInt(str.substring(22, 24)),
          onoffstatusL: this.hexToInt(str.substring(24, 26)),
          lux: 0,
          lightLv: this.hexToInt(str.substring(26, 28)),
          destination: this.hexToInt(str.substring(28, 30)),
          bypass: this.hexToInt(str.substring(30, 32)),
        };
      }
      return obj;
    } else if (port.toUpperCase() === "D3") {
      const obj = {
        port,
        zigbeeAdd,
        commandName: "lightSurvival",
      };
      return obj;
    } else if (port.toUpperCase() === "D4") {
      let obj = { port, zigbeeAdd, commandName: "lightSystemStart" };
      if (byteLength === 15) {
        //VER0
        const version =
          String.fromCharCode(this.hexToInt(str.substring(20, 22))) +
          String.fromCharCode(this.hexToInt(str.substring(22, 24))) +
          String.fromCharCode(this.hexToInt(str.substring(24, 26))) +
          String.fromCharCode(this.hexToInt(str.substring(26, 28)));
        obj = { ...obj, version };
      } else if (byteLength === 22) {
        //VER1
        let ip = `${this.hexToInt(str.substring(20, 22))}.${this.hexToInt(
          str.substring(22, 24)
        )}.${this.hexToInt(str.substring(24, 26))}.${this.hexToInt(
          str.substring(26, 28)
        )}`;
        const version =
          String.fromCharCode(this.hexToInt(str.substring(12, 14))) +
          String.fromCharCode(this.hexToInt(str.substring(14, 16))) +
          String.fromCharCode(this.hexToInt(str.substring(16, 18))) +
          String.fromCharCode(this.hexToInt(str.substring(18, 20)));
        const ipArray = [
          this.hexToInt(str.substring(20, 22)),
          this.hexToInt(str.substring(22, 24)),
          this.hexToInt(str.substring(24, 26)),
          this.hexToInt(str.substring(26, 28)),
        ];
        const macArray = [
          this.hexToInt(str.substring(28, 30)),
          this.hexToInt(str.substring(30, 32)),
          this.hexToInt(str.substring(32, 34)),
          this.hexToInt(str.substring(34, 36)),
          this.hexToInt(str.substring(36, 38)),
          this.hexToInt(str.substring(38, 40)),
        ];
        obj = {
          ...obj,
          version,
          ip,
          ipArray,
          macArray,
          mac: str.substring(28, 40),
          zbChannel: this.hexToInt(str.substring(40, 42)),
        };
      } else if (byteLength === 14) {
        //VER2
        const ipArray = [
          this.hexToInt(str.substring(16, 18)),
          this.hexToInt(str.substring(18, 20)),
          this.hexToInt(str.substring(20, 22)),
          this.hexToInt(str.substring(22, 24)),
        ];
        const ip = ipArray.join(".");
        const majorVer = this.hexToInt(str.substring(12, 14));
        const minorVer = this.hexToInt(str.substring(14, 16));
        const minorVerStr = minorVer < 10 ? `0${minorVer}` : minorVer;
        obj = {
          ...obj,
          version: `${majorVer}.${minorVerStr}`,
          ip,
          ipArray,
          // macArray: [],
          // mac: "",
          zbChannel: this.hexToInt(str.substring(24, 26)),
        };
      }
      return obj;
    } else if (port.toUpperCase() === "D5") {
      let obj = { port, zigbeeAdd, commandName: "lightTestStart" };
      if (byteLength > 12) {
        obj.reportID = str.substring(20, 28);
      } else {
        obj.reportID = str.substring(12, 20);
      }
      return obj;
    } else if (port.toUpperCase() === "D6") {
      let obj;
      if (byteLength > 22) {
        const currentPolarity = this.hexToInt(str.substring(26, 28));
        let current = this.hexToInt(str.substring(28, 32)) / 100;
        if (currentPolarity === 1) {
          current = current * -1;
        }
        obj = {
          voltage: this.hexToInt(str.substring(22, 26)) / 100,
          current,
          voltageL: this.hexToInt(str.substring(32, 36)) / 100,
          currentL: this.hexToInt(str.substring(36, 40)) / 100,
          onoffstatusA: this.hexToInt(str.substring(40, 42)),
          onoffstatusL: this.hexToInt(str.substring(42, 44)),
          reportID: str.substring(44, 52),
          testTime: this.hexToInt(str.substring(52, 56)),
          lux: this.hexToInt(str.substring(56, 60)),
          progress: this.hexToInt(str.substring(60, 62)),
          lightLv: this.hexToInt(str.substring(62, 64)),
          ver: 1,
        };
      } else {
        const currentPolarity = this.hexToInt(str.substring(16, 18));
        let current = this.hexToInt(str.substring(18, 22)) / 100;
        if (currentPolarity === 1) current = current * -1;
        obj = {
          voltage: this.hexToInt(str.substring(12, 16)) / 100,
          current,
          voltageL: 0,
          currentL: 0,
          onoffstatusA: this.hexToInt(str.substring(22, 24)),
          onoffstatusL: this.hexToInt(str.substring(24, 26)),
          reportID: str.substring(26, 34),
          testTime: this.hexToInt(str.substring(34, 38)),
          lux: 0,
          progress: this.hexToInt(str.substring(38, 40)),
          lightLv: 0,
          ver: 2,
        };
      }
      obj = { ...obj, port, zigbeeAdd, commandName: "lightUploadTestData" };
      return obj;
    } else if (port.toUpperCase() === "D7") {
      let obj;
      if (byteLength > 14) {
        obj = {
          reportID: str.substring(20, 28),
          totalTestTime: this.hexToInt(str.substring(28, 32)),
        };
      } else {
        obj = {
          reportID: str.substring(12, 20),
          totalTestTime: this.hexToInt(str.substring(20, 24)),
        };
      }
      obj = { ...obj, port, zigbeeAdd, commandName: "lightTestFinish" };
      return obj;
    } else if (port.toUpperCase() === "D8") {
      let obj;
      if (byteLength > 19) {
        //old with serial
        const currentPolarity = this.hexToInt(str.substring(26, 27));
        let current = this.hexToInt(str.substring(28, 32)) / 100;
        if (currentPolarity === 1) {
          current = current * -1;
        }
        obj = {
          destination: this.hexToInt(str.substring(20, 22)),
          voltage: this.hexToInt(str.substring(22, 26)) / 100,
          current,
          voltageL: this.hexToInt(str.substring(32, 36)) / 100,
          currentL: this.hexToInt(str.substring(36, 40)) / 100,
          onoffstatusA: this.hexToInt(str.substring(40, 42)),
          onoffstatusL: this.hexToInt(str.substring(42, 44)),
          lux: this.hexToInt(str.substring(44, 48)),
          lightLv: this.hexToInt(str.substring(48, 50)),
          portReply: str.substring(52, 54),
          lockLevel: this.hexToInt(str.substring(54, 56)),
        };
      } else if (byteLength === 18) {
        const currentPolarity = this.hexToInt(str.substring(18, 20));
        let current = this.hexToInt(str.substring(20, 24)) / 100;
        if (currentPolarity === 1) {
          current = current * -1;
        }
        obj = {
          destination: this.hexToInt(str.substring(12, 14)),
          voltage: this.hexToInt(str.substring(14, 18)) / 100,
          current,
          voltageL: 0,
          currentL: 0,
          onoffstatusA: this.hexToInt(str.substring(24, 26)),
          onoffstatusL: this.hexToInt(str.substring(26, 28)),
          lux: 0,
          lightLv: this.hexToInt(str.substring(28, 30)),
          portReply: str.substring(30, 32),
          lockLevel: this.hexToInt(str.substring(32, 34)),
        };
      } else if (byteLength === 14) {
        const portReply = str.substring(12, 14).toUpperCase();
        switch (portReply) {
          case "A3": {
            const currentPolarity = this.hexToInt(str.substring(18, 20));
            let current = this.hexToInt(str.substring(20, 24)) / 100;
            if (currentPolarity === 1) current = current * -1;
            obj = {
              voltage: this.hexToInt(str.substring(14, 18)) / 100,
              current,
              onoffstatusL: this.hexToInt(str.substring(24, 26)),
              portReply,
            };
            break;
          }
          case "A4": {
            obj = {
              portReply,
              onoffstatusA: this.hexToInt(str.substring(14, 16)),
              lightLv: this.hexToInt(str.substring(16, 18)),
              bypass: this.hexToInt(str.substring(18, 20)),
              lockLevel: this.hexToInt(str.substring(20, 22)),
            };
            break;
          }
          case "A9": {
            obj = {
              portReply,
              lockLevel: this.hexToInt(str.substring(14, 16)),
            };
            break;
          }
        }
      }
      obj = { ...obj, port, zigbeeAdd, commandName: "lightReplyLightAction" };
      return obj;
    } else if (port.toUpperCase() === "D9") {
      const obj = {
        port,
        zigbeeAdd,
        replyPort: str.substring(12, 14),
        commandName: "lightShortReply",
      };
      return obj;
    } else if (port.toUpperCase() === "DA") {
      const faultCode1 = this.hexToInt(str.substring(12, 14));
      const faultCode2 = this.hexToInt(str.substring(14, 16));
      let faultBin1 = [];
      let faultBin2 = [];
      for (let i = 0; i < 8; i++) {
        faultBin1[i] = (faultCode1 >> i) & 1;
        faultBin2[i] = (faultCode2 >> i) & 1;
      }
      const obj = {
        port,
        zigbeeAdd,
        commandName: "lightFault",
        lowMemory: faultBin1[0] || 0,
        lossIna: faultBin1[1] || 0,
        lowBatV: faultBin1[2] || 0,
        highBatV: faultBin1[3] || 0,
        noBatCur: faultBin1[4] || 0,
        notMatchCtlA: faultBin1[5] || 0,
        lossMcp: faultBin1[6] || 0,
        fault1_spare: faultBin1[7] || 0,
        daliGearNotPresent: faultBin2[0] || 0,
        daliLampFail: faultBin2[1] || 0,
        daliPowerFail: faultBin2[2] || 0,
        fault2_spare3: faultBin2[3] || 0,
        fault2_spare4: faultBin2[4] || 0,
        fault2_spare5: faultBin2[5] || 0,
        fault2_spare6: faultBin2[6] || 0,
        fault2_spare7: faultBin2[7] || 0,
        faultBin1,
        faultBin2,
        faultCode1,
        faultCode2,
      };
      return obj;
    } else if (port.toUpperCase() === "DB") {
      const obj = {
        port,
        zigbeeAdd,
        commandName: "lightRequestGatewayShortReply",
      };
      return obj;
    } else if (port.toUpperCase() === "DD") {
      const settingType = this.hexToInt(str.substring(12, 14));
      const data1 = this.hexToInt(str.substring(14, 16));
      const data2 = this.hexToInt(str.substring(16, 18));
      const settingVal = (data1 << 8) + data2;
      // const map = {
      //   2: "lockLevel",
      //   3: "enableA",
      //   4: "enableL",
      //   5: "enaleBat",
      //   6: "enableDim",
      //   7: "dimTransition",
      //   8: "dimTransitON",
      //   9: "dimTransitOFF",
      //   10: "cutDimOnBypass",
      //   11: "reverseA",
      //   12: "freeRam",
      //   13: "controlAPin",
      //   14: "controlLPin",
      //   15: "delayCountDown",
      //   16: "inputBypassPin",
      //   17: "controlBPin",
      //   18: "controlDPin",
      //   19: "dtkResetPin",
      //   20: "dtkFctPin"
      // };
      const settingTypeName = this.lightSettingFieldOf(settingType);
      let obj = {
        port,
        zigbeeAdd,
        commandName: "lightReportOneSetting",
        // settingType: map[settingType],
        settingType: settingTypeName,
        settingVal,
      };
      return obj;
    } else if (port.toUpperCase() === "80") {
      let obj = {
        port,
        zigbeeAdd,
        commandName: "sensorRequestSetting",
      };
      if (byteLength === 8) {
        //VER0, do nothing
      }
      if (byteLength === 9) {
        //VER1
        const majorVer = this.hexToInt(str.substring(12, 14));
        const minorVer = this.hexToInt(str.substring(14, 16));
        const minorVerStr = minorVer < 10 ? `0${minorVer}` : minorVer;
        obj = {
          ...obj,
          version: `${majorVer}.${minorVerStr}`,
        };
      }
      return obj;
    } else if (port.toUpperCase() === "82") {
      let obj = { port, zigbeeAdd, commandName: "sensorUploadData" };
      if (byteLength > 14) {
        //VER0
        obj = {
          currentStatus: this.hexToInt(str.substring(12, 14)),
          currentStatus2: this.hexToInt(str.substring(14, 16)),
          currentStatus3: this.hexToInt(str.substring(16, 18)),
          sensorType: this.hexToInt(str.substring(18, 20)),
          isUpload: this.hexToInt(str.substring(20, 22)),
          settingNum: this.hexToInt(str.substring(22, 24)),
          lux: this.hexToInt(str.substring(24, 28)),
        };
      } else if (byteLength === 13) {
        //VER1
        const statusByte = this.hexToInt(str.substring(12, 14));
        obj = {
          lux: this.hexToInt(str.substring(14, 18)),
          sensorType: this.hexToInt(str.substring(18, 20)),
          isUpload: this.hexToInt(str.substring(20, 22)),
          settingNum: this.hexToInt(str.substring(22, 24)),
        };
        for (let i = 0; i < 8; i++) {
          obj[`currentStatus${i === 0 ? "" : i + 1}`] = (statusByte >> i) & 1;
        }
      }
      return obj;
    } else if (port.toUpperCase() === "83") {
      const obj = {
        port,
        zigbeeAdd,
        commandName: "sensorSurvival",
      };
      return obj;
    } else if (port.toUpperCase() === "84") {
      let obj = { port, zigbeeAdd, commandName: "sensorSystemStart" };
      if (byteLength > 14) {
        let ip = `${this.hexToInt(str.substring(20, 22))}.${this.hexToInt(
          str.substring(22, 24)
        )}.${this.hexToInt(str.substring(24, 26))}.${this.hexToInt(
          str.substring(26, 28)
        )}`;
        const version =
          String.fromCharCode(this.hexToInt(str.substring(12, 14))) +
          String.fromCharCode(this.hexToInt(str.substring(14, 16))) +
          String.fromCharCode(this.hexToInt(str.substring(16, 18))) +
          String.fromCharCode(this.hexToInt(str.substring(18, 20)));
        const ipArray = [
          this.hexToInt(str.substring(20, 22)),
          this.hexToInt(str.substring(22, 24)),
          this.hexToInt(str.substring(24, 26)),
          this.hexToInt(str.substring(26, 28)),
        ];
        const macArray = [
          this.hexToInt(str.substring(28, 30)),
          this.hexToInt(str.substring(30, 32)),
          this.hexToInt(str.substring(32, 34)),
          this.hexToInt(str.substring(34, 36)),
          this.hexToInt(str.substring(36, 38)),
          this.hexToInt(str.substring(38, 40)),
        ];
        obj = {
          ...obj,
          version,
          ip,
          ipArray,
          macArray,
          mac: str.substring(28, 40),
          zbChannel: this.hexToInt(str.substring(40, 42)),
        };
      } else if (byteLength === 14) {
        const ipArray = [
          this.hexToInt(str.substring(16, 18)),
          this.hexToInt(str.substring(18, 20)),
          this.hexToInt(str.substring(20, 22)),
          this.hexToInt(str.substring(22, 24)),
        ];
        const ip = ipArray.join(".");
        const majorVer = this.hexToInt(str.substring(12, 14));
        const minorVer = this.hexToInt(str.substring(14, 16));
        const minorVerStr = minorVer < 10 ? `0${minorVer}` : minorVer;
        obj = {
          ...obj,
          version: `${majorVer}.${minorVerStr}`,
          ip,
          ipArray,
          macArray: [],
          mac: "",
          zbChannel: this.hexToInt(str.substring(24, 26)),
        };
      }
      return obj;
    } else if (port.toUpperCase() === "85") {
      const settingType = this.hexToInt(str.substring(12, 14));
      const data1 = this.hexToInt(str.substring(14, 16));
      const data2 = this.hexToInt(str.substring(16, 18));
      const settingVal = (data1 << 8) + data2;
      const settingTypeField = this.sensorSettingFieldOf(settingType);
      let obj = {
        port,
        zigbeeAdd,
        settingVal,
        settingType,
        settingTypeField,
        commandName: "sensorReportOneSetting",
      };
      return obj;
    } else if (port.toUpperCase() === "88") {
      const portReply = str.substring(12, 14).toUpperCase();
      const obj = {
        port,
        zigbeeAdd,
        portReply,
        commandName: "sensorReplySensorAction",
      };
      return obj;
    } else if (port.toUpperCase() === "A0") {
      const obj = {
        port,
        zigbeeAdd,
      };
      return obj;
    } else if (port.toUpperCase() === "A2") {
      const commandMode = this.hexToInt(str.substring(12, 14));
      // const { checksumByte, checksumCalc } = this.verifyChecksum(str);
      let obj = {};
      switch (commandMode) {
        case 8: {
          obj = {
            commandName: "flashCtlA",
            flashTimes: this.hexToInt(str.substring(14, 16)),
          };
          break;
        }
        case 9: {
          obj = {
            commandName: "lightAction",
            lockLevel: this.hexToInt(str.substring(14, 16)),
            releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
            pwm: this.hexToInt(str.substring(18, 20)),
          };
          break;
        }
        case 0x0a: {
          obj = {
            commandName: "delayedLightAction",
            lockLevel: this.hexToInt(str.substring(14, 16)),
            releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
            delaySec: this.hexToInt(str.substring(18, 22)),
            delayedPwm: this.hexToInt(str.substring(22, 24)),
          };
          break;
        }
        case 0x0b: {
          obj = {
            commandName: "delayedLightAction2",
            lockLevel: this.hexToInt(str.substring(14, 16)),
            releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
            delaySec: this.hexToInt(str.substring(18, 22)),
            delayedPwm: this.hexToInt(str.substring(22, 24)),
            delaySec2: this.hexToInt(str.substring(24, 28)),
            delayedPwm2: this.hexToInt(str.substring(28, 30)),
          };
          break;
        }
        case 0x0c: {
          obj = {
            commandName: "reverseSwitch",
            lockLevel: this.hexToInt(str.substring(14, 16)),
            releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
          };
          break;
        }
      }
      obj = { ...obj, port, zigbeeAdd, commandMode };
      return obj;
    } else if (port.toUpperCase() === "A3") {
      let obj = { port, zigbeeAdd };
      if (byteLength === 12) {
        obj = { ...obj, controlL: this.hexToInt(str.substring(20, 22)) };
      } else if (byteLength === 8) {
        obj = {
          ...obj,
          controlL: this.hexToInt(str.substring(12, 14)),
          ver: 1,
        };
      }
      return obj;
    } else if (port.toUpperCase() === "A4") {
      let obj = { port, zigbeeAdd };
      if (byteLength > 20) {
        //VER0
        obj = {
          ...obj,
          lockLevel: this.hexToInt(str.substring(18, 20)),
          controlA: this.hexToInt(str.substring(20, 22)),
          pwm: this.hexToInt(str.substring(22, 24)),
          enable_delayed_action: this.hexToInt(str.substring(24, 26)),
          delayedOnOff: this.hexToInt(str.substring(26, 28)),
          delayedPwm: this.hexToInt(str.substring(28, 30)),
          delayed_action: this.hexToInt(str.substring(30, 34)),
          lockLevel2: this.hexToInt(str.substring(34, 36)),
          enable_delayed_action2: this.hexToInt(str.substring(36, 38)),
          delayedOnOff2: this.hexToInt(str.substring(38, 40)),
          delayedPwm2: this.hexToInt(str.substring(40, 42)),
          delayed_action2: this.hexToInt(str.substring(42, 46)),
        };
      } else if (byteLength === 17) {
        //VER1
        const onoffByte = this.hexToInt(str.substring(16, 18));
        const delayed_action = this.hexToInt(str.substring(22, 26));
        const delayed_action2 = this.hexToInt(str.substring(28, 32));
        obj = {
          ...obj,
          subLightAdd: this.hexToInt(str.substring(12, 14)),
          lockLevel: this.hexToInt(str.substring(14, 16)),
          controlA: (onoffByte >> 0) & 1,
          pwm: this.hexToInt(str.substring(18, 20)),
          enable_delayed_action: delayed_action > 0 ? 1 : 0,
          delayedOnOff: (onoffByte >> 1) & 1,
          delayedPwm: this.hexToInt(str.substring(20, 22)),
          delayed_action,
          enable_delayed_action2: delayed_action2 > 0 ? 1 : 0,
          delayedOnOff2: (onoffByte >> 2) & 1,
          delayedPwm2: this.hexToInt(str.substring(26, 28)),
          delayed_action2,
          releaseOnDelayEnd: (onoffByte >> 3) & 1,
          // ignorePwm: (onoffByte>>4)&1,
          // ignoreOnOff: (onoffByte>>5)&1,
          // ignoreDelayedPwm:(onoffByte>>6)&1,
          // ignoreDelayedOnOff:(onoffByte>>7)&1,
          ver: 1,
        };
        // } else if (byteLength === 18) {
        //   //VER2
        //   const onoffByte = this.hexToInt(str.substring(16, 18));
        //   const delayed_action = this.hexToInt(str.substring(22, 26));
        //   const delayed_action2 = this.hexToInt(str.substring(28, 32));
        //   // const checksum = this.hexToInt(str.substring(32, 34));
        //   // const strForCheck = str.substring(0, str.length - 4);
        //   // const checksumCalc = this.calculateChecksum(strForCheck);
        //   const { checksumByte, checksumCalc } = this.verifyChecksum(str);

        //   obj = {
        //     ...obj,
        //     subLightAdd: this.hexToInt(str.substring(12, 14)),
        //     lockLevel: this.hexToInt(str.substring(14, 16)),
        //     controlA: (onoffByte >> 0) & 1,
        //     pwm: this.hexToInt(str.substring(18, 20)),
        //     enable_delayed_action: delayed_action > 0 ? 1 : 0,
        //     delayedOnOff: (onoffByte >> 1) & 1,
        //     delayedPwm: this.hexToInt(str.substring(20, 22)),
        //     delayed_action,
        //     enable_delayed_action2: delayed_action2 > 0 ? 1 : 0,
        //     delayedOnOff2: (onoffByte >> 2) & 1,
        //     delayedPwm2: this.hexToInt(str.substring(26, 28)),
        //     delayed_action2,
        //     releaseOnDelayEnd: (onoffByte >> 3) & 1,
        //     ver: 2,
        //     checksumByte,
        //     checksumCalc,
        //     checksumOK: checksumCalc === checksumByte,
        //   };
      }
      return obj;
    } else if (port.toUpperCase() === "A5") {
      let obj = { port, zigbeeAdd };
      if (byteLength > 22) {
        //VER0
        const minV = this.hexToInt(str.substring(28, 32)) / 100;
        const minI = this.hexToInt(str.substring(32, 36)) / 100;
        obj = {
          ...obj,
          time_pretest: this.hexToInt(str.substring(20, 22)),
          time_cutOff: this.hexToInt(str.substring(22, 24)),
          time_recharge: this.hexToInt(str.substring(24, 26)),
          time_interval: this.hexToInt(str.substring(26, 28)),
          minV,
          minI,
          reportID: str.substring(36, 44),
          ver: 0,
        };
      } else if (byteLength === 19) {
        //VER1
        const minV = this.hexToInt(str.substring(20, 24)) / 100;
        const minI = this.hexToInt(str.substring(24, 28)) / 100;
        obj = {
          ...obj,
          time_pretest: this.hexToInt(str.substring(12, 14)),
          time_cutOff: this.hexToInt(str.substring(14, 16)),
          time_recharge: this.hexToInt(str.substring(16, 18)),
          time_interval: this.hexToInt(str.substring(18, 20)),
          minV,
          minI,
          reportID: str.substring(28, 36),
          ver: 1,
        };
      }
      return obj;
    } else if (port.toUpperCase() === "A7") {
      const obj = {
        port,
        zigbeeAdd,
      };
      return obj;
    } else if (port.toUpperCase() === "AA") {
      const obj = {
        port,
        zigbeeAdd,
      };
      return obj;
    } else if (port.toUpperCase() === "AB") {
      let obj = { port, zigbeeAdd };
      if (dataLen === 0x11) {
        obj = {
          ...obj,
          typeA: this.hexToInt(str.substring(12, 14)),
          typeL: this.hexToInt(str.substring(14, 16)),
          typeBatVI: this.hexToInt(str.substring(16, 18)),
          typePwm: this.hexToInt(str.substring(18, 20)),
          dimTransition: this.hexToInt(str.substring(20, 22)),
          dimTransitON: this.hexToInt(str.substring(22, 24)),
          dimTransitOFF: this.hexToInt(str.substring(24, 26)),
          cutDimOnBypass: this.hexToInt(str.substring(26, 28)),
          reverseA: this.hexToInt(str.substring(28, 30)),
          survival_time_interval: this.hexToInt(str.substring(30, 32)),
          survival_timeout: this.hexToInt(str.substring(32, 34)),
          regular_time_interval: this.hexToInt(str.substring(34, 36)),
          lockLevel: this.hexToInt(str.substring(36, 38)),
        };
      } else if (dataLen === 0x0c) {
        const typeByte = this.hexToInt(str.substring(12, 14));
        const operateByte = this.hexToInt(str.substring(14, 16));
        obj = {
          ...obj,
          typeA: (typeByte >> 0) & 1,
          typeL: (typeByte >> 1) & 1,
          typeBatVI: (typeByte >> 2) & 1,
          typePwm: (typeByte >> 3) & 1,
          reverseA: (operateByte >> 0) & 1,
          cutDimOnBypass: (operateByte >> 1) & 1,
          enableMotion: (operateByte >> 2) & 1,
          dimTransition: this.hexToInt(str.substring(16, 18)),
          dimTransitON: this.hexToInt(str.substring(18, 20)),
          dimTransitOFF: this.hexToInt(str.substring(20, 22)),
          survival_time_interval: this.hexToInt(str.substring(22, 24)),
          regular_time_interval: this.hexToInt(str.substring(24, 26)),
          gwChecksum: this.hexToInt(str.substring(26, 28)),
          ver: 1,
        };
      }
      return obj;
    } else if (port.toUpperCase() === "AC") {
      const settingType = this.hexToInt(str.substring(12, 14));
      const data1 = this.hexToInt(str.substring(14, 16));
      const data2 = this.hexToInt(str.substring(16, 18));
      const val = (data1 << 8) + data2;
      const settingTypeField = this.lightSettingFieldOf(settingType);
      let obj = {
        port,
        zigbeeAdd,
        settingType,
        [settingTypeField]: val,
      };
      return obj;
    } else if (port.toUpperCase() === "AD") {
      const obj = {
        port,
        zigbeeAdd,
        settingType: this.hexToInt(str.substring(12, 14)),
      };
      return obj;
    } else if (port.toUpperCase() === "AE") {
      const obj = {
        port,
        zigbeeAdd,
        typeA: this.hexToInt(str.substring(12, 14)),
        typeL: this.hexToInt(str.substring(14, 16)),
        typeBatVI: this.hexToInt(str.substring(16, 18)),
        typePwm: this.hexToInt(str.substring(18, 20)),
        dimTransition: this.hexToInt(str.substring(20, 22)),
        dimTransitON: this.hexToInt(str.substring(22, 24)),
        dimTransitOFF: this.hexToInt(str.substring(24, 26)),
        cutDimOnBypass: this.hexToInt(str.substring(26, 28)),
        reverseA: this.hexToInt(str.substring(28, 30)),
        survival_time_interval: this.hexToInt(str.substring(30, 32)),
        survival_timeout: this.hexToInt(str.substring(32, 34)),
        regular_time_interval: this.hexToInt(str.substring(34, 36)),
        lockLevel: this.hexToInt(str.substring(36, 38)),
      };
      return obj;
    } else if (port.toUpperCase() === "90") {
      const obj = {
        port,
        zigbeeAdd,
      };
      return obj;
    } else if (port.toUpperCase() === "91") {
      const commandMode = this.hexToInt(str.substring(12, 14));
      let obj = { port, zigbeeAdd, commandMode };
      switch (commandMode) {
        case 2: {
          obj = {
            ...obj,
            delaySec: this.hexToInt(str.substring(14, 18)),
            commandName: "disableSensorWithDelay",
          };
          break;
        }
        case 3: {
          obj = { ...obj, commandName: "terminateDisableDelay" };
          break;
        }
        case 4: {
          obj = {
            ...obj,
            delaySec: this.hexToInt(str.substring(14, 18)),
            commandName: "enableSensorWithDelay",
          };
          break;
        }
        case 5: {
          obj = { ...obj, commandName: "terminateEnableDelay" };
          break;
        }
        default:
          break;
      }
      return obj;
    } else if (port.toUpperCase() === "94") {
      const obj = {
        port,
        zigbeeAdd,
        switchType: this.hexToInt(str.substring(12, 14)),
        onoffcontrol: this.hexToInt(str.substring(14, 16)),
      };
      return obj;
    } else if (port.toUpperCase() === "96") {
      const obj = {
        port,
        zigbeeAdd,
      };
      return obj;
    } else if (port.toUpperCase() === "9A") {
      const obj = {
        port,
        zigbeeAdd,
      };
      return obj;
    } else if (port.toUpperCase() === "9B") {
      let obj = { port, zigbeeAdd };
      if (dataLen === 0x0e) {
        obj = {
          regular_time_interval: this.hexToInt(str.substring(12, 14)),
          survival_time_interval: this.hexToInt(str.substring(14, 16)),
          survival_timeout: this.hexToInt(str.substring(16, 18)),
          enable_delayed_action: this.hexToInt(str.substring(18, 20)),
          motion_off_delay: this.hexToInt(str.substring(20, 24)),
          enable_delayed_action2: this.hexToInt(str.substring(24, 26)),
          motion_off_delay2: this.hexToInt(str.substring(26, 30)),
          sensorDist: this.hexToInt(str.substring(30, 32)),
        };
      } else if (dataLen === 0x0f) {
        const settingByte = this.hexToInt(str.substring(18, 20));
        obj = {
          regular_time_interval: this.hexToInt(str.substring(12, 14)),
          survival_time_interval: this.hexToInt(str.substring(14, 16)),
          sensorType: this.hexToInt(str.substring(16, 18)),
          disabledSensor: settingByte & 1,
          hasIR: (settingByte >> 1) & 1,
          disabledLux: (settingByte >> 2) & 1,
          disabledMotion: (settingByte >> 3) & 1,
          motion_off_delay: this.hexToInt(str.substring(20, 24)),
          gang: this.hexToInt(str.substring(24, 26)),
          motion_off_delay2: this.hexToInt(str.substring(26, 30)),
          sensorDist: this.hexToInt(str.substring(30, 32)),
          gwChecksum: this.hexToInt(str.substring(32, 34)),
          ver: 1,
        };
      }
      return obj;
    } else if (port.toUpperCase() === "9C") {
      const settingType = this.hexToInt(str.substring(12, 14));
      const data1 = this.hexToInt(str.substring(14, 16));
      const data2 = this.hexToInt(str.substring(16, 18));
      const data3 = this.hexToInt(str.substring(18, 20));
      const val = (data2 << 8) + data3;
      const settingTypeField = this.sensorSettingFieldOf(settingType);
      const obj = {
        port,
        zigbeeAdd,
        settingType,
        data1,
        data2,
        data3,
        [settingTypeField]: val,
      };
      return obj;
    } else if (port.toUpperCase() === "9D") {
      const settingType = this.hexToInt(str.substring(12, 14));
      let obj = { port, zigbeeAdd, settingType };
      return obj;
    } else if (port.toUpperCase() === "9E") {
      const obj = {
        port,
        zigbeeAdd,
        regular_time_interval: this.hexToInt(str.substring(12, 14)),
        survival_time_interval: this.hexToInt(str.substring(14, 16)),
        survival_timeout: this.hexToInt(str.substring(16, 18)),
        enable_delayed_action: this.hexToInt(str.substring(18, 20)),
        motion_off_delay: this.hexToInt(str.substring(20, 24)),
        enable_delayed_action2: this.hexToInt(str.substring(24, 26)),
        motion_off_delay2: this.hexToInt(str.substring(26, 30)),
        sensorDist: this.hexToInt(str.substring(30, 32)),
      };
      return obj;
    } else if (port.toUpperCase() === "C0") {
      const commandMode = this.hexToInt(str.substring(12, 14));
      let obj = { port, zigbeeAdd, commandMode };
      switch (commandMode) {
        case 2: {
          obj = {
            ...obj,
            commandName: "currentZbChannel",
            zbChannel: this.hexToInt(str.substring(14, 16)),
          };
          break;
        }
        case 3: {
          obj = {
            ...obj,
            commandName: "currentGateway",
            gatewayAdd1: this.hexToInt(str.substring(14, 16)),
            gatewayAdd2: this.hexToInt(str.substring(16, 18)),
          };
          break;
        }
        case 4: {
          obj = {
            ...obj,
            commandName: "receivedSetting",
            receivedSetting: this.hexToInt(str.substring(14, 16)),
          };
          break;
        }
        case 5: {
          obj = {
            ...obj,
            commandName: "wifiOnOff",
            wifiOnOff: this.hexToInt(str.substring(14, 16)),
          };
          break;
        }
        case 6: {
          obj = {
            ...obj,
            commandName: "acknowledgeGeneralCommand",
            ackPort: this.hexToInt(str.substring(14, 16)),
          };
          break;
        }
        case 7: {
          let otaSsid = "";
          for (let i = 7; i < byteLength - 1; i++) {
            const b = this.hexToInt(str.substring(i * 2, i * 2 + 2));
            const c = String.fromCharCode(b);
            otaSsid += c;
          }
          obj = { ...obj, commandName: "reportOtaSsid", otaSsid };
          break;
        }
        case 8: {
          let otaPassword = "";
          for (let i = 7; i < byteLength - 1; i++) {
            const b = this.hexToInt(str.substring(i * 2, i * 2 + 2));
            const c = String.fromCharCode(b);
            otaPassword += c;
          }
          obj = { ...obj, commandName: "reportOtaPassword", otaPassword };
          break;
        }
        case 9: {
          obj = {
            ...obj,
            commandName: "requestResend",
            portStr: str.substring(14, 16),
          };
          break;
        }
        default: {
          break;
        }
      }
      return obj;
    } else if (port.toUpperCase() === "E0") {
      const newGateway = str.substring(12, 14);
      let obj = { newGateway };
      return obj;
    } else if (port.toUpperCase() === "E1") {
      const data1 = str.substring(12, 14);
      return { data1 };
    } else if (port.toUpperCase() === "E2") {
      const wifiStatus = str.substring(12, 14); //"03":OFF, "09":ON
      const wifi = wifiStatus === "03" ? "OFF" : "ON";
      let obj = { wifi };
      return obj;
    } else if (port.toUpperCase() === "EE") {
      const commandMode = this.hexToInt(str.substring(12, 14));
      let obj = { port, zigbeeAdd, commandMode };
      switch (commandMode) {
        case 2: {
          obj = {
            ...obj,
            commandName: "deviceRestart",
          };
          break;
        }
        case 3: {
          const wifiStatus = str.substring(14, 16); //"03":OFF, "09":ON
          obj = {
            ...obj,
            wifiOnOff:
              wifiStatus === "09"
                ? "OFF"
                : wifiStatus === "03"
                  ? "ON"
                  : "UNKNOWN",
            commandName: "wifiOnOff",
          };
          break;
        }
        case 4: {
          obj = {
            ...obj,
            commandName: "restartZbModule",
          };
          break;
        }
        case 5: {
          obj = {
            ...obj,
            commandName: "changeZbChannel",
          };
          break;
        }
        case 6: {
          obj = {
            ...obj,
            newZbAdd1: this.hexToInt(str.substring(14, 16)),
            newZbAdd2: this.hexToInt(str.substring(16, 18)),
            commandName: "changeZbAdd",
          };
          break;
        }
        case 7: {
          obj = {
            ...obj,
            commandName: "disconnectGateway",
          };
          break;
        }
        case 8: {
          obj = {
            ...obj,
            commandName: "updateFirmware",
          };
          break;
        }
        case 9: {
          obj = { ...obj, commandName: "queryCurrentZbChannel" };
          break;
        }
        case 0x0a: {
          obj = { ...obj, commandName: "queryCurrentGateway" };
          break;
        }
        case 0x0b: {
          obj = { ...obj, commandName: "queryWifiOnOff" };
          break;
        }
        case 0x0c: {
          obj = { ...obj, commandName: "queryReceivedSetting" };
          break;
        }
        case 0x0d: {
          let otaSsid = "";
          for (let i = 7; i < byteLength - 1; i++) {
            const b = this.hexToInt(str.substring(i * 2, i * 2 + 2));
            const c = String.fromCharCode(b);
            otaSsid += c;
          }
          obj = { ...obj, commandName: "setOtaSsid", otaSsid };
          break;
        }
        case 0x0e: {
          let otaPassword = "";
          for (let i = 7; i < byteLength - 1; i++) {
            const b = this.hexToInt(str.substring(i * 2, i * 2 + 2));
            const c = String.fromCharCode(b);
            otaPassword += c;
          }
          obj = { ...obj, commandName: "setOtaPassword", otaPassword };
          break;
        }
        case 0x0f: {
          obj = { ...obj, commandName: "queryOtaSsid" };
          break;
        }
        case 0x10: {
          obj = { ...obj, commandName: "queryOtaPassword" };
          break;
        }
        case 0x11: {
          obj = {
            ...obj,
            commandName: "redirectZb",
            targetAddH: this.hexToInt(str.substring(14, 16)),
            targetAddL: this.hexToInt(str.substring(16, 18)),
            targetPort: this.hexToInt(str.substring(18, 20)),
          };
          let dataArray = [];
          for (let i = 10; i < byteLength - 1; i++) {
            dataArray[i] = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          }
          obj.push(dataArray);
          break;
        }
        case 0x12: {
          obj = { ...obj, portStr: str.substring(14, 16) };
          break;
        }
      }
      return obj;
    } else if (port.toUpperCase() === "BB") {
      const commandMode = this.hexToInt(str.substring(12, 14));
      let obj = { port, zigbeeAdd, commandMode };
      if (commandMode === 2) {
        //send setting
        obj = {
          ...obj,
          survival_time_interval: this.hexToInt(str.substring(14, 16)),
          regular_time_interval: this.hexToInt(str.substring(16, 18)),
          gwChecksum: this.hexToInt(str.substring(18, 20)),
          commandName: "daliCtlSendSetting",
        };
      } else if (commandMode === 3) {
        obj = {
          ...obj,
          commandName: "daliInitialise",
        };
      } else if (commandMode === 4) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          daliCmd: this.hexToInt(str.substring(16, 18)),
          commandName: "daliQueryGeneral",
        };
      } else if (commandMode === 5) {
        obj = {
          ...obj,
          commandName: "scanShortAdd",
        };
      } else if (commandMode === 6) {
        obj = {
          ...obj,
          currentAdd: this.hexToInt(str.substring(14, 16)),
          newAdd: this.hexToInt(str.substring(16, 18)),
          commandName: "changeShortAdd",
        };
      } else if (commandMode === 7) {
        obj = {
          ...obj,
          arcLv: this.hexToInt(str.substring(14, 16)),
          commandName: "broadcastLight",
        };
      } else if (commandMode === 8) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          times: this.hexToInt(str.substring(16, 18)),
          commandName: "flashLight",
        };
      } else if (commandMode === 9) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          pwm: this.hexToInt(str.substring(16, 18)),
          lockLevel: this.hexToInt(str.substring(18, 20)),
          delayedPwm: this.hexToInt(str.substring(20, 22)),
          delayed_action: this.hexToInt(str.substring(22, 26)),
          delayedPwm2: this.hexToInt(str.substring(26, 28)),
          delayed_action2: this.hexToInt(str.substring(28, 32)),
          releaseOnDelayEnd: this.hexToInt(str.substring(32, 34)),
          commandName: "controlSingleLight",
        };
      } else if (commandMode === 0x0a) {
        //store fade time
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          fadeTime: this.hexToInt(str.substring(16, 18)),
          commandName: "storeFadeTime",
        };
      } else if (commandMode === 0x0b) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          memoryAdd: this.hexToInt(str.substring(16, 18)),
          value: this.hexToInt(str.substring(18, 20)),
          commandName: "writeMemoryBank",
        };
      } else if (commandMode === 0x0c) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          memoryAdd: this.hexToInt(str.substring(16, 18)),
          commandName: "queryMemoryBank",
        };
      } else if (commandMode === 0x0d) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          lockLevel: this.hexToInt(str.substring(16, 18)),
          commandName: "changeLockLevel",
        };
      } else if (commandMode === 0x0e) {
        obj = {
          ...obj,
          commandName: "queryLockLevelAll",
        };
      } else if (commandMode === 0x0f) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          commandName: "queryLockLevel",
        };
      } else if (commandMode === 0x10) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          commandName: "queryFadeTime",
        };
      } else if (commandMode === 0x11) {
        obj = {
          ...obj,
          commandName: "cancelScanShortAdd",
        };
      } else if (commandMode === 0x12) {
        obj = {
          ...obj,
          commandName: "queryAllLightLv",
        };
      } else if (commandMode === 0x13) {
        obj = {
          ...obj,
          commandName: "daliReset",
          shortAdd: this.hexToInt(str.substring(14, 16)),
        };
      } else if (commandMode === 0x14) {
        obj = {
          ...obj,
          commandName: "releaseLockLevelAll",
        };
      } else if (commandMode === 0x15) {
        obj = {
          ...obj,
          commandName: "changeMinLv",
          shortAdd: this.hexToInt(str.substring(14, 16)),
          minLv: this.hexToInt(str.substring(16, 18)),
        };
      } else if (commandMode === 0x16) {
        obj = {
          ...obj,
          commandName: "changeMaxLv",
          shortAdd: this.hexToInt(str.substring(14, 16)),
          maxLv: this.hexToInt(str.substring(16, 18)),
        };
      } else if (commandMode === 0x17) {
        obj = {
          ...obj,
          commandName: "queryMinLv",
          shortAdd: this.hexToInt(str.substring(14, 16)),
        };
      } else if (commandMode === 0x18) {
        obj = {
          ...obj,
          commandName: "queryMaxLv",
          shortAdd: this.hexToInt(str.substring(14, 16)),
        };
      } else if (commandMode === 0x19) {
        obj = {
          ...obj,
          commandName: "addToGroup",
          shortAdd: this.hexToInt(str.substring(14, 16)),
          groupNo: this.hexToInt(str.substring(16, 18)),
        };
      } else if (commandMode === 0x1a) {
        obj = {
          ...obj,
          commandName: "removeFromGroup",
          shortAdd: this.hexToInt(str.substring(14, 16)),
          groupNo: this.hexToInt(str.substring(16, 18)),
        };
      } else if (commandMode === 0x1b) {
        obj = { ...obj, commandName: "removeAllLights" };
      } else if (commandMode === 0x1c) {
        obj = {
          ...obj,
          commandName: "removeOneLight",
          shortAdd: this.hexToInt(str.substring(14, 16)),
        };
      } else if (commandMode === 0x1d) {
        let lightLvArr = [];
        for (let i = 0; i < 16; i++) {
          lightLvArr[i] = this.hexToInt(
            str.substring((i + 9) * 2, (i + 9) * 2 + 2)
          );
        }
        obj = {
          ...obj,
          commandName: "controlMultiLight_noDelay",
          lockLevel: this.hexToInt(str.substring(14, 16)),
          releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
          lightLvArr,
        };
      } else if (commandMode === 0x1f) {
        let lightLvArr = [],
          lightLvArrDelay = [];
        for (let i = 0; i < 16; i++) {
          lightLvArr[i] = this.hexToInt(
            str.substring((i + 11) * 2, (i + 11) * 2 + 2)
          );
          lightLvArrDelay[i] = this.hexToInt(
            str.substring((i + 27) * 2, (i + 27) * 2 + 2)
          );
        }
        obj = {
          ...obj,
          commandName: "controlMultiLight_1Delay",
          lockLevel: this.hexToInt(str.substring(14, 16)),
          releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
          delayed_action: this.hexToInt(str.substring(18, 22)),
          lightLvArr,
          lightLvArrDelay,
        };
      } else if (commandMode === 0x22) {
        let lightLvArr = [],
          lightLvArrDelay = [],
          lightLvArrDelay2 = [];
        for (let i = 0; i < 16; i++) {
          lightLvArr[i] = this.hexToInt(
            str.substring((i + 13) * 2, (i + 13) * 2 + 2)
          );
          lightLvArrDelay[i] = this.hexToInt(
            str.substring((i + 29) * 2, (i + 29) * 2 + 2)
          );
          lightLvArrDelay2[i] = this.hexToInt(
            str.substring((i + 45) * 2, (i + 45) * 2 + 2)
          );
        }
        obj = {
          ...obj,
          commandName: "controlMultiLight_2Delay",
          lockLevel: this.hexToInt(str.substring(14, 16)),
          releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
          delayed_action: this.hexToInt(str.substring(18, 22)),
          delayed_action2: this.hexToInt(str.substring(22, 26)),
          lightLvArr,
          lightLvArrDelay,
          lightLvArrDelay2,
        };
      } else if (commandMode === 0x27) {
        let lightLvArrDelay = [];
        for (let i = 0; i < 16; i++) {
          lightLvArrDelay[i] = this.hexToInt(
            str.substring((i + 11) * 2, (i + 11) * 2 + 2)
          );
        }
        obj = {
          ...obj,
          commandName: "controlMultiLight_delayOnly",
          lockLevel: this.hexToInt(str.substring(14, 16)),
          releaseOnDelayEnd: this.hexToInt(str.substring(16, 18)),
          delayed_action: this.hexToInt(str.substring(18, 22)),
          lightLvArrDelay,
        };
      } else if (commandMode === 0x29) {
        obj = {
          ...obj,
          commandName: "controlSingleLight_pwmOnly",
          shortAdd: this.hexToInt(str.substring(14, 16)),
          pwm: this.hexToInt(str.substring(16, 18)),
          releaseOnDelayEnd: this.hexToInt(str.substring(18, 20)),
        };
      } else if (commandMode === 0x2a) {
        obj = {
          ...obj,
          commandName: "controlSingleLight_delayOnly",
          shortAdd: this.hexToInt(str.substring(14, 16)),
          delayedPwm: this.hexToInt(str.substring(16, 18)),
          delaySec: this.hexToInt(str.substring(18, 22)),
          lockLevel: this.hexToInt(str.substring(22, 24)),
          releaseOnDelayEnd: this.hexToInt(str.substring(24, 26)),
        };
      } else if (commandMode === 0x2b) {
        obj = {
          ...obj,
          commandName: "queryLightLv",
          shortAdd: this.hexToInt(str.substring(14, 16)),
        };
      } else if (commandMode === 0x2c) {
        obj = {
          ...obj,
          commandName: "queryBypass",
        };
      } else if (commandMode === 0x2d) {
        obj = {
          ...obj,
          commandName: "acknowledgeReport",
          reportCode: this.hexToInt(str.substring(14, 16)),
        };
      }
      return obj;
    } else if (port.toUpperCase() === "B0") {
      const commandMode = this.hexToInt(str.substring(12, 14));
      let obj = {
        port,
        zigbeeAdd,
        commandMode,
      };
      if (commandMode === 2) {
        const majorVer = this.hexToInt(str.substring(14, 16));
        const minorVer = this.hexToInt(str.substring(16, 18));
        const minorVerStr = minorVer < 10 ? `0${minorVer}` : minorVer;
        obj = {
          ...obj,
          commandName: "requestGatewaySetting",
          version: `${majorVer}.${minorVerStr}`,
        };
      } else if (commandMode === 3) {
        let addList = [];
        for (let i = 7; i < 23; i++) {
          let add = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          if (isNaN(add) || add === null || add < 0 || add > 63) add = 99;
          addList[i - 7] = add;
        }
        obj = { ...obj, addList, commandName: "reportShortAddList" };
      } else if (commandMode === 4) {
        const shortAdd = this.hexToInt(str.substring(14, 16));
        const daliCmd = this.hexToInt(str.substring(16, 18));
        const reply = this.hexToInt(str.substring(18, 20));
        obj = {
          ...obj,
          shortAdd,
          daliCmd,
          reply,
          commandName: "replyGenerayQuery",
        };
      } else if (commandMode === 5) {
        //device start
        const ip1 = this.hexToInt(str.substring(18, 20));
        const ip2 = this.hexToInt(str.substring(20, 22));
        const ip3 = this.hexToInt(str.substring(22, 24));
        const ip4 = this.hexToInt(str.substring(24, 26));
        let ip = `${ip1}.${ip2}.${ip3}.${ip4}`;
        // const version =
        //   String.fromCharCode(this.hexToInt(str.substring(14, 16))) +
        //   String.fromCharCode(this.hexToInt(str.substring(16, 18))) +
        //   String.fromCharCode(this.hexToInt(str.substring(18, 20))) +
        //   String.fromCharCode(this.hexToInt(str.substring(20, 22)));
        const majorVer = this.hexToInt(str.substring(14, 16));
        const minorVer = this.hexToInt(str.substring(16, 18));
        const minorVerStr = minorVer < 10 ? `0${minorVer}` : minorVer;
        const ipArray = [ip1, ip2, ip3, ip4];
        obj = {
          ...obj,
          version: `${majorVer}.${minorVerStr}`,
          ip,
          ipArray,
          zbChannel: this.hexToInt(str.substring(26, 28)),
          commandName: "daliCtlStart",
        };
      } else if (commandMode === 6) {
        obj = { ...obj, commandName: "daliCtlSurvival" };
      } else if (commandMode === 7) {
        //acknowledge light action
        const shortAdd = this.hexToInt(str.substring(14, 16));
        const lightLv = this.hexToInt(str.substring(16, 18));
        const lockLevel = this.hexToInt(str.substring(18, 20));
        obj = {
          ...obj,
          shortAdd,
          lightLv,
          lockLevel,
          commandName: "acknowledgeLightAction",
        };
      } else if (commandMode === 8) {
        const replyCommandMode = str.substring(14, 16);
        obj = {
          ...obj,
          replyCommandMode,
          commandName: "acknowledgeGeneral",
        };
      } else if (commandMode === 9) {
        let lightLvList = [];
        for (let i = 7; i < 23; i++) {
          let lv = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          if (isNaN(lv) || lv === null || lv < 0) lv = 0;
          lightLvList[i - 7] = lv;
        }
        obj = { ...obj, lightLvList, commandName: "reportLightStatus" };
      } else if (commandMode === 0x0a) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          fadeTime: this.hexToInt(str.substring(16, 18)),
          commandName: "reportFadeTime",
        };
      } else if (commandMode === 0x0b) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          memoryAdd: this.hexToInt(str.substring(16, 18)),
          value: this.hexToInt(str.substring(18, 20)),
          commandName: "replyMemoryBank",
        };
      } else if (commandMode === 0x0c) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          lockLevel: this.hexToInt(str.substring(16, 18)),
          commandName: "reportLockLevel",
        };
      } else if (commandMode === 0x0d) {
        let lvList = [];
        for (let i = 7; i < 23; i++) {
          let lv = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          if (isNaN(lv) || lv === null || lv < 0) lv = 0;
          lvList[i - 7] = lv;
        }
        obj = { ...obj, lockLvList: lvList, commandName: "reportLockLevelAll" };
      } else if (commandMode === 0x0e) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          instance: this.hexToInt(str.substring(16, 18)),
          value: this.hexToInt(str.substring(18, 20)),
          commandName: "reportSensorAction",
        };
      } else if (commandMode === 0x0f) {
        obj = { ...obj, commandName: "scanFinish" };
      } else if (commandMode === 0x10) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          status: this.hexToInt(str.substring(16, 18)),
          commandName: "reportLightSurvival",
        };
      } else if (commandMode === 0x1a) {
        let lvList = [];
        for (let i = 7; i < 23; i++) {
          let lv = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          if (isNaN(lv) || lv === null || lv < 0) lv = 0;
          lvList[i - 7] = lv;
        }
        obj = {
          ...obj,
          commandName: "reportMinLvAll",
          minLvList: lvList,
        };
      } else if (commandMode === 0x1b) {
        let lvList = [];
        for (let i = 7; i < 23; i++) {
          let lv = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          if (isNaN(lv) || lv === null || lv < 0) lv = 0;
          lvList[i - 7] = lv;
        }
        obj = {
          ...obj,
          commandName: "reportMinLvAll",
          maxLvList: lvList,
        };
      } else if (commandMode === 0x1c) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          minLv: this.hexToInt(str.substring(16, 18)),
          commandName: "reportMinLv",
        };
      } else if (commandMode === 0x1d) {
        obj = {
          ...obj,
          shortAdd: this.hexToInt(str.substring(14, 16)),
          maxLv: this.hexToInt(str.substring(16, 18)),
          commandName: "reportMaxLv",
        };
      } else if (commandMode === 0x1f) {
        let addList = [];
        for (let i = 7; i < 23; i++) {
          let add = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          if (add === 0xff) break;
          if (isNaN(add) || add === null || add < 0 || add > 63) add = 99;
          addList[i - 7] = add;
        }
        obj = { ...obj, addList, commandName: "reportConnectedLights" };
      } else if (commandMode === 0x20) {
        let addList = [];
        for (let i = 7; i < 23; i++) {
          let add = this.hexToInt(str.substring(i * 2, i * 2 + 2));
          if (add === 0xff) break;
          if (isNaN(add) || add === null || add < 0 || add > 63) add = 99;
          addList[i - 7] = add;
        }
        obj = { ...obj, addList, commandName: "reportDisconnectedLights" };
      } else if (commandMode === 0x21) {
        obj = {
          ...obj,
          commandName: "reportBypassDetected",
          bypass: this.hexToInt(str.substring(14, 16)),
        };
      } else if (commandMode === 0x22) {
        obj = {
          ...obj,
          commandName: "requestNextPartCommand",
          requestPartNo: this.hexToInt(str.substring(14, 16)),
        };
      }
      return obj;
    } else {
      console.log(`zbStrToJson - Unrecognized port: ${port} ${port2}`);
      const obj = {
        port,
        zigbeeAdd: zigbeeAdd || "ZZZZ",
      };
      return obj;
    }
  }
  gwCommandToZb(cmd) {
    const { controlMode, type } = cmd || {};
    const zigbeeAdd = cmd.zigbeeAdd || "ZZZZ";
    if (controlMode) {
      if (controlMode?.toUpperCase() === "AA") {
        let str = `fe05aaaa${zigbeeAdd}00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "AB") {
        let str = "";
        if (!cmd.ver || cmd.ver === 0) {
          str = `fe11abab${zigbeeAdd}`;
          str += this.intToHexStr(cmd.typeA);
          str += this.intToHexStr(cmd.typeL);
          str += this.intToHexStr(cmd.typeBatVI);
          str += this.intToHexStr(cmd.typePwm);
          str += this.intToHexStr(cmd.dimTransition);
          str += this.intToHexStr(cmd.dimTransitON);
          str += this.intToHexStr(cmd.dimTransitOFF);
          str += this.intToHexStr(cmd.cutDimOnBypass);
          str += this.intToHexStr(cmd.reverseA);
          str += this.intToHexStr(cmd.survival_time_interval);
          str += this.intToHexStr(cmd.survival_timeout);
          str += this.intToHexStr(cmd.regular_time_interval);
          str += this.intToHexStr(cmd.lockLevel);
          str += "ff";
        } else if (cmd.ver === 1) {
          let typeByte =
            (cmd.typePwm << 3) |
            (cmd.typeBatVI << 2) |
            (cmd.typeL << 1) |
            cmd.typeA;
          const operateByte =
            (cmd.enableMotion << 2) | (cmd.cutDimOnBypass << 1) | cmd.reverseA;
          const gwHstr = cmd.gatewayAdd.substring(0, 2);
          const gwLstr = cmd.gatewayAdd.substring(2, 4);
          const gwH = this.hexToInt(gwHstr);
          const gwL = this.hexToInt(gwLstr);
          const gwChecksum = (gwH + gwL) & 0xff;
          str = `fe0cabab${zigbeeAdd}`;
          str += this.intToHexStr(typeByte);
          str += this.intToHexStr(operateByte);
          str += this.intToHexStr(cmd.dimTransition);
          str += this.intToHexStr(cmd.dimTransitON);
          str += this.intToHexStr(cmd.dimTransitOFF);
          str += this.intToHexStr(cmd.survival_time_interval);
          str += this.intToHexStr(cmd.regular_time_interval);
          str += this.intToHexStr(gwChecksum);
          str += "ff";
        }
        return str;
      } else if (controlMode?.toUpperCase() === "A0") {
        let str = `fe05a0a0${zigbeeAdd}00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "A1") {
        let str = `fe05a1a1fefdfefd00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "A2") {
        let str = `feXXa2a2${zigbeeAdd}`;
        str += this.intToHexStr(cmd.commandMode);
        switch (cmd.commandMode) {
          case 8: {
            //flashCtlA
            str += this.intToHexStr(cmd.flashTimes);
            str += "ff";
            const dataLen = str.length / 2 - 3;
            str = str.replace("XX", this.intToHexStr(dataLen));
            break;
          }
          case 9: {
            //lightAction
            str += this.intToHexStr(cmd.lockLevel);
            str += this.intToHexStr(cmd.releaseOnDelayEnd);
            str += this.intToHexStr(cmd.pwm);
            str += "ff";
            const dataLen = str.length / 2 - 3;
            str = str.replace("XX", this.intToHexStr(dataLen));
            break;
          }
          case 0x0a: {
            //delayedLightAction
            str += this.intToHexStr(cmd.lockLevel);
            str += this.intToHexStr(cmd.releaseOnDelayEnd);
            str += this.intToHexStr(cmd.delaySec, 2);
            str += this.intToHexStr(cmd.delayedPwm);
            str += "ff";
            const dataLen = str.length / 2 - 3;
            str = str.replace("XX", this.intToHexStr(dataLen));
            break;
          }
          case 0x0b: {
            //delayedLightAction2
            str += this.intToHexStr(cmd.lockLevel);
            str += this.intToHexStr(cmd.releaseOnDelayEnd);
            str += this.intToHexStr(cmd.delaySec, 2);
            str += this.intToHexStr(cmd.delayedPwm);
            str += this.intToHexStr(cmd.delaySec2, 2);
            str += this.intToHexStr(cmd.delayedPwm2);
            str += "ff";
            const dataLen = str.length / 2 - 3;
            str = str.replace("XX", this.intToHexStr(dataLen));
            break;
          }
          case 0x0c: {
            //reverseSwitch
            str += this.intToHexStr(cmd.lockLevel);
            str += this.intToHexStr(cmd.releaseOnDelayEnd);
            str += "ff";
            const dataLen = str.length / 2 - 3;
            str = str.replace("XX", this.intToHexStr(dataLen));
            break;
          }
        }
        return str;
      } else if (controlMode?.toUpperCase() === "A3") {
        let strA3 = "";
        if (!cmd.ver || cmd.ver === 0) {
          strA3 = `fe09a3a3${zigbeeAdd}00000000`;
          strA3 += this.intToHexStr(cmd.onoffcontrolL);
          strA3 += "ff";
        } else if (cmd.ver === 1) {
          strA3 = `fe05a3a3${zigbeeAdd}`;
          strA3 += this.intToHexStr(cmd.onoffcontrolL);
          strA3 += "ff";
        }
        return strA3;
      } else if (controlMode?.toUpperCase() === "A4") {
        let strA4 = "";
        if (!cmd.ver || cmd.ver === 0) {
          strA4 += `fe15a4a4${zigbeeAdd}000000`;
          strA4 += this.intToHexStr(cmd.lockLevel);
          strA4 += this.intToHexStr(cmd.onoffcontrolA);
          strA4 += this.intToHexStr(cmd.pwm);
          strA4 += this.intToHexStr(cmd.enable_delayed_action);
          strA4 += this.intToHexStr(cmd.delayedOnOff);
          strA4 += this.intToHexStr(cmd.delayedPwm);
          strA4 += this.intToHexStr(cmd.delayed_action, 2);
          strA4 += this.intToHexStr(cmd.lockLevel);
          strA4 += this.intToHexStr(cmd.enable_delayed_action2);
          strA4 += this.intToHexStr(cmd.delayedOnOff2);
          strA4 += this.intToHexStr(cmd.delayedPwm2);
          strA4 += this.intToHexStr(cmd.delayed_action2, 2);
          strA4 += "ff";
          // fe 15 a4 a4 30 5d 00 00 00 64 00 50 01 01 0a 00 00 64 00 01 0a 00 00 ff;
          //                            lo  A pw en df dp da da lo en df dp da da
        } else if (cmd.ver === 1) {
          const releaseOnDelayEnd = cmd.releaseOnDelayEnd || 0;
          const onOff =
            cmd.onoffcontrolA +
            (cmd.delayedOnOff << 1) +
            (cmd.delayedOnOff2 << 2) +
            (releaseOnDelayEnd << 3);
          strA4 += `fe0ea4a4${zigbeeAdd}`;
          strA4 += this.intToHexStr(cmd.subLightAdd);
          strA4 += this.intToHexStr(cmd.lockLevel);
          strA4 += this.intToHexStr(onOff);
          strA4 += this.intToHexStr(cmd.pwm);
          strA4 += this.intToHexStr(cmd.delayedPwm);
          strA4 += this.intToHexStr(cmd.delayed_action, 2);
          strA4 += this.intToHexStr(cmd.delayedPwm2);
          strA4 += this.intToHexStr(cmd.delayed_action2, 2);
          strA4 += "ff";
        }
        return strA4;
      } else if (controlMode?.toUpperCase() === "A5") {
        const {
          time_pretest,
          time_cutOff,
          time_recharge,
          time_interval,
          minI,
          minV,
          reportID,
          ver,
        } = cmd;
        const minI100 = Number(minI) * 100;
        const minV100 = Number(minV) * 100;
        const reportID_hex = reportID.split("_")[1];
        if (!ver || ver === 0) {
          let str = `fe14a5a5${zigbeeAdd}00000000`;
          str += this.intToHexStr(time_pretest);
          str += this.intToHexStr(time_cutOff);
          str += this.intToHexStr(time_recharge);
          str += this.intToHexStr(time_interval);
          str += this.intToHexStr(minV100, 2);
          str += this.intToHexStr(minI100, 2);
          str += reportID_hex;
          str += "ff";
          return str;
        } else if (ver === 1) {
          let str = `feXXa5a5${zigbeeAdd}`;
          str += this.intToHexStr(time_pretest);
          str += this.intToHexStr(time_cutOff);
          str += this.intToHexStr(time_recharge);
          str += this.intToHexStr(time_interval);
          str += this.intToHexStr(minV100, 2);
          str += this.intToHexStr(minI100, 2);
          str += reportID_hex;
          str += "ff";
          const dataLen = str.length / 2 - 3; //dataLen = 0x10
          str = str.replace("XX", this.intToHexStr(dataLen));
          return str;
        }
      } else if (controlMode?.toUpperCase() === "A6") {
        let str = `fe05a6a6${zigbeeAdd}00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "A7") {
        let str = `fe05a7a7${zigbeeAdd}00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "AC") {
        const { settingType, data1, data2 } = cmd;
        let str = `fe07acac${zigbeeAdd}`;
        str += this.intToHexStr(settingType);
        str += this.intToHexStr(data1);
        str += this.intToHexStr(data2);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "AD") {
        const { settingType } = cmd;
        let str = `fe05adad${zigbeeAdd}`;
        str += this.intToHexStr(settingType);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "AE") {
        let str = `fe11aeae${zigbeeAdd}`;
        str += this.intToHexStr(cmd.typeA);
        str += this.intToHexStr(cmd.typeL);
        str += this.intToHexStr(cmd.typeBatVI);
        str += this.intToHexStr(cmd.typePwm);
        str += this.intToHexStr(cmd.dimTransition);
        str += this.intToHexStr(cmd.dimTransitON);
        str += this.intToHexStr(cmd.dimTransitOFF);
        str += this.intToHexStr(cmd.cutDimOnBypass);
        str += this.intToHexStr(cmd.reverseA);
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.survival_timeout);
        str += this.intToHexStr(cmd.regular_time_interval);
        str += this.intToHexStr(cmd.lockLevel);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "90") {
        let str = `fe059090${zigbeeAdd}00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "91") {
        const { commandMode } = cmd;
        let str = `feXX9191${zigbeeAdd}`;
        str += this.intToHexStr(commandMode);
        switch (commandMode) {
          case 2: {
            //disableSensorWithDelay
            str += this.intToHexStr(cmd.delaySec, 2);
            break;
          }
          case 3: {
            //terminateDisableDelay
            break;
          }
          case 4: {
            //enableSensorWithDelay
            str += this.intToHexStr(cmd.delaySec, 2);
            break;
          }
          case 5: {
            //terminateEnableDelay
            break;
          }
          default:
            break;
        }
        str += "ff";
        const dataLen = str.length / 2 - 3;
        str = str.replace("XX", this.intToHexStr(dataLen));
        return str;
      } else if (controlMode?.toUpperCase() === "94") {
        let str = `fe069494${zigbeeAdd}`;
        str += this.intToHexStr(cmd.switchType);
        str += this.intToHexStr(cmd.onoffcontrol);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "96") {
        let str = `fe059696${zigbeeAdd}00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "9A") {
        let str = `fe059a9a${zigbeeAdd}00ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "9B") {
        let str = "";
        if (!cmd.ver || cmd.ver === 0) {
          str = `fe0e9b9b${zigbeeAdd}`;
          str += this.intToHexStr(cmd.regular_time_interval);
          str += this.intToHexStr(cmd.survival_time_interval);
          str += this.intToHexStr(cmd.survival_timeout);
          str += this.intToHexStr(cmd.enable_delayed_action);
          str += this.intToHexStr(cmd.motion_off_delay, 2);
          str += this.intToHexStr(cmd.enable_delayed_action2);
          str += this.intToHexStr(cmd.motion_off_delay2, 2);
          str += this.intToHexStr(cmd.sensorDist);
          str += "ff";
        } else if (cmd.ver === 1) {
          let settingByte =
            (cmd.disabledMotion << 3) |
            (cmd.disabledLux << 2) |
            (cmd.hasIR << 1) |
            cmd.disabledSensor;
          const gwHstr = cmd.gatewayAdd.substring(0, 2);
          const gwLstr = cmd.gatewayAdd.substring(2, 4);
          const gwH = this.hexToInt(gwHstr);
          const gwL = this.hexToInt(gwLstr);
          const gwChecksum = (gwH + gwL) & 0xff;
          str = `fe0f9b9b${zigbeeAdd}`;
          str += this.intToHexStr(cmd.regular_time_interval);
          str += this.intToHexStr(cmd.survival_time_interval);
          str += this.intToHexStr(cmd.sensorType);
          str += this.intToHexStr(settingByte);
          str += this.intToHexStr(cmd.motion_off_delay, 2);
          str += this.intToHexStr(cmd.gang);
          str += this.intToHexStr(cmd.motion_off_delay2, 2);
          str += this.intToHexStr(cmd.sensorDist);
          str += this.intToHexStr(gwChecksum);
          str += "ff";
        }
        return str;
      } else if (controlMode?.toUpperCase() === "9C") {
        const { settingType, settingVal } = cmd;
        let data1 = 0;
        const data2 = settingVal >> 8; //high byte
        const data3 = settingVal & 0xff; //low byte
        let str = `fe089c9c${zigbeeAdd}`;
        str += this.intToHexStr(settingType);
        str += this.intToHexStr(data1);
        str += this.intToHexStr(data2);
        str += this.intToHexStr(data3);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "9D") {
        const { settingType } = cmd;
        let str = `fe059d9d${zigbeeAdd}`;
        str += this.intToHexStr(settingType);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "9E") {
        let str = `fe0e9e9e`;
        str += zigbeeAdd;
        str += this.intToHexStr(cmd.regular_time_interval);
        str += this.intToHexStr(cmd.survival_time_interval);
        str += this.intToHexStr(cmd.survival_timeout);
        str += this.intToHexStr(cmd.enable_delayed_action);
        str += this.intToHexStr(cmd.motion_off_delay, 2);
        str += this.intToHexStr(cmd.enable_delayed_action2);
        str += this.intToHexStr(cmd.motion_off_delay2, 2);
        str += this.intToHexStr(cmd.sensorDist);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "E0") {
        const { newGateway } = cmd;
        const checkSum = this.hexToInt(newGateway.substring(2)) - 1;
        let str = `fe07e0e0${zigbeeAdd}`;
        str += newGateway;
        str += this.intToHexStr(checkSum);
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "E1") {
        const { data1 } = cmd;
        let str = `fe05e1e1${zigbeeAdd}`;
        str = str + data1 || "00";
        str += "ff";
        return str;
      } else if (controlMode?.toUpperCase() === "E2") {
        const { wifi } = cmd;
        const data = wifi === "ON" ? "09" : "03";
        let str = `fe05e2e2${zigbeeAdd}${data}ff`;
        return str;
      } else if (controlMode?.toUpperCase() === "EE") {
        const { commandMode } = cmd;
        let str = `feXXeeee${zigbeeAdd}`;
        str += this.intToHexStr(commandMode);
        if (commandMode === 2) {
          //deviceRestart
        } else if (commandMode === 3) {
          //wifiOnOff
          const wifiStatus = cmd.wifiOnOff === "OFF" ? "09" : "03";
          str += this.intToHexStr(wifiStatus);
        } else if (commandMode === 4) {
          //restartZbModule
        } else if (commandMode === 5) {
          //changeZbChannel
          str += this.intToHexStr(cmd.zbChannel);
        } else if (commandMode === 6) {
          //changeZbAdd
          str += cmd.newZbAdd;
        } else if (commandMode === 7) {
          //disconnectGateway
        } else if (commandMode === 8) {
          //updateFirmware
        } else if (commandMode === 9) {
          //queryCurrentZbChannel
        } else if (commandMode === 0x0a) {
          //queryCurrentGateway
        } else if (commandMode === 0x0b) {
          //queryWifiOnOff
        } else if (commandMode === 0x0c) {
          //queryReceivedSetting;
        } else if (commandMode === 0x0d) {
          const { otaSsid } = cmd;
          for (let i = 0; i < otaSsid.length; i++) {
            const code = otaSsid.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
        } else if (commandMode === 0x0e) {
          //setOtaPassword
          const { otaPassword } = cmd;
          for (let i = 0; i < otaPassword.length; i++) {
            const code = otaPassword.charCodeAt(i);
            const hex = code.toString(16);
            str += hex;
          }
        } else if (commandMode === 0x0f) {
          //query ota ssid
        } else if (commandMode === 0x10) {
          //query ota password
        } else if (commandMode === 0x11) {
          //redirectZb
          const { dataArray, targetAdd, targetPort } = cmd;
          //dataArray - zb command without FE, Len, add, port and FF
          str += this.intToHexStr(targetAdd, 2);
          str += this.intToHexStr(targetPort);
          for (let i = 0; i < dataArray.length; i++) {
            str += this.intToHexStr(dataArray[i]);
          }
        } else if (commandMode === 0x12) {
          //requestResendToGw
          const { portStr } = cmd;
          str += portStr;
        }
        str += "ff";
        const dataLen = str.length / 2 - 3;
        str = str.replace("XX", this.intToHexStr(dataLen));
        return str;
      } else if (controlMode?.toUpperCase() === "BB") {
        const { commandMode } = cmd;
        let str = `feXXbbbb${zigbeeAdd}`;
        str += this.intToHexStr(commandMode);
        if (commandMode === 2) {
          const gwHstr = cmd.gatewayAdd.substring(0, 2);
          const gwLstr = cmd.gatewayAdd.substring(2, 4);
          const gwH = this.hexToInt(gwHstr);
          const gwL = this.hexToInt(gwLstr);
          const gwChecksum = (gwH + gwL) & 0xff;
          //daliCtlSendSetting
          str += this.intToHexStr(cmd.survival_time_interval);
          str += this.intToHexStr(cmd.regular_time_interval);
          str += this.intToHexStr(gwChecksum);
        } else if (commandMode === 3) {
          //daliInitialise
          // nothing to add
        } else if (commandMode === 4) {
          //daliQueryGeneral
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.daliCmd);
        } else if (commandMode === 5) {
          //scanShortAdd
          // nothing to add
        } else if (commandMode === 6) {
          //changeShortAdd
          str += this.intToHexStr(cmd.currentAdd);
          str += this.intToHexStr(cmd.newAdd);
        } else if (commandMode === 7) {
          //broadcastLight
          str += this.intToHexStr(cmd.arcLv);
        } else if (commandMode === 8) {
          //flashLight
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.times);
        } else if (commandMode === 9) {
          //controlSingleLight
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.pwm);
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.delayedPwm);
          str += this.intToHexStr(cmd.delayed_action, 2);
          str += this.intToHexStr(cmd.delayedPwm2);
          str += this.intToHexStr(cmd.delayed_action2, 2);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
        } else if (commandMode === 0x0a) {
          //storeFadeTime
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.fadeTime);
        } else if (commandMode === 0x0b) {
          //writeMemoryBank
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.memoryAdd);
          str += this.intToHexStr(cmd.value);
        } else if (commandMode === 0x0c) {
          //queryMemoryBank
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.memoryAdd);
        } else if (commandMode === 0x0d) {
          //changeLockLevel
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.lockLevel);
        } else if (commandMode === 0x0e) {
          //queryLockLevelAll
          // nothing to add
        } else if (commandMode === 0x0f) {
          //queryLockLevel
          str += this.intToHexStr(cmd.shortAdd);
        } else if (commandMode === 0x10) {
          //queryFadeTime
          str += this.intToHexStr(cmd.shortAdd);
        } else if (commandMode === 0x11) {
          //cancelScanShortAdd
        } else if (commandMode === 0x12) {
          //queryAllLightLv
        } else if (commandMode === 0x13) {
          //daliReset
          str += this.intToHexStr(cmd.shortAdd);
        } else if (commandMode === 0x14) {
          // releaseLockLevelAll
        } else if (commandMode === 0x15) {
          //changeMinLv
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.minLv);
        } else if (commandMode === 0x16) {
          //changeMaxLv
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.maxLv);
        } else if (commandMode === 0x17) {
          //queryMinLv
          str += this.intToHexStr(cmd.shortAdd);
        } else if (commandMode === 0x18) {
          //queryMaxLv
          str += this.intToHexStr(cmd.shortAdd);
        } else if (commandMode === 0x19) {
          //addToGroup
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.groupNo);
        } else if (commandMode === 0x1a) {
          //removeFromGroup
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.groupNo);
        } else if (commandMode === 0x1b) {
          //removeAllLights
        } else if (commandMode === 0x1c) {
          //removeOneLight
          str += this.intToHexStr(cmd.shortAdd);
        } else if (commandMode === 0x1d) {
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
          for (let i = 0; i < 16; i++) {
            str += this.intToHexStr(cmd.lightLvArr[i]);
          }
        } else if (commandMode === 0x1f) {
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
          str += this.intToHexStr(cmd.delayed_action, 2);
          for (let i = 0; i < 16; i++) {
            str += this.intToHexStr(cmd.lightLvArr[i]);
          }
          for (let i = 0; i < 16; i++) {
            str += this.intToHexStr(cmd.lightLvArrDelay[i]);
          }
        } else if (commandMode === 0x22) {
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
          str += this.intToHexStr(cmd.delayed_action, 2);
          str += this.intToHexStr(cmd.delayed_action2, 2);
          for (let i = 0; i < 16; i++) {
            str += this.intToHexStr(cmd.lightLvArr[i]);
          }
          for (let i = 0; i < 16; i++) {
            str += this.intToHexStr(cmd.lightLvArrDelay[i]);
          }
          for (let i = 0; i < 16; i++) {
            str += this.intToHexStr(cmd.lightLvArrDelay2[i]);
          }
        } else if (commandMode === 0x27) {
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
          str += this.intToHexStr(cmd.delayed_action, 2);
          for (let i = 0; i < 16; i++) {
            str += this.intToHexStr(cmd.lightLvArrDelay[i]);
          }
        } else if (commandMode === 0x29) {
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.pwm);
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
        } else if (commandMode === 0x2a) {
          str += this.intToHexStr(cmd.shortAdd);
          str += this.intToHexStr(cmd.delayedPwm);
          str += this.intToHexStr(cmd.delaySec, 2);
          str += this.intToHexStr(cmd.lockLevel);
          str += this.intToHexStr(cmd.releaseOnDelayEnd);
        } else if (commandMode === 0x2b) {
          //queryLightLv
          str += this.intToHexStr(cmd.shortAdd);
        } else if (commandMode === 0x2c) {
          //queryBypass
        } else if (commandMode === 0x2d) {
          //acknowledgeReport
          str += this.intToHexStr(cmd.reportCode);
        }
        str += "ff";
        const dataLen = str.length / 2 - 3; //fe04bbbbed5bff
        str = str.replace("XX", this.intToHexStr(dataLen));
        return str;
      } else {
        return "";
      }
    } else if (type === "restartZigbee") {
      return `fe059021000010ff`;
    } else {
      return "";
    }
  }
}

module.exports = General;
